// Auto Generated, Don't Modify Manually
import * as decoders from 'decoders'
import * as Sentry from '@sentry/react'
import * as base from './base'
import { ArrayObjectDecoder } from './base'
import { DataDecoder } from './base'
import { ErrorMessage } from './base'
import { baseURL } from './base'
import { identity } from '../helpers/fns'
import { queryToString } from '../helpers/fns'
import { toFormData } from '../helpers/fns'

import { IDString } from './types'
import { LanguageString } from './types'
import { MessageObject } from './types'
import { SuccessResponse } from './types'
import { AuthObject } from './types'
import { GrantType } from './types'
import { Program } from './types'
import { Faculty } from './types'
import { ResumeTab } from './types'
import { MediaFile } from './types'
import { DownloadMediaFile } from './types'
import { GeneralSettings } from './types'
import { NotificationsData } from './types'
import { NotificationSettings } from './types'
import { ExportFile } from './types'
import { AuthUser } from './types'
import { Semester } from './types'
import { ChooseCriteria } from './types'
import { AdministratorRegime } from './types'
import { MessageUnreadCount } from './types'
import { FinalScore } from './types'
import { Course } from './types'
import { CoursePaperCriteria } from './types'
import { SavePaperCriteria } from './types'
import { ScoreEvaluation } from './types'
import { Paper } from './types'
import { Group } from './types'
import { GroupSchedule } from './types'
import { Choice } from './types'
import { LibraryBook } from './types'
import { LibraryBooksTaken } from './types'
import { BillingSchedule } from './types'
import { BillingDeposit } from './types'
import { BillingBalance } from './types'
import { PaymentInstruction } from './types'
import { Pagination } from './types'
import { AuthLog } from './types'
import { User } from './types'
import { AdministratorUser } from './types'
import { JSONRecord } from './types'
import { AdministratorStudentChoicesPage } from './types'
import { AdministratorChoiceHistoryResource } from './types'
import { AdministratorChoiceCreateResponse } from './types'
import { AdministratorChoiceUpdateResource } from './types'
import { AdministratorStudentChoiceCoursesPage } from './types'
import { AdministratorChoiceDeleteResult } from './types'
import { AdministratorChoiceDiscardResult } from './types'
import { AdministratorChoiceProgramAssignmentResult } from './types'
import { AdministratorChoiceProgramAssignmentResetResult } from './types'
import { AdministratorStudentChoiceHistory3Page } from './types'
import { UserState } from './types'
import { Message } from './types'
import { ScheduleDay } from './types'
import { Card } from './types'
import { CalendarItem } from './types'
import { Statement } from './types'
import { StatementTemplate } from './types'
import { StatementTemplateView } from './types'
import { StatementTemplateRequest } from './types'
import { AdministratorStatement } from './types'
import { AdministratorStatementTemplate } from './types'
import { AdministratorListsStatementTemplate } from './types'
import { Rating } from './types'
import { CourseSyllabus } from './types'
import { CourseFile } from './types'
import { CoursePost } from './types'
import { NewsUnreadCount } from './types'
import { News } from './types'
import { PortfolioCompetency } from './types'
import { Section } from './types'
import { StudentPortfolioUserWork } from './types'
import { LecturerPortfolioUserWork } from './types'
import { Notification } from './types'
import { Faq } from './types'
import { FacultySchool } from './types'
import { StudentProgramState } from './types'
import { LecturerUser } from './types'
import { Recommendation } from './types'
import { RecommendationLecturerSide } from './types'
import { RecommendationStudentInfo } from './types'
import { CoursePostComment } from './types'
import { Resume } from './types'
import { ResumePersonal } from './types'
import { ResumeWork } from './types'
import { ResumeTraining } from './types'
import { ResumeSkill } from './types'
import { ResumeEducation } from './types'
import { ResumeAdditional } from './types'
import { University } from './types'
import { ResumeLanguage } from './types'
import { ResumePublicationType } from './types'
import { ResumeGrantType } from './types'
import { ResumeCity } from './types'
import { RegistrationStatus } from './types'
import { MasterRegistrationStep1 } from './types'
import { MasterRegistrationStep2 } from './types'
import { RegistrationStep3 } from './types'
import { LecturerRegistrationStep1 } from './types'
import { LecturerRegistrationStep2 } from './types'
import { ExamCourse } from './types'
import { UpdateResumeWorkRequest } from './types'
import { UpdateResumeTrainingRequest } from './types'
import { UpdateResumeSkillLanguageRequest } from './types'
import { UpdateResumeSkillCommunicationRequest } from './types'
import { UpdateResumeSkillComputerRequest } from './types'
import { UpdateResumeSkillOrganisationalRequest } from './types'
import { UpdateResumeSkillOtherRequest } from './types'
import { UpdateResumeEducationRequest } from './types'
import { UpdateResumeAdditionalPublicationRequest } from './types'
import { UpdateResumeAdditionalFellowshipRequest } from './types'
import { UpdateResumeAdditionalSubjectRequest } from './types'
import { UpdateResumeAdditionalVideoLectureRequest } from './types'
import { AvailableChoiceSummary } from './types'
import { AvailableCourseTab } from './types'
import { AvailableCourseSummary } from './types'
import { MetaData } from './types'
import { Country } from './types'
import { Address } from './types'
import { FeedbackSubject } from './types'
import { SurveyProgress } from './types'
import { Survey } from './types'
import { LecturerSurveyList } from './types'
import { SurveyQuestion } from './types'
import { QuestionAnswerRequest } from './types'
import { Feedback } from './types'
import { Registration } from './types'
import { SurveyChart } from './types'
import { MailStatus } from './types'
import { Mail } from './types'
import { AdministratorBulkMessage } from './types'
import { AdministratorBulkMessageRejected } from './types'
import { AdministratorBulkMessageProgress } from './types'
import { ScoreDistribution } from './types'
import { AdministratorGraduatesStatisticsType } from './types'
import { AdministratorGraduatesStatisticsMeta } from './types'
import { AdministratorGraduatesExport } from './types'
import { AdministratorGraduatesSearch } from './types'
import { AdministratorListsOption } from './types'
import { AdministratorStatistics } from './types'
import { Degree } from './types'
import { RegimeDefinitions } from './types'
import { FileDefinitions } from './types'
import { PortfolioDefinitions } from './types'
import { PortfolioListsCompetency } from './types'
import { PortfolioListsCriteria } from './types'
import { PortfolioListsSection } from './types'
import { PortfolioListsMentor } from './types'
import { PortfolioListsSemester } from './types'
import { PortfolioListsStudent } from './types'
import { AdministratorPortfolioWork } from './types'
import { AdministratorPortfolioLimit } from './types'
import { CacheKey } from './types'
import { AdministratorPortfolioCriteria } from './types'
import { AdministratorPortfolioCompetency } from './types'
import { PortfolioSemester } from './types'
import { AdministratorPortfolioSection } from './types'
import { AdministratorPortfolioSectionDetails } from './types'
import { AdministratorPortfolioSectionRequest } from './types'
import { AdministratorPortfolioCompetencyRequest } from './types'
import { AdministratorPortfolioSemesterRequest } from './types'
import { AdministratorPortfolioMentorRequest } from './types'
import { AdministratorPortfolioStudent } from './types'
import { AdministratorFacultyDegree } from './types'
import { AdministratorFaculty } from './types'
import { AdministratorDefinitionUser } from './types'
import { AdministratorDefinitionStudent } from './types'
import { ClinicalInternshipReference } from './types'
import { AdministratorProgramsListResponse } from './types'
import { AdministratorProgram } from './types'
import { AdministratorCourseRequirementsResponse } from './types'
import { AdministratorCourse } from './types'
import { AdministratorListsType } from './types'
import { AdministratorCourseDefinition } from './types'
import { AdministratorCourseDefaultsResponse } from './types'
import { AdministratorCreditTypesListResponse } from './types'
import { AdministratorListsScoreOptionsResponse } from './types'
import { AdministratorListsHoursResponse } from './types'
import { AdministratorListsLectureTypesResponse } from './types'
import { AdministratorListsFacultiesResponse } from './types'
import { AdministratorListsCoursesResponse } from './types'
import { AdministratorListsGroupNamesResponse } from './types'
import { AdministratorListsBuildingsResponse } from './types'
import { AdministratorListsRoomsResponse } from './types'
import { AdministratorListsLectureFormatsResponse } from './types'
import { AdministratorListsScheduleLocationsResponse } from './types'
import { AdministratorListsLearningWeek } from './types'
import { AdministratorListsScoreCriteriasResponse } from './types'
import { AdministratorListsLecturer } from './types'
import { AdministratorListsGroupDurations } from './types'
import { AdministratorCourseGroupItem } from './types'
import { AdministratorCourseScoresGroup } from './types'
import { AdministratorCourseGroupScores } from './types'
import { AdministratorCourseGroupCriterias } from './types'
import { AdministratorPaperStatus } from './types'
import { AdministratorPaperCard } from './types'
import { AdministratorCourseStudentChoice } from './types'
import { AdministratorCourseGroupScheduleLecturer } from './types'
import { AdministratorCourseGroupSchedule } from './types'
import { AdministratorCourseGroupScheduleConflictsDetected } from './types'
import { AdministratorCourseGroupScheduleConflictResult } from './types'
import { AdministratorCourseGroupAvailableLecturer } from './types'
import { AdministratorSchedulesGridResponse } from './types'
import { AdministratorListsLearningWeeksScheduleResponse } from './types'

import { IDStringDecoder } from './types'
import { MessageObjectDecoder } from './types'
import { SuccessResponseDecoder } from './types'
import { AuthObjectDecoder } from './types'
import { ProgramDecoder } from './types'
import { FacultyDecoder } from './types'
import { MediaFileDecoder } from './types'
import { DownloadMediaFileDecoder } from './types'
import { GeneralSettingsDecoder } from './types'
import { NotificationSettingsDecoder } from './types'
import { ExportFileDecoder } from './types'
import { AuthUserDecoder } from './types'
import { SemesterDecoder } from './types'
import { AdministratorRegimeDecoder } from './types'
import { MessageUnreadCountDecoder } from './types'
import { FinalScoreDecoder } from './types'
import { CourseDecoder } from './types'
import { CoursePaperCriteriaDecoder } from './types'
import { PaperDecoder } from './types'
import { GroupDecoder } from './types'
import { GroupScheduleDecoder } from './types'
import { ChoiceDecoder } from './types'
import { LibraryBookDecoder } from './types'
import { LibraryBooksTakenDecoder } from './types'
import { BillingScheduleDecoder } from './types'
import { BillingDepositDecoder } from './types'
import { BillingBalanceDecoder } from './types'
import { PaymentInstructionDecoder } from './types'
import { PaginationDecoder } from './types'
import { AuthLogDecoder } from './types'
import { UserDecoder } from './types'
import { AdministratorUserDecoder } from './types'
import { JSONRecordDecoder } from './types'
import { AdministratorStudentChoicesPageDecoder } from './types'
import { AdministratorChoiceHistoryResourceDecoder } from './types'
import { AdministratorChoiceCreateResponseDecoder } from './types'
import { AdministratorChoiceUpdateResourceDecoder } from './types'
import { AdministratorStudentChoiceCoursesPageDecoder } from './types'
import { AdministratorChoiceDeleteResultDecoder } from './types'
import { AdministratorChoiceDiscardResultDecoder } from './types'
import { AdministratorChoiceProgramAssignmentResultDecoder } from './types'
import { AdministratorChoiceProgramAssignmentResetResultDecoder } from './types'
import { AdministratorStudentChoiceHistory3PageDecoder } from './types'
import { UserStateDecoder } from './types'
import { MessageDecoder } from './types'
import { ScheduleDayDecoder } from './types'
import { CardDecoder } from './types'
import { CalendarItemDecoder } from './types'
import { StatementDecoder } from './types'
import { StatementTemplateDecoder } from './types'
import { StatementTemplateViewDecoder } from './types'
import { AdministratorStatementDecoder } from './types'
import { AdministratorStatementTemplateDecoder } from './types'
import { AdministratorListsStatementTemplateDecoder } from './types'
import { RatingDecoder } from './types'
import { CourseSyllabusDecoder } from './types'
import { CourseFileDecoder } from './types'
import { CoursePostDecoder } from './types'
import { NewsUnreadCountDecoder } from './types'
import { NewsDecoder } from './types'
import { PortfolioCompetencyDecoder } from './types'
import { SectionDecoder } from './types'
import { StudentPortfolioUserWorkDecoder } from './types'
import { LecturerPortfolioUserWorkDecoder } from './types'
import { NotificationDecoder } from './types'
import { FaqDecoder } from './types'
import { FacultySchoolDecoder } from './types'
import { StudentProgramStateDecoder } from './types'
import { LecturerUserDecoder } from './types'
import { RecommendationDecoder } from './types'
import { RecommendationLecturerSideDecoder } from './types'
import { RecommendationStudentInfoDecoder } from './types'
import { CoursePostCommentDecoder } from './types'
import { ResumeDecoder } from './types'
import { ResumePersonalDecoder } from './types'
import { ResumeWorkDecoder } from './types'
import { ResumeTrainingDecoder } from './types'
import { ResumeSkillDecoder } from './types'
import { ResumeEducationDecoder } from './types'
import { ResumeAdditionalDecoder } from './types'
import { UniversityDecoder } from './types'
import { ResumeLanguageDecoder } from './types'
import { ResumePublicationTypeDecoder } from './types'
import { ResumeGrantTypeDecoder } from './types'
import { ResumeCityDecoder } from './types'
import { RegistrationStatusDecoder } from './types'
import { ExamCourseDecoder } from './types'
import { AvailableChoiceSummaryDecoder } from './types'
import { AvailableCourseTabDecoder } from './types'
import { AvailableCourseSummaryDecoder } from './types'
import { MetaDataDecoder } from './types'
import { CountryDecoder } from './types'
import { AddressDecoder } from './types'
import { FeedbackSubjectDecoder } from './types'
import { SurveyProgressDecoder } from './types'
import { SurveyDecoder } from './types'
import { LecturerSurveyListDecoder } from './types'
import { SurveyQuestionDecoder } from './types'
import { FeedbackDecoder } from './types'
import { RegistrationDecoder } from './types'
import { SurveyChartDecoder } from './types'
import { MailStatusDecoder } from './types'
import { MailDecoder } from './types'
import { AdministratorBulkMessageDecoder } from './types'
import { AdministratorBulkMessageRejectedDecoder } from './types'
import { AdministratorBulkMessageProgressDecoder } from './types'
import { ScoreDistributionDecoder } from './types'
import { AdministratorGraduatesStatisticsMetaDecoder } from './types'
import { AdministratorGraduatesExportDecoder } from './types'
import { AdministratorGraduatesSearchDecoder } from './types'
import { AdministratorListsOptionDecoder } from './types'
import { AdministratorStatisticsDecoder } from './types'
import { DegreeDecoder } from './types'
import { RegimeDefinitionsDecoder } from './types'
import { FileDefinitionsDecoder } from './types'
import { PortfolioDefinitionsDecoder } from './types'
import { PortfolioListsCompetencyDecoder } from './types'
import { PortfolioListsCriteriaDecoder } from './types'
import { PortfolioListsSectionDecoder } from './types'
import { PortfolioListsMentorDecoder } from './types'
import { PortfolioListsSemesterDecoder } from './types'
import { PortfolioListsStudentDecoder } from './types'
import { AdministratorPortfolioWorkDecoder } from './types'
import { AdministratorPortfolioLimitDecoder } from './types'
import { CacheKeyDecoder } from './types'
import { AdministratorPortfolioCriteriaDecoder } from './types'
import { AdministratorPortfolioCompetencyDecoder } from './types'
import { PortfolioSemesterDecoder } from './types'
import { AdministratorPortfolioSectionDecoder } from './types'
import { AdministratorPortfolioSectionDetailsDecoder } from './types'
import { AdministratorPortfolioStudentDecoder } from './types'
import { AdministratorFacultyDegreeDecoder } from './types'
import { AdministratorFacultyDecoder } from './types'
import { AdministratorDefinitionUserDecoder } from './types'
import { AdministratorDefinitionStudentDecoder } from './types'
import { ClinicalInternshipReferenceDecoder } from './types'
import { AdministratorProgramsListResponseDecoder } from './types'
import { AdministratorProgramDecoder } from './types'
import { AdministratorCourseRequirementsResponseDecoder } from './types'
import { AdministratorCourseDecoder } from './types'
import { AdministratorListsTypeDecoder } from './types'
import { AdministratorCourseDefinitionDecoder } from './types'
import { AdministratorCourseDefaultsResponseDecoder } from './types'
import { AdministratorCreditTypesListResponseDecoder } from './types'
import { AdministratorListsScoreOptionsResponseDecoder } from './types'
import { AdministratorListsHoursResponseDecoder } from './types'
import { AdministratorListsLectureTypesResponseDecoder } from './types'
import { AdministratorListsFacultiesResponseDecoder } from './types'
import { AdministratorListsCoursesResponseDecoder } from './types'
import { AdministratorListsGroupNamesResponseDecoder } from './types'
import { AdministratorListsBuildingsResponseDecoder } from './types'
import { AdministratorListsRoomsResponseDecoder } from './types'
import { AdministratorListsLectureFormatsResponseDecoder } from './types'
import { AdministratorListsScheduleLocationsResponseDecoder } from './types'
import { AdministratorListsLearningWeekDecoder } from './types'
import { AdministratorListsScoreCriteriasResponseDecoder } from './types'
import { AdministratorListsLecturerDecoder } from './types'
import { AdministratorListsGroupDurationsDecoder } from './types'
import { AdministratorCourseGroupItemDecoder } from './types'
import { AdministratorCourseScoresGroupDecoder } from './types'
import { AdministratorCourseGroupScoresDecoder } from './types'
import { AdministratorCourseGroupCriteriasDecoder } from './types'
import { AdministratorPaperStatusDecoder } from './types'
import { AdministratorPaperCardDecoder } from './types'
import { AdministratorCourseStudentChoiceDecoder } from './types'
import { AdministratorCourseGroupScheduleDecoder } from './types'
import { AdministratorCourseGroupScheduleConflictsDetectedDecoder } from './types'
import { AdministratorCourseGroupScheduleConflictResultDecoder } from './types'
import { AdministratorCourseGroupAvailableLecturerDecoder } from './types'
import { AdministratorSchedulesGridResponseDecoder } from './types'
import { AdministratorListsLearningWeeksScheduleResponseDecoder } from './types'

export interface loginParams {
  readonly "body": {
    readonly "clientId": "1"
    readonly "grantType": "internal"
    readonly "login": string
    readonly "password": string
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type loginOk = AuthObject

export type loginErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function login (params: loginParams): Promise<loginOk> {
  const url = "/auth/token"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "clientId": params.body["clientId"],
      "grantType": params.body["grantType"],
      "login": params.body["login"],
      "password": params.body["password"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthObjectDecoder).decode(data)
    if (result.ok) {
      return identity<AuthObject>(result.value)
    } else {
      console.error(
        'POST /auth/token 2XX AuthObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /auth/token 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /auth/token 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /auth/token 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /auth/token 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("login"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /auth/token XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export type basicAuthParams = void

export type basicAuthOk = null

export type basicAuthErr = never

export async function basicAuth (params: basicAuthParams): Promise<basicAuthOk> {
  const url = "/basic-auth"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'GET /basic-auth 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("basicAuth"))
  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface loginWithGoogleIdTokenParams {
  readonly "body": {
    readonly "clientId": "1"
    readonly "grantType": "google_id_token"
    readonly "token": string
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type loginWithGoogleIdTokenOk = AuthObject

export type loginWithGoogleIdTokenErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function loginWithGoogleIdToken (params: loginWithGoogleIdTokenParams): Promise<loginWithGoogleIdTokenOk> {
  const url = "/auth/token"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "clientId": params.body["clientId"],
      "grantType": params.body["grantType"],
      "token": params.body["token"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthObjectDecoder).decode(data)
    if (result.ok) {
      return identity<AuthObject>(result.value)
    } else {
      console.error(
        'POST /auth/token 2XX AuthObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /auth/token 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /auth/token 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /auth/token 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /auth/token 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("loginWithGoogleIdToken"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /auth/token XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface loginWithGoogleAccessTokenParams {
  readonly "body": {
    readonly "clientId": "1"
    readonly "grantType": "google_access_token"
    readonly "token": string
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type loginWithGoogleAccessTokenOk = AuthObject

export type loginWithGoogleAccessTokenErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function loginWithGoogleAccessToken (params: loginWithGoogleAccessTokenParams): Promise<loginWithGoogleAccessTokenOk> {
  const url = "/auth/token"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "clientId": params.body["clientId"],
      "grantType": params.body["grantType"],
      "token": params.body["token"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthObjectDecoder).decode(data)
    if (result.ok) {
      return identity<AuthObject>(result.value)
    } else {
      console.error(
        'POST /auth/token 2XX AuthObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /auth/token 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /auth/token 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /auth/token 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /auth/token 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("loginWithGoogleAccessToken"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /auth/token XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getEmulateUserParams {
  readonly "body": {
    readonly "clientId": "1"
    readonly "grantType": "emulate"
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "userId": string
  }
}

export type getEmulateUserOk = AuthObject

export type getEmulateUserErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getEmulateUser (params: getEmulateUserParams): Promise<getEmulateUserOk> {
  let url = "/auth/emulate/"
  url += params.args["userId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "clientId": params.body["clientId"],
      "grantType": params.body["grantType"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthObjectDecoder).decode(data)
    if (result.ok) {
      return identity<AuthObject>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/ 2XX AuthObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getEmulateUser"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postFinishEmulateUserParams {
  readonly "body": {
    readonly "clientId": "1"
    readonly "grantType": "emulate"
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Accept-Language": LanguageString
  }
}

export type postFinishEmulateUserOk = AuthObject

export type postFinishEmulateUserErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postFinishEmulateUser (params: postFinishEmulateUserParams): Promise<postFinishEmulateUserOk> {
  const url = "/auth/emulate/finish"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "clientId": params.body["clientId"],
      "grantType": params.body["grantType"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthObjectDecoder).decode(data)
    if (result.ok) {
      return identity<AuthObject>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/finish 2XX AuthObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/finish 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/finish 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/finish 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/finish 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postFinishEmulateUser"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /auth/emulate/finish XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserByPersNumberParams {
  readonly "body": {
    readonly "persNum": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getUserByPersNumberOk = User

export type getUserByPersNumberErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUserByPersNumber (params: getUserByPersNumberParams): Promise<getUserByPersNumberOk> {
  const url = "/administrator/users/by-persnum"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "persNum": params.body["persNum"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX User
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(UserDecoder).decode(data)
    if (result.ok) {
      return identity<User>(result.value)
    } else {
      console.error(
        'POST /administrator/users/by-persnum 2XX User\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/by-persnum 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/by-persnum 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/users/by-persnum 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/users/by-persnum 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUserByPersNumber"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/users/by-persnum XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorRegimesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": string
    readonly "perPage": string
  }
}

export interface getAdministratorRegimesOk {
  readonly "data": readonly AdministratorRegime[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorRegimesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorRegimes (params: getAdministratorRegimesParams): Promise<getAdministratorRegimesOk> {
  const url = "/administrator/regimes"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorRegime[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorRegimeDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorRegime[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes 2XX {\n' +
        '  readonly "data": readonly AdministratorRegime[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorRegimes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorRegimesShowParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorRegimesShowOk = AdministratorRegime

export type getAdministratorRegimesShowErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorRegimesShow (params: getAdministratorRegimesShowParams): Promise<getAdministratorRegimesShowOk> {
  let url = "/administrator/regimes/show/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorRegime
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorRegimeDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorRegime>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/show/ 2XX AdministratorRegime\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/show/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/show/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/show/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/show/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorRegimesShow"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/show/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorRegimesSaveParams {
  readonly "body": {
    readonly "name": string
    readonly "showMessage": number
    readonly "message": null | string
    readonly "type": IDString
    readonly "status": boolean
    readonly "chooseAllowed": boolean
    readonly "limitFunctional": number
    readonly "allowLogin": IDString
    readonly "allowChoose": IDString
    readonly "schedule": IDString
    readonly "survey": IDString
    readonly "allowLecturerSurvey": IDString
    readonly "allowLecturerScore": IDString
    readonly "chooseCriterias": readonly ChooseCriteria[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postAdministratorRegimesSaveOk = null

export type postAdministratorRegimesSaveErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorRegimesSave (params: postAdministratorRegimesSaveParams): Promise<postAdministratorRegimesSaveOk> {
  let url = "/administrator/regimes/save/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "showMessage": params.body["showMessage"],
      "message": params.body["message"],
      "type": params.body["type"],
      "status": params.body["status"],
      "chooseAllowed": params.body["chooseAllowed"],
      "limitFunctional": params.body["limitFunctional"],
      "allowLogin": params.body["allowLogin"],
      "allowChoose": params.body["allowChoose"],
      "schedule": params.body["schedule"],
      "survey": params.body["survey"],
      "allowLecturerSurvey": params.body["allowLecturerSurvey"],
      "allowLecturerScore": params.body["allowLecturerScore"],
      "chooseCriterias": params.body["chooseCriterias"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/regimes/save/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/regimes/save/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/regimes/save/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/regimes/save/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/regimes/save/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorRegimesSave"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/regimes/save/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorRegimesActivateParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorRegimesActivateOk = null

export type getAdministratorRegimesActivateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorRegimesActivate (params: getAdministratorRegimesActivateParams): Promise<getAdministratorRegimesActivateOk> {
  let url = "/administrator/regimes/activate/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/activate/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/activate/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/activate/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/activate/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/activate/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorRegimesActivate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/activate/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorMailsListParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "filters": {
      readonly "status": null | string
      readonly "search": null | string
    }
  }
}

export interface getAdministratorMailsListOk {
  readonly "data": readonly Mail[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorMailsListErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorMailsList (params: getAdministratorMailsListParams): Promise<getAdministratorMailsListOk> {
  const url = "/administrator/mails/list"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Mail[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(MailDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Mail[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/list 2XX {\n' +
        '  readonly "data": readonly Mail[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/list 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/list 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/list 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/list 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorMailsList"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/list XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorMailsStatusesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export interface getAdministratorMailsStatusesOk {
  readonly "data": readonly MailStatus[]
}

export type getAdministratorMailsStatusesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorMailsStatuses (params: getAdministratorMailsStatusesParams): Promise<getAdministratorMailsStatusesOk> {
  const url = "/administrator/mails/statuses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly MailStatus[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(MailStatusDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly MailStatus[]
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/statuses 2XX {\n' +
        '  readonly "data": readonly MailStatus[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/statuses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/statuses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/statuses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/statuses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorMailsStatuses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/mails/statuses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorMailsTryAgainParams {
  readonly "body": {
    readonly "id": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorMailsTryAgainOk = null

export type postAdministratorMailsTryAgainErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorMailsTryAgain (params: postAdministratorMailsTryAgainParams): Promise<postAdministratorMailsTryAgainOk> {
  const url = "/administrator/mails/try-again"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "id": params.body["id"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/mails/try-again 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/mails/try-again 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/mails/try-again 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/mails/try-again 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/mails/try-again 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorMailsTryAgain"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/mails/try-again XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorBulkMessageParams {
  readonly "body": {
    readonly "file": Blob
    readonly "subject": string
    readonly "body": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorBulkMessageOk = AdministratorBulkMessage

export type postAdministratorBulkMessageErr = AdministratorBulkMessageRejected | base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorBulkMessage (params: postAdministratorBulkMessageParams): Promise<postAdministratorBulkMessageOk> {
  const url = "/administrator/users/message/bulk"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Accept": "application/json",
    },
    body: toFormData({
      "file": params.body["file"],
      "subject": params.body["subject"],
      "body": params.body["body"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorBulkMessage
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorBulkMessageDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorBulkMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk 2XX AdministratorBulkMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 AdministratorBulkMessageRejected
  if (response.status === 422) {
    const result = DataDecoder(AdministratorBulkMessageRejectedDecoder).decode(data)
    if (result.ok) {
      throw identity<AdministratorBulkMessageRejected>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk 422 AdministratorBulkMessageRejected\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorBulkMessage"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/users/message/bulk XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorBulkMessageProgressParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "batchId": string
  }
}

export type getAdministratorBulkMessageProgressOk = AdministratorBulkMessageProgress

export type getAdministratorBulkMessageProgressErr = base.NotFoundError | base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorBulkMessageProgress (params: getAdministratorBulkMessageProgressParams): Promise<getAdministratorBulkMessageProgressOk> {
  let url = "/administrator/users/message/bulk/"
  url += params.args["batchId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorBulkMessageProgress
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorBulkMessageProgressDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorBulkMessageProgress>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ 2XX AdministratorBulkMessageProgress\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 404 base.NotFoundError
  if (response.status === 404) {
    const result = DataDecoder(base.NotFoundErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.NotFoundError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ 404 base.NotFoundError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorBulkMessageProgress"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/message/bulk/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAuthTokenParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Accept-Language": LanguageString
  }
}

export type deleteAuthTokenOk = null

export type deleteAuthTokenErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAuthToken (params: deleteAuthTokenParams): Promise<deleteAuthTokenOk> {
  const url = "/auth/token"
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'DELETE /auth/token 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /auth/token 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /auth/token 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /auth/token 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /auth/token 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAuthToken"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /auth/token XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAuthTokenRefreshParams {
  readonly "body": {
    readonly "clientId": "1"
    readonly "grantType": GrantType
    readonly "refreshToken": string
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type postAuthTokenRefreshOk = AuthObject

export type postAuthTokenRefreshErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAuthTokenRefresh (params: postAuthTokenRefreshParams): Promise<postAuthTokenRefreshOk> {
  const url = "/auth/token/refresh"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "clientId": params.body["clientId"],
      "grantType": params.body["grantType"],
      "refreshToken": params.body["refreshToken"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthObjectDecoder).decode(data)
    if (result.ok) {
      return identity<AuthObject>(result.value)
    } else {
      console.error(
        'POST /auth/token/refresh 2XX AuthObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /auth/token/refresh 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /auth/token/refresh 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /auth/token/refresh 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /auth/token/refresh 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAuthTokenRefresh"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /auth/token/refresh XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAuthUserParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAuthUserOk = AuthUser

export type getAuthUserErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAuthUser (params: getAuthUserParams): Promise<getAuthUserOk> {
  const url = "/auth/user"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AuthUser
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AuthUserDecoder).decode(data)
    if (result.ok) {
      return identity<AuthUser>(result.value)
    } else {
      console.error(
        'GET /auth/user 2XX AuthUser\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /auth/user 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /auth/user 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /auth/user 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /auth/user 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAuthUser"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /auth/user XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getSemestersActiveParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type getSemestersActiveOk = Semester

export type getSemestersActiveErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getSemestersActive (params: getSemestersActiveParams): Promise<getSemestersActiveOk> {
  const url = "/semesters/active"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Semester
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SemesterDecoder).decode(data)
    if (result.ok) {
      return identity<Semester>(result.value)
    } else {
      console.error(
        'GET /semesters/active 2XX Semester\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /semesters/active 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /semesters/active 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /semesters/active 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /semesters/active 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getSemestersActive"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /semesters/active XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postPushSubscriptionsParams {
  readonly "body": {
    readonly "token": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postPushSubscriptionsOk = null

export type postPushSubscriptionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postPushSubscriptions (params: postPushSubscriptionsParams): Promise<postPushSubscriptionsOk> {
  const url = "/push-subscriptions"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "token": params.body["token"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /push-subscriptions 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /push-subscriptions 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /push-subscriptions 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /push-subscriptions 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /push-subscriptions 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postPushSubscriptions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /push-subscriptions XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deletePushSubscriptionsParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "token": string
  }
}

export type deletePushSubscriptionsOk = null

export type deletePushSubscriptionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deletePushSubscriptions (params: deletePushSubscriptionsParams): Promise<deletePushSubscriptionsOk> {
  let url = "/push-subscriptions/"
  url += params.args["token"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'DELETE /push-subscriptions/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /push-subscriptions/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /push-subscriptions/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /push-subscriptions/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /push-subscriptions/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deletePushSubscriptions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /push-subscriptions/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postPaperCriteriasParams {
  readonly "body": {
    readonly "intermediateScoreLimit": number
    readonly "groups": readonly string[]
    readonly "criterias": readonly SavePaperCriteria[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "courseId": string
  }
}

export type postPaperCriteriasOk = MessageObject

export type postPaperCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postPaperCriterias (params: postPaperCriteriasParams): Promise<postPaperCriteriasOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/papers"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "intermediateScoreLimit": params.body["intermediateScoreLimit"],
      "groups": params.body["groups"],
      "criterias": params.body["criterias"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postPaperCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerGroupsExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "courseId": string
  }
}

export type getLecturerGroupsExportOk = ExportFile

export type getLecturerGroupsExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerGroupsExport (params: getLecturerGroupsExportParams): Promise<getLecturerGroupsExportOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/export"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerGroupsExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface updatePaperCriteriasParams {
  readonly "body": {
    readonly "intermediateScoreLimit": number
    readonly "criterias": ReadonlyArray<{
      readonly "criteriaId": string
      readonly "min": number
      readonly "max": number
    }>
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "courseId": string
    readonly "groupId": string
    readonly "paperId": string
  }
}

export type updatePaperCriteriasOk = null

export type updatePaperCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function updatePaperCriterias (params: updatePaperCriteriasParams): Promise<updatePaperCriteriasOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/"
  url += params.args["groupId"]
  url += "/papers/"
  url += params.args["paperId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "intermediateScoreLimit": params.body["intermediateScoreLimit"],
      "criterias": params.body["criterias"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("updatePaperCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getPaperCriteriasParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getPaperCriteriasOk = readonly CoursePaperCriteria[]

export type getPaperCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getPaperCriterias (params: getPaperCriteriasParams): Promise<getPaperCriteriasOk> {
  const url = "/lecturer/paper-criterias"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly CoursePaperCriteria[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CoursePaperCriteriaDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly CoursePaperCriteria[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/paper-criterias 2XX readonly CoursePaperCriteria[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/paper-criterias 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/paper-criterias 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/paper-criterias 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/paper-criterias 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getPaperCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/paper-criterias XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerTeachingGroupsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerTeachingGroupsOk = readonly Group[]

export type getLecturerTeachingGroupsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerTeachingGroups (params: getLecturerTeachingGroupsParams): Promise<getLecturerTeachingGroupsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/teaching-groups"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Group[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(GroupDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Group[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly Group[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerTeachingGroups"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerGroupsPaperParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": string
  }
}

export type getLecturerGroupsPaperOk = Paper

export type getLecturerGroupsPaperErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerGroupsPaper (params: getLecturerGroupsPaperParams): Promise<getLecturerGroupsPaperOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/teaching-groups/"
  url += params.args["groupId"]
  url += "/paper"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Paper
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(PaperDecoder).decode(data)
    if (result.ok) {
      return identity<Paper>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX Paper\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerGroupsPaper"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
    }
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerStudentsOk = readonly LecturerUser[]

export type getLecturerStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerStudents (params: getLecturerStudentsParams): Promise<getLecturerStudentsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/teaching-groups/students"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly LecturerUser[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(LecturerUserDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly LecturerUser[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly LecturerUser[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentsScoreParams {
  readonly "body": {
    readonly "criteriaId": string
    readonly "score": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "courseId": string
    readonly "groupId": string
    readonly "profileId": string
  }
}

export type postStudentsScoreOk = FinalScore

export type postStudentsScoreErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentsScore (params: postStudentsScoreParams): Promise<postStudentsScoreOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/"
  url += params.args["groupId"]
  url += "/students/"
  url += params.args["profileId"]
  url += "/scores"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "criteriaId": params.body["criteriaId"],
      "score": params.body["score"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX FinalScore
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(FinalScoreDecoder).decode(data)
    if (result.ok) {
      return identity<FinalScore>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX FinalScore\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentsScore"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerTeachingGroupParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "courseId": string
    readonly "groupId": string
  }
}

export type getLecturerTeachingGroupOk = Group

export type getLecturerTeachingGroupErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerTeachingGroup (params: getLecturerTeachingGroupParams): Promise<getLecturerTeachingGroupOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/"
  url += params.args["groupId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Group
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(GroupDecoder).decode(data)
    if (result.ok) {
      return identity<Group>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX Group\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerTeachingGroup"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerTeachesSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerTeachesSemestersOk = readonly Semester[]

export type getLecturerTeachesSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerTeachesSemesters (params: getLecturerTeachesSemestersParams): Promise<getLecturerTeachesSemestersOk> {
  const url = "/lecturer/courses/teaches/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches/semesters 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches/semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches/semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches/semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches/semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerTeachesSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches/semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCourseTeachesSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerCourseTeachesSemestersOk = readonly Semester[]

export type getLecturerCourseTeachesSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCourseTeachesSemesters (params: getLecturerCourseTeachesSemestersParams): Promise<getLecturerCourseTeachesSemestersOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/teaches/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCourseTeachesSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerManageSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerManageSemestersOk = readonly Semester[]

export type getLecturerManageSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerManageSemesters (params: getLecturerManageSemestersParams): Promise<getLecturerManageSemestersOk> {
  const url = "/lecturer/courses/manage/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage/semesters 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage/semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage/semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage/semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage/semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerManageSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage/semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCourseParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerCourseOk = Course

export type getLecturerCourseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCourse (params: getLecturerCourseParams): Promise<getLecturerCourseOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Course
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CourseDecoder).decode(data)
    if (result.ok) {
      return identity<Course>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX Course\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCourse"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCourseSyllabusParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerCourseSyllabusOk = CourseSyllabus

export type getLecturerCourseSyllabusErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCourseSyllabus (params: getLecturerCourseSyllabusParams): Promise<getLecturerCourseSyllabusOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/syllabus"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CourseSyllabus
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CourseSyllabusDecoder).decode(data)
    if (result.ok) {
      return identity<CourseSyllabus>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX CourseSyllabus\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCourseSyllabus"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchLecturerCourseSyllabusParams {
  readonly "body": {
    readonly "duration": string
    readonly "lecturers": string
    readonly "hours": string
    readonly "prerequisites": string
    readonly "methods": string
    readonly "mission": string
    readonly "topics": string
    readonly "outcomes": string
    readonly "evaluation": string
    readonly "resources": string
    readonly "otherResources": string
    readonly "schedule": string
    readonly "knowledge": boolean
    readonly "applying": boolean
    readonly "judgments": boolean
    readonly "communications": boolean
    readonly "learning": boolean
    readonly "values": boolean
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type patchLecturerCourseSyllabusOk = null

export type patchLecturerCourseSyllabusErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchLecturerCourseSyllabus (params: patchLecturerCourseSyllabusParams): Promise<patchLecturerCourseSyllabusOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/syllabus"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "duration": params.body["duration"],
      "lecturers": params.body["lecturers"],
      "hours": params.body["hours"],
      "prerequisites": params.body["prerequisites"],
      "methods": params.body["methods"],
      "mission": params.body["mission"],
      "topics": params.body["topics"],
      "outcomes": params.body["outcomes"],
      "evaluation": params.body["evaluation"],
      "resources": params.body["resources"],
      "otherResources": params.body["otherResources"],
      "schedule": params.body["schedule"],
      "knowledge": params.body["knowledge"],
      "applying": params.body["applying"],
      "judgments": params.body["judgments"],
      "communications": params.body["communications"],
      "learning": params.body["learning"],
      "values": params.body["values"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchLecturerCourseSyllabus"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseSyllabusParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseSyllabusOk = CourseSyllabus

export type getAdministratorCourseSyllabusErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseSyllabus (params: getAdministratorCourseSyllabusParams): Promise<getAdministratorCourseSyllabusOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/syllabus"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CourseSyllabus
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CourseSyllabusDecoder).decode(data)
    if (result.ok) {
      return identity<CourseSyllabus>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX CourseSyllabus\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseSyllabus"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseSyllabusExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "mode": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseSyllabusExportOk = ExportFile

export type getAdministratorCourseSyllabusExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseSyllabusExport (params: getAdministratorCourseSyllabusExportParams): Promise<getAdministratorCourseSyllabusExportOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/syllabus/export"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseSyllabusExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseRequirementsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseRequirementsOk = AdministratorCourseRequirementsResponse

export type getAdministratorCourseRequirementsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseRequirements (params: getAdministratorCourseRequirementsParams): Promise<getAdministratorCourseRequirementsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/requirements"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseRequirementsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseRequirementsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseRequirementsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX AdministratorCourseRequirementsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseRequirements"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseRequirementsParams {
  readonly "body": {
    readonly "semId"?: number
    readonly "requiredCouIds": readonly number[]
    readonly "orGroup"?: number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postAdministratorCourseRequirementsOk = AdministratorCourseRequirementsResponse

export type postAdministratorCourseRequirementsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseRequirements (params: postAdministratorCourseRequirementsParams): Promise<postAdministratorCourseRequirementsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/requirements"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "requiredCouIds": params.body["requiredCouIds"],
      "orGroup": params.body["orGroup"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseRequirementsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseRequirementsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseRequirementsResponse>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX AdministratorCourseRequirementsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseRequirements"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAdministratorCourseRequirementsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
  }
  readonly "args": {
    readonly "id": string
    readonly "orGroup": number
  }
}

export type deleteAdministratorCourseRequirementsOk = MessageObject

export type deleteAdministratorCourseRequirementsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAdministratorCourseRequirements (params: deleteAdministratorCourseRequirementsParams): Promise<deleteAdministratorCourseRequirementsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/requirements/"
  url += params.args["orGroup"]
  url += ""
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAdministratorCourseRequirements"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseCorequisitesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseCorequisitesOk = AdministratorCourseRequirementsResponse

export type getAdministratorCourseCorequisitesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseCorequisites (params: getAdministratorCourseCorequisitesParams): Promise<getAdministratorCourseCorequisitesOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/corequisites"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseRequirementsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseRequirementsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseRequirementsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX AdministratorCourseRequirementsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseCorequisites"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseCorequisitesParams {
  readonly "body": {
    readonly "requiredCouIds": readonly number[]
    readonly "semId"?: number
    readonly "orGroup"?: number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postAdministratorCourseCorequisitesOk = AdministratorCourseRequirementsResponse

export type postAdministratorCourseCorequisitesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseCorequisites (params: postAdministratorCourseCorequisitesParams): Promise<postAdministratorCourseCorequisitesOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/corequisites"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "requiredCouIds": params.body["requiredCouIds"],
      "semId": params.body["semId"],
      "orGroup": params.body["orGroup"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseRequirementsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseRequirementsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseRequirementsResponse>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX AdministratorCourseRequirementsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseCorequisites"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAdministratorCourseCorequisitesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
  }
  readonly "args": {
    readonly "id": string
    readonly "orGroup": number
  }
}

export type deleteAdministratorCourseCorequisitesOk = MessageObject

export type deleteAdministratorCourseCorequisitesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAdministratorCourseCorequisites (params: deleteAdministratorCourseCorequisitesParams): Promise<deleteAdministratorCourseCorequisitesOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/corequisites/"
  url += params.args["orGroup"]
  url += ""
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAdministratorCourseCorequisites"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseGroupsOk = readonly AdministratorCourseGroupItem[]

export type getAdministratorCourseGroupsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroups (params: getAdministratorCourseGroupsParams): Promise<getAdministratorCourseGroupsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorCourseGroupItem[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorCourseGroupItemDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorCourseGroupItem[]>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX readonly AdministratorCourseGroupItem[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroups"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseGroupsParams {
  readonly "body": {
    readonly "name": string
    readonly "quotaMin": number
    readonly "quotaMax": number
    readonly "learningDuration": number
    readonly "examDuration": number
    readonly "lecturerIds"?: readonly number[]
    readonly "semId"?: number
    readonly "allowInSems"?: readonly number[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postAdministratorCourseGroupsOk = AdministratorCourseGroupItem

export type postAdministratorCourseGroupsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseGroups (params: postAdministratorCourseGroupsParams): Promise<postAdministratorCourseGroupsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "quotaMin": params.body["quotaMin"],
      "quotaMax": params.body["quotaMax"],
      "learningDuration": params.body["learningDuration"],
      "examDuration": params.body["examDuration"],
      "lecturerIds": params.body["lecturerIds"],
      "semId": params.body["semId"],
      "allowInSems": params.body["allowInSems"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseGroupItem
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseGroupItemDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseGroupItem>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX AdministratorCourseGroupItem\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseGroups"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseGroupParams {
  readonly "body": {
    readonly "name"?: string
    readonly "quotaMin"?: number
    readonly "quotaMax"?: number
    readonly "learningDuration"?: number
    readonly "examDuration"?: number
    readonly "lecturerIds"?: readonly number[]
    readonly "semId"?: number
    readonly "allowInSems"?: readonly number[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type putAdministratorCourseGroupOk = AdministratorCourseGroupItem

export type putAdministratorCourseGroupErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourseGroup (params: putAdministratorCourseGroupParams): Promise<putAdministratorCourseGroupOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "quotaMin": params.body["quotaMin"],
      "quotaMax": params.body["quotaMax"],
      "learningDuration": params.body["learningDuration"],
      "examDuration": params.body["examDuration"],
      "lecturerIds": params.body["lecturerIds"],
      "semId": params.body["semId"],
      "allowInSems": params.body["allowInSems"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseGroupItem
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseGroupItemDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseGroupItem>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX AdministratorCourseGroupItem\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourseGroup"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAdministratorCourseGroupParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type deleteAdministratorCourseGroupOk = MessageObject

export type deleteAdministratorCourseGroupErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAdministratorCourseGroup (params: deleteAdministratorCourseGroupParams): Promise<deleteAdministratorCourseGroupOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += ""
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAdministratorCourseGroup"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseScoresParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseScoresOk = readonly AdministratorCourseScoresGroup[]

export type getAdministratorCourseScoresErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseScores (params: getAdministratorCourseScoresParams): Promise<getAdministratorCourseScoresOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/scores"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorCourseScoresGroup[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorCourseScoresGroupDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorCourseScoresGroup[]>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX readonly AdministratorCourseScoresGroup[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseScores"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseScoresSummaryExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
    readonly "mode"?: string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseScoresSummaryExportOk = ExportFile

export type getAdministratorCourseScoresSummaryExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseScoresSummaryExport (params: getAdministratorCourseScoresSummaryExportParams): Promise<getAdministratorCourseScoresSummaryExportOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/scores/summary/export"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseScoresSummaryExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupScoresParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type getAdministratorCourseGroupScoresOk = AdministratorCourseGroupScores

export type getAdministratorCourseGroupScoresErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroupScores (params: getAdministratorCourseGroupScoresParams): Promise<getAdministratorCourseGroupScoresOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/scores"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseGroupScores
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseGroupScoresDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseGroupScores>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX AdministratorCourseGroupScores\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroupScores"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseGroupScoresParams {
  readonly "body": {
    readonly "semId": number
    readonly "scores": JSONRecord
    readonly "card"?: JSONRecord
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type putAdministratorCourseGroupScoresOk = MessageObject

export type putAdministratorCourseGroupScoresErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourseGroupScores (params: putAdministratorCourseGroupScoresParams): Promise<putAdministratorCourseGroupScoresOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/scores"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "scores": params.body["scores"],
      "card": params.body["card"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourseGroupScores"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupScoresExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type getAdministratorCourseGroupScoresExportOk = ExportFile

export type getAdministratorCourseGroupScoresExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroupScoresExport (params: getAdministratorCourseGroupScoresExportParams): Promise<getAdministratorCourseGroupScoresExportOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/scores/export"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroupScoresExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupCriteriasParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type getAdministratorCourseGroupCriteriasOk = AdministratorCourseGroupCriterias

export type getAdministratorCourseGroupCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroupCriterias (params: getAdministratorCourseGroupCriteriasParams): Promise<getAdministratorCourseGroupCriteriasOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/criterias"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseGroupCriterias
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseGroupCriteriasDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseGroupCriterias>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX AdministratorCourseGroupCriterias\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroupCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseGroupCriteriasParams {
  readonly "body": {
    readonly "semId": number
    readonly "intermediateScoreLimit": number
    readonly "groupIds"?: readonly number[]
    readonly "criterias": readonly JSONRecord[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type putAdministratorCourseGroupCriteriasOk = MessageObject

export type putAdministratorCourseGroupCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourseGroupCriterias (params: putAdministratorCourseGroupCriteriasParams): Promise<putAdministratorCourseGroupCriteriasOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/criterias"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "intermediateScoreLimit": params.body["intermediateScoreLimit"],
      "groupIds": params.body["groupIds"],
      "criterias": params.body["criterias"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourseGroupCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseGroupPaperStatusParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type putAdministratorCourseGroupPaperStatusOk = AdministratorPaperStatus

export type putAdministratorCourseGroupPaperStatusErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourseGroupPaperStatus (params: putAdministratorCourseGroupPaperStatusParams): Promise<putAdministratorCourseGroupPaperStatusOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/paper/status"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorPaperStatus
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorPaperStatusDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorPaperStatus>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX AdministratorPaperStatus\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourseGroupPaperStatus"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseGroupsMessageParams {
  readonly "body": {
    readonly "groups": readonly number[]
    readonly "subject": string
    readonly "body": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postAdministratorCourseGroupsMessageOk = null

export type postAdministratorCourseGroupsMessageErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseGroupsMessage (params: postAdministratorCourseGroupsMessageParams): Promise<postAdministratorCourseGroupsMessageOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/teaching-groups/message/groups"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "groups": params.body["groups"],
      "subject": params.body["subject"],
      "body": params.body["body"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseGroupsMessage"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupCardsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": number
  }
}

export type getAdministratorCourseGroupCardsOk = readonly AdministratorPaperCard[]

export type getAdministratorCourseGroupCardsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroupCards (params: getAdministratorCourseGroupCardsParams): Promise<getAdministratorCourseGroupCardsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/cards"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorPaperCard[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorPaperCardDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorPaperCard[]>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX readonly AdministratorPaperCard[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroupCards"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
    readonly "groupId"?: number
    readonly "page"?: number
    readonly "perPage"?: number
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getAdministratorCourseStudentsOk {
  readonly "data": readonly AdministratorCourseStudentChoice[]
  readonly "meta": {
    readonly "pagination": Pagination
    readonly "summary": {
      readonly "total": number
      readonly "passed": number
      readonly "failed": number
      readonly "withoutGroup": number
    }
  }
}

export type getAdministratorCourseStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseStudents (params: getAdministratorCourseStudentsParams): Promise<getAdministratorCourseStudentsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/students"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorCourseStudentChoice[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //     readonly "summary": {
  //       readonly "total": number
  //       readonly "passed": number
  //       readonly "failed": number
  //       readonly "withoutGroup": number
  //     }
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorCourseStudentChoiceDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
        "summary": decoders.object({
          "total": decoders.number,
          "passed": decoders.number,
          "failed": decoders.number,
          "withoutGroup": decoders.number,
        }),
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorCourseStudentChoice[]
        readonly "meta": {
          readonly "pagination": Pagination
          readonly "summary": {
            readonly "total": number
            readonly "passed": number
            readonly "failed": number
            readonly "withoutGroup": number
          }
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX {\n' +
        '  readonly "data": readonly AdministratorCourseStudentChoice[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '    readonly "summary": {\n' +
        '      readonly "total": number\n' +
        '      readonly "passed": number\n' +
        '      readonly "failed": number\n' +
        '      readonly "withoutGroup": number\n' +
        '    }\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseStudentsParams {
  readonly "body": {
    readonly "semId": number
    readonly "assignments": ReadonlyArray<{
      readonly "userId": number
      readonly "groupId"?: null | number
    }>
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorCourseStudentsOk = MessageObject

export type putAdministratorCourseStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourseStudents (params: putAdministratorCourseStudentsParams): Promise<putAdministratorCourseStudentsOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/students"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "assignments": params.body["assignments"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourseStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseStudentsReplaceNamesParams {
  readonly "body": {
    readonly "semId": number
    readonly "from": string
    readonly "to": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface postAdministratorCourseStudentsReplaceNamesOk {
  readonly "data": {
    readonly "updated": number
  }
}

export type postAdministratorCourseStudentsReplaceNamesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseStudentsReplaceNames (params: postAdministratorCourseStudentsReplaceNamesParams): Promise<postAdministratorCourseStudentsReplaceNamesOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += "/students/replace-names"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "from": params.body["from"],
      "to": params.body["to"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": {
  //     readonly "updated": number
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": decoders.object({
        "updated": decoders.number,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": {
          readonly "updated": number
        }
      }>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX {\n' +
        '  readonly "data": {\n' +
        '    readonly "updated": number\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseStudentsReplaceNames"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupSchedulesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
    readonly "weekId"?: number
    readonly "hourId"?: number
    readonly "lectureType"?: number
    readonly "lectureFormat"?: number
    readonly "searchWord"?: string
    readonly "locationType"?: number
    readonly "buildingId"?: number
    readonly "roomId"?: number
  }
  readonly "args": {
    readonly "couId": number
    readonly "groupId": number
  }
}

export type getAdministratorCourseGroupSchedulesOk = readonly AdministratorCourseGroupSchedule[]

export type getAdministratorCourseGroupSchedulesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroupSchedules (params: getAdministratorCourseGroupSchedulesParams): Promise<getAdministratorCourseGroupSchedulesOk> {
  let url = "/administrator/courses/"
  url += params.args["couId"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedules"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorCourseGroupSchedule[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorCourseGroupScheduleDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorCourseGroupSchedule[]>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX readonly AdministratorCourseGroupSchedule[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroupSchedules"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseGroupScheduleParams {
  readonly "body": {
    readonly "semId": number
    readonly "date": string
    readonly "hourId": number
    readonly "lectureTypeId": number
    readonly "lectureFormatId": number
    readonly "locationType"?: number
    readonly "buildingId"?: number
    readonly "roomId"?: number
    readonly "locationId"?: number
    readonly "isHalfHour"?: boolean
    readonly "isSplitLecture"?: boolean
    readonly "info"?: string
    readonly "lecturers": readonly AdministratorCourseGroupScheduleLecturer[]
    readonly "force"?: boolean
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "couId": number
    readonly "groupId": number
  }
}

export type postAdministratorCourseGroupScheduleOk = null

export type postAdministratorCourseGroupScheduleErr = AdministratorCourseGroupScheduleConflictsDetected | base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseGroupSchedule (params: postAdministratorCourseGroupScheduleParams): Promise<postAdministratorCourseGroupScheduleOk> {
  let url = "/administrator/courses/"
  url += params.args["couId"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedules"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "date": params.body["date"],
      "hourId": params.body["hourId"],
      "lectureTypeId": params.body["lectureTypeId"],
      "lectureFormatId": params.body["lectureFormatId"],
      "locationType": params.body["locationType"],
      "buildingId": params.body["buildingId"],
      "roomId": params.body["roomId"],
      "locationId": params.body["locationId"],
      "isHalfHour": params.body["isHalfHour"],
      "isSplitLecture": params.body["isSplitLecture"],
      "info": params.body["info"],
      "lecturers": params.body["lecturers"],
      "force": params.body["force"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 AdministratorCourseGroupScheduleConflictsDetected
  if (response.status === 422) {
    const result = DataDecoder(AdministratorCourseGroupScheduleConflictsDetectedDecoder).decode(data)
    if (result.ok) {
      throw identity<AdministratorCourseGroupScheduleConflictsDetected>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 AdministratorCourseGroupScheduleConflictsDetected\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseGroupSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseGroupScheduleParams {
  readonly "body": {
    readonly "date"?: string
    readonly "hourId"?: number
    readonly "lectureTypeId"?: number
    readonly "lectureFormatId"?: number
    readonly "locationType"?: number
    readonly "buildingId"?: number
    readonly "roomId"?: number
    readonly "locationId"?: number
    readonly "isHalfHour"?: boolean
    readonly "isSplitLecture"?: boolean
    readonly "info"?: string
    readonly "lecturers"?: readonly AdministratorCourseGroupScheduleLecturer[]
    readonly "massUpdate"?: boolean
    readonly "force"?: boolean
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "couId": number
    readonly "groupId": number
    readonly "id": number
  }
}

export type putAdministratorCourseGroupScheduleOk = null

export type putAdministratorCourseGroupScheduleErr = AdministratorCourseGroupScheduleConflictsDetected | base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourseGroupSchedule (params: putAdministratorCourseGroupScheduleParams): Promise<putAdministratorCourseGroupScheduleOk> {
  let url = "/administrator/courses/"
  url += params.args["couId"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedules/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "date": params.body["date"],
      "hourId": params.body["hourId"],
      "lectureTypeId": params.body["lectureTypeId"],
      "lectureFormatId": params.body["lectureFormatId"],
      "locationType": params.body["locationType"],
      "buildingId": params.body["buildingId"],
      "roomId": params.body["roomId"],
      "locationId": params.body["locationId"],
      "isHalfHour": params.body["isHalfHour"],
      "isSplitLecture": params.body["isSplitLecture"],
      "info": params.body["info"],
      "lecturers": params.body["lecturers"],
      "massUpdate": params.body["massUpdate"],
      "force": params.body["force"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 AdministratorCourseGroupScheduleConflictsDetected
  if (response.status === 422) {
    const result = DataDecoder(AdministratorCourseGroupScheduleConflictsDetectedDecoder).decode(data)
    if (result.ok) {
      throw identity<AdministratorCourseGroupScheduleConflictsDetected>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 AdministratorCourseGroupScheduleConflictsDetected\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourseGroupSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAdministratorCourseGroupScheduleParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
    readonly "massDelete"?: boolean
  }
  readonly "args": {
    readonly "couId": number
    readonly "groupId": number
    readonly "id": number
  }
}

export type deleteAdministratorCourseGroupScheduleOk = MessageObject

export type deleteAdministratorCourseGroupScheduleErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAdministratorCourseGroupSchedule (params: deleteAdministratorCourseGroupScheduleParams): Promise<deleteAdministratorCourseGroupScheduleOk> {
  let url = "/administrator/courses/"
  url += params.args["couId"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedules/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAdministratorCourseGroupSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseGroupScheduleLecturersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "couId": number
    readonly "groupId": number
  }
}

export type getAdministratorCourseGroupScheduleLecturersOk = readonly AdministratorCourseGroupAvailableLecturer[]

export type getAdministratorCourseGroupScheduleLecturersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseGroupScheduleLecturers (params: getAdministratorCourseGroupScheduleLecturersParams): Promise<getAdministratorCourseGroupScheduleLecturersOk> {
  let url = "/administrator/courses/"
  url += params.args["couId"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedules/lecturers"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorCourseGroupAvailableLecturer[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorCourseGroupAvailableLecturerDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorCourseGroupAvailableLecturer[]>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX readonly AdministratorCourseGroupAvailableLecturer[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseGroupScheduleLecturers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCourseGroupScheduleCheckConflictsParams {
  readonly "body": {
    readonly "semId": number
    readonly "dates": readonly string[]
    readonly "hourIds": readonly number[]
    readonly "lectureTypeId": number
    readonly "lectureFormatId": number
    readonly "locationType"?: number
    readonly "buildingId"?: number
    readonly "roomId"?: number
    readonly "locationId"?: number
    readonly "isHalfHour"?: boolean
    readonly "isSplitLecture"?: boolean
    readonly "info"?: string
    readonly "scheduleId"?: number
    readonly "lecturers": readonly AdministratorCourseGroupScheduleLecturer[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "couId": number
    readonly "groupId": number
  }
}

export type postAdministratorCourseGroupScheduleCheckConflictsOk = AdministratorCourseGroupScheduleConflictResult

export type postAdministratorCourseGroupScheduleCheckConflictsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourseGroupScheduleCheckConflicts (params: postAdministratorCourseGroupScheduleCheckConflictsParams): Promise<postAdministratorCourseGroupScheduleCheckConflictsOk> {
  let url = "/administrator/courses/"
  url += params.args["couId"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedules/check-conflicts"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "dates": params.body["dates"],
      "hourIds": params.body["hourIds"],
      "lectureTypeId": params.body["lectureTypeId"],
      "lectureFormatId": params.body["lectureFormatId"],
      "locationType": params.body["locationType"],
      "buildingId": params.body["buildingId"],
      "roomId": params.body["roomId"],
      "locationId": params.body["locationId"],
      "isHalfHour": params.body["isHalfHour"],
      "isSplitLecture": params.body["isSplitLecture"],
      "info": params.body["info"],
      "scheduleId": params.body["scheduleId"],
      "lecturers": params.body["lecturers"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseGroupScheduleConflictResult
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseGroupScheduleConflictResultDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseGroupScheduleConflictResult>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 2XX AdministratorCourseGroupScheduleConflictResult\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourseGroupScheduleCheckConflicts"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentChoicesOk = readonly Choice[]

export type getStudentChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentChoices (params: getStudentChoicesParams): Promise<getStudentChoicesOk> {
  const url = "/student/choices"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Choice[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ChoiceDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Choice[]>(result.value)
    } else {
      console.error(
        'GET /student/choices 2XX readonly Choice[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentChoicesProgramsAssignParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "program_id": string
  }
}

export type postStudentChoicesProgramsAssignOk = MessageObject

export type postStudentChoicesProgramsAssignErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentChoicesProgramsAssign (params: postStudentChoicesProgramsAssignParams): Promise<postStudentChoicesProgramsAssignOk> {
  let url = "/student/choices/"
  url += params.args["uid"]
  url += "/programs/"
  url += params.args["program_id"]
  url += "/assign"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentChoicesProgramsAssign"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/choices/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentChoicesFreeCreditsAssignParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
  }
}

export type postStudentChoicesFreeCreditsAssignOk = MessageObject

export type postStudentChoicesFreeCreditsAssignErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentChoicesFreeCreditsAssign (params: postStudentChoicesFreeCreditsAssignParams): Promise<postStudentChoicesFreeCreditsAssignOk> {
  let url = "/student/choices/"
  url += params.args["uid"]
  url += "/free-credits/assign"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentChoicesFreeCreditsAssign"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/choices/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentChoicesRemoveAssignmentParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
  }
}

export type postStudentChoicesRemoveAssignmentOk = MessageObject

export type postStudentChoicesRemoveAssignmentErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentChoicesRemoveAssignment (params: postStudentChoicesRemoveAssignmentParams): Promise<postStudentChoicesRemoveAssignmentOk> {
  let url = "/student/choices/"
  url += params.args["uid"]
  url += "/remove-assignment"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/choices/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentChoicesRemoveAssignment"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/choices/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentChoicesParams {
  readonly "body": {
    readonly "courseId": IDString
    readonly "groupId": IDString
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentChoicesOk = MessageObject

export type postStudentChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentChoices (params: postStudentChoicesParams): Promise<postStudentChoicesOk> {
  const url = "/student/choices"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "courseId": params.body["courseId"],
      "groupId": params.body["groupId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'POST /student/choices 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteStudentChoicesParams {
  readonly "body": {
    readonly "courseId": IDString
    readonly "groupId": IDString
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type deleteStudentChoicesOk = MessageObject

export type deleteStudentChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteStudentChoices (params: deleteStudentChoicesParams): Promise<deleteStudentChoicesOk> {
  const url = "/student/choices"
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "courseId": params.body["courseId"],
      "groupId": params.body["groupId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /student/choices 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /student/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /student/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /student/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /student/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteStudentChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /student/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentChoicesRechooseParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentChoicesRechooseOk = Choice

export type getStudentChoicesRechooseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentChoicesRechoose (params: getStudentChoicesRechooseParams): Promise<getStudentChoicesRechooseOk> {
  const url = "/student/choices/rechoose"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Choice
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ChoiceDecoder).decode(data)
    if (result.ok) {
      return identity<Choice>(result.value)
    } else {
      console.error(
        'GET /student/choices/rechoose 2XX Choice\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/choices/rechoose 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/choices/rechoose 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/choices/rechoose 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/choices/rechoose 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentChoicesRechoose"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/choices/rechoose XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentChoicesRechooseParams {
  readonly "body": {
    readonly "courseId": IDString
    readonly "groupId": IDString
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentChoicesRechooseOk = MessageObject

export type postStudentChoicesRechooseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentChoicesRechoose (params: postStudentChoicesRechooseParams): Promise<postStudentChoicesRechooseOk> {
  const url = "/student/choices/rechoose"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "courseId": params.body["courseId"],
      "groupId": params.body["groupId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/rechoose 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/choices/rechoose 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/choices/rechoose 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/choices/rechoose 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/choices/rechoose 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentChoicesRechoose"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/choices/rechoose XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteStudentChoicesRechooseParams {
  readonly "body": {
    readonly "courseId": IDString
    readonly "groupId": IDString
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type deleteStudentChoicesRechooseOk = MessageObject

export type deleteStudentChoicesRechooseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteStudentChoicesRechoose (params: deleteStudentChoicesRechooseParams): Promise<deleteStudentChoicesRechooseOk> {
  const url = "/student/choices/rechoose"
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "courseId": params.body["courseId"],
      "groupId": params.body["groupId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /student/choices/rechoose 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /student/choices/rechoose 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /student/choices/rechoose 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /student/choices/rechoose 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /student/choices/rechoose 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteStudentChoicesRechoose"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /student/choices/rechoose XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentSchedulesCurrentParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentSchedulesCurrentOk = readonly ScheduleDay[]

export type getStudentSchedulesCurrentErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentSchedulesCurrent (params: getStudentSchedulesCurrentParams): Promise<getStudentSchedulesCurrentOk> {
  const url = "/student/schedules/current"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ScheduleDay[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ScheduleDayDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ScheduleDay[]>(result.value)
    } else {
      console.error(
        'GET /student/schedules/current 2XX readonly ScheduleDay[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/schedules/current 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/schedules/current 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/schedules/current 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/schedules/current 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentSchedulesCurrent"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/schedules/current XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCardParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentCardOk = Card

export type getStudentCardErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCard (params: getStudentCardParams): Promise<getStudentCardOk> {
  const url = "/student/card"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Card
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CardDecoder).decode(data)
    if (result.ok) {
      return identity<Card>(result.value)
    } else {
      console.error(
        'GET /student/card 2XX Card\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/card 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/card 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/card 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/card 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCard"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/card XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCardExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentCardExportOk = ExportFile

export type getStudentCardExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCardExport (params: getStudentCardExportParams): Promise<getStudentCardExportOk> {
  const url = "/student/card/export"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /student/card/export 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/card/export 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/card/export 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/card/export 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/card/export 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCardExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/card/export XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCalendarParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentCalendarOk = readonly CalendarItem[]

export type getStudentCalendarErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCalendar (params: getStudentCalendarParams): Promise<getStudentCalendarOk> {
  const url = "/student/calendar"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly CalendarItem[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CalendarItemDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly CalendarItem[]>(result.value)
    } else {
      console.error(
        'GET /student/calendar 2XX readonly CalendarItem[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/calendar 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/calendar 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/calendar 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/calendar 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCalendar"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/calendar XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentCourseOk = Course

export type getStudentCourseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourse (params: getStudentCourseParams): Promise<getStudentCourseOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Course
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CourseDecoder).decode(data)
    if (result.ok) {
      return identity<Course>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX Course\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourse"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseSyllabusParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentCourseSyllabusOk = CourseSyllabus

export type getStudentCourseSyllabusErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourseSyllabus (params: getStudentCourseSyllabusParams): Promise<getStudentCourseSyllabusOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/syllabus"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CourseSyllabus
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CourseSyllabusDecoder).decode(data)
    if (result.ok) {
      return identity<CourseSyllabus>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX CourseSyllabus\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourseSyllabus"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseGroupsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentCourseGroupsOk = readonly Group[]

export type getStudentCourseGroupsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourseGroups (params: getStudentCourseGroupsParams): Promise<getStudentCourseGroupsOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/groups"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Group[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(GroupDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Group[]>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX readonly Group[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourseGroups"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseClassmatesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentCourseClassmatesOk = readonly User[]

export type getStudentCourseClassmatesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourseClassmates (params: getStudentCourseClassmatesParams): Promise<getStudentCourseClassmatesOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/classmates"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly User[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UserDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly User[]>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX readonly User[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourseClassmates"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseGroupScheduleParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": string
  }
}

export interface getStudentCourseGroupScheduleOk {
  readonly "data": readonly GroupSchedule[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentCourseGroupScheduleErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourseGroupSchedule (params: getStudentCourseGroupScheduleParams): Promise<getStudentCourseGroupScheduleOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/schedule"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly GroupSchedule[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(GroupScheduleDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly GroupSchedule[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX {\n' +
        '  readonly "data": readonly GroupSchedule[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourseGroupSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseGroupWeekScheduleParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "groupId": string
  }
}

export type getStudentCourseGroupWeekScheduleOk = readonly GroupSchedule[]

export type getStudentCourseGroupWeekScheduleErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourseGroupWeekSchedule (params: getStudentCourseGroupWeekScheduleParams): Promise<getStudentCourseGroupWeekScheduleOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/groups/"
  url += params.args["groupId"]
  url += "/week-schedule"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly GroupSchedule[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(GroupScheduleDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly GroupSchedule[]>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX readonly GroupSchedule[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourseGroupWeekSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCourseScoresParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentCourseScoresOk = Choice

export type getStudentCourseScoresErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCourseScores (params: getStudentCourseScoresParams): Promise<getStudentCourseScoresOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/scores"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Choice
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ChoiceDecoder).decode(data)
    if (result.ok) {
      return identity<Choice>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX Choice\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCourseScores"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCoursesMaterialsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
    }
    readonly "page": number
    readonly "perPage": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getStudentCoursesMaterialsOk {
  readonly "data": readonly CourseFile[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentCoursesMaterialsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCoursesMaterials (params: getStudentCoursesMaterialsParams): Promise<getStudentCoursesMaterialsOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/materials"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly CourseFile[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(CourseFileDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly CourseFile[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX {\n' +
        '  readonly "data": readonly CourseFile[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCoursesMaterials"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCoursePostsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentCoursePostsOk = readonly CoursePost[]

export type getStudentCoursePostsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCoursePosts (params: getStudentCoursePostsParams): Promise<getStudentCoursePostsOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/posts"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly CoursePost[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CoursePostDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly CoursePost[]>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX readonly CoursePost[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCoursePosts"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCoursePostCommentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export type getStudentCoursePostCommentsOk = readonly CoursePostComment[]

export type getStudentCoursePostCommentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCoursePostComments (params: getStudentCoursePostCommentsParams): Promise<getStudentCoursePostCommentsOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/posts/"
  url += params.args["postId"]
  url += "/comments"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly CoursePostComment[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CoursePostCommentDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly CoursePostComment[]>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX readonly CoursePostComment[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCoursePostComments"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentCoursesPostsCommentsParams {
  readonly "body": {
    readonly "replyCommentId"?: string
    readonly "body": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export type postStudentCoursesPostsCommentsOk = CoursePostComment

export type postStudentCoursesPostsCommentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentCoursesPostsComments (params: postStudentCoursesPostsCommentsParams): Promise<postStudentCoursesPostsCommentsOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/posts/"
  url += params.args["postId"]
  url += "/comments/"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "replyCommentId": params.body["replyCommentId"],
      "body": params.body["body"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CoursePostComment
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CoursePostCommentDecoder).decode(data)
    if (result.ok) {
      return identity<CoursePostComment>(result.value)
    } else {
      console.error(
        'POST /student/courses/ 2XX CoursePostComment\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentCoursesPostsComments"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
      readonly "semester": null | string
    }
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getStudentStatementsOk {
  readonly "data": readonly Statement[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentStatementsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatements (params: getStudentStatementsParams): Promise<getStudentStatementsOk> {
  const url = "/student/statements"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Statement[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(StatementDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Statement[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/statements 2XX {\n' +
        '  readonly "data": readonly Statement[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatements"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "semId": string
  }
}

export type getStudentStatementOk = Statement

export type getStudentStatementErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatement (params: getStudentStatementParams): Promise<getStudentStatementOk> {
  let url = "/student/statements/"
  url += params.args["id"]
  url += "/"
  url += params.args["semId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Statement
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(StatementDecoder).decode(data)
    if (result.ok) {
      return identity<Statement>(result.value)
    } else {
      console.error(
        'GET /student/statements/ 2XX Statement\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatement"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getFaqQuestionsParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "search": null | string
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getFaqQuestionsOk {
  readonly "data": readonly Faq[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getFaqQuestionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getFaqQuestions (params: getFaqQuestionsParams): Promise<getFaqQuestionsOk> {
  const url = "/faq/questions"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Faq[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(FaqDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Faq[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /faq/questions 2XX {\n' +
        '  readonly "data": readonly Faq[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /faq/questions 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /faq/questions 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /faq/questions 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /faq/questions 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getFaqQuestions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /faq/questions XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getFaqQuestionParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getFaqQuestionOk {
  readonly "data": Faq
}

export type getFaqQuestionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getFaqQuestion (params: getFaqQuestionParams): Promise<getFaqQuestionOk> {
  let url = "/faq/questions/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": Faq
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": FaqDecoder,
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": Faq
      }>(result.value)
    } else {
      console.error(
        'GET /faq/questions/ 2XX {\n' +
        '  readonly "data": Faq\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /faq/questions/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /faq/questions/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /faq/questions/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /faq/questions/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getFaqQuestion"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /faq/questions/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerCalendarParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "date": string
    readonly "courseId": IDString
    readonly "groupId": IDString
    readonly "criteriaId"?: IDString
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postLecturerCalendarOk = null

export type postLecturerCalendarErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerCalendar (params: postLecturerCalendarParams): Promise<postLecturerCalendarOk> {
  const url = "/lecturer/calendar"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "date": params.body["date"],
      "courseId": params.body["courseId"],
      "groupId": params.body["groupId"],
      "criteriaId": params.body["criteriaId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/calendar 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/calendar 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/calendar 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/calendar 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/calendar 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerCalendar"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/calendar XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCalendarParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerCalendarOk = readonly CalendarItem[]

export type getLecturerCalendarErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCalendar (params: getLecturerCalendarParams): Promise<getLecturerCalendarOk> {
  const url = "/lecturer/calendar"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly CalendarItem[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CalendarItemDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly CalendarItem[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/calendar 2XX readonly CalendarItem[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/calendar 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/calendar 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/calendar 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/calendar 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCalendar"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/calendar XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteLecturerCalendarParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type deleteLecturerCalendarOk = MessageObject

export type deleteLecturerCalendarErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteLecturerCalendar (params: deleteLecturerCalendarParams): Promise<deleteLecturerCalendarOk> {
  let url = "/lecturer/calendar/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/calendar/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/calendar/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/calendar/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/calendar/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/calendar/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteLecturerCalendar"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/calendar/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getCoursesLecturersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getCoursesLecturersOk = readonly User[]

export type getCoursesLecturersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getCoursesLecturers (params: getCoursesLecturersParams): Promise<getCoursesLecturersOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/my-groups-lecturers"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly User[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UserDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly User[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly User[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getCoursesLecturers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesMaterialsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "author": null | string
      readonly "search": null | string
    }
    readonly "page": null | string
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getLecturerCoursesMaterialsOk {
  readonly "data": readonly CourseFile[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getLecturerCoursesMaterialsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesMaterials (params: getLecturerCoursesMaterialsParams): Promise<getLecturerCoursesMaterialsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/materials"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly CourseFile[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(CourseFileDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly CourseFile[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX {\n' +
        '  readonly "data": readonly CourseFile[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesMaterials"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerCoursesMaterialsParams {
  readonly "body": {
    readonly "semId": string
    readonly "title": string
    readonly "url": null | string
    readonly "fileUid": null | string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postLecturerCoursesMaterialsOk = null

export type postLecturerCoursesMaterialsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerCoursesMaterials (params: postLecturerCoursesMaterialsParams): Promise<postLecturerCoursesMaterialsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/materials"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "title": params.body["title"],
      "url": params.body["url"],
      "fileUid": params.body["fileUid"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerCoursesMaterials"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchLecturerCoursesMaterialsParams {
  readonly "body": {
    readonly "semId": string
    readonly "title": string
    readonly "url": null | string
    readonly "fileUid": null | string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "fileId": string
  }
}

export type patchLecturerCoursesMaterialsOk = null

export type patchLecturerCoursesMaterialsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchLecturerCoursesMaterials (params: patchLecturerCoursesMaterialsParams): Promise<patchLecturerCoursesMaterialsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/materials/"
  url += params.args["fileId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "title": params.body["title"],
      "url": params.body["url"],
      "fileUid": params.body["fileUid"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchLecturerCoursesMaterials"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteLecturerCoursesMaterialsParams {
  readonly "body": {
    readonly "semId": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "fileId": string
  }
}

export type deleteLecturerCoursesMaterialsOk = MessageObject

export type deleteLecturerCoursesMaterialsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteLecturerCoursesMaterials (params: deleteLecturerCoursesMaterialsParams): Promise<deleteLecturerCoursesMaterialsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/materials/"
  url += params.args["fileId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteLecturerCoursesMaterials"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesMaterialParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
    readonly "fileId": string
  }
}

export type getLecturerCoursesMaterialOk = CourseFile

export type getLecturerCoursesMaterialErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesMaterial (params: getLecturerCoursesMaterialParams): Promise<getLecturerCoursesMaterialOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/materials/"
  url += params.args["fileId"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CourseFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CourseFileDecoder).decode(data)
    if (result.ok) {
      return identity<CourseFile>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX CourseFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesMaterial"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "courseId": string
    readonly "groupId": string
  }
}

export type getLecturerCoursesStudentsOk = readonly LecturerUser[]

export type getLecturerCoursesStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesStudents (params: getLecturerCoursesStudentsParams): Promise<getLecturerCoursesStudentsOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/"
  url += params.args["groupId"]
  url += "/students"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly LecturerUser[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(LecturerUserDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly LecturerUser[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly LecturerUser[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerSchedulesCurrentParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerSchedulesCurrentOk = readonly ScheduleDay[]

export type getLecturerSchedulesCurrentErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerSchedulesCurrent (params: getLecturerSchedulesCurrentParams): Promise<getLecturerSchedulesCurrentOk> {
  const url = "/lecturer/schedules/current"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ScheduleDay[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ScheduleDayDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ScheduleDay[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/schedules/current 2XX readonly ScheduleDay[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/schedules/current 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/schedules/current 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/schedules/current 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/schedules/current 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerSchedulesCurrent"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/schedules/current XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesTeachesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
}

export type getLecturerCoursesTeachesOk = readonly Course[]

export type getLecturerCoursesTeachesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesTeaches (params: getLecturerCoursesTeachesParams): Promise<getLecturerCoursesTeachesOk> {
  const url = "/lecturer/courses/teaches"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Course[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CourseDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Course[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches 2XX readonly Course[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesTeaches"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/teaches XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesManageParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
}

export type getLecturerCoursesManageOk = readonly Course[]

export type getLecturerCoursesManageErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesManage (params: getLecturerCoursesManageParams): Promise<getLecturerCoursesManageOk> {
  const url = "/lecturer/courses/manage"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Course[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CourseDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Course[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage 2XX readonly Course[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesManage"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/manage XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerFeedbacksSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerFeedbacksSemestersOk = readonly Semester[]

export type getLecturerFeedbacksSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerFeedbacksSemesters (params: getLecturerFeedbacksSemestersParams): Promise<getLecturerFeedbacksSemestersOk> {
  const url = "/lecturer/feedbacks/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/semesters 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerFeedbacksSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerFeedbacksSubjectsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerFeedbacksSubjectsOk = readonly FeedbackSubject[]

export type getLecturerFeedbacksSubjectsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerFeedbacksSubjects (params: getLecturerFeedbacksSubjectsParams): Promise<getLecturerFeedbacksSubjectsOk> {
  const url = "/lecturer/feedbacks/subjects"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly FeedbackSubject[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FeedbackSubjectDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly FeedbackSubject[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/subjects 2XX readonly FeedbackSubject[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/subjects 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/subjects 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/subjects 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/subjects 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerFeedbacksSubjects"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/subjects XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerFeedbacksParams {
  readonly "body": {
    readonly "subjectId": IDString
    readonly "text": IDString
    readonly "files": readonly string[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postLecturerFeedbacksOk = null

export type postLecturerFeedbacksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerFeedbacks (params: postLecturerFeedbacksParams): Promise<postLecturerFeedbacksOk> {
  const url = "/lecturer/feedbacks"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "subjectId": params.body["subjectId"],
      "text": params.body["text"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/feedbacks 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/feedbacks 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/feedbacks 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/feedbacks 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/feedbacks 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerFeedbacks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/feedbacks XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerFeedbackParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type getLecturerFeedbackOk = Feedback

export type getLecturerFeedbackErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerFeedback (params: getLecturerFeedbackParams): Promise<getLecturerFeedbackOk> {
  let url = "/lecturer/feedbacks/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Feedback
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(FeedbackDecoder).decode(data)
    if (result.ok) {
      return identity<Feedback>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/ 2XX Feedback\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerFeedback"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerFeedbacksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "semId": string
  }
}

export interface getLecturerFeedbacksOk {
  readonly "data": readonly Feedback[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getLecturerFeedbacksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerFeedbacks (params: getLecturerFeedbacksParams): Promise<getLecturerFeedbacksOk> {
  const url = "/lecturer/feedbacks"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Feedback[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(FeedbackDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Feedback[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks 2XX {\n' +
        '  readonly "data": readonly Feedback[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerFeedbacks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/feedbacks XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementsTemplatesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentStatementsTemplatesOk = readonly StatementTemplate[]

export type getStudentStatementsTemplatesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatementsTemplates (params: getStudentStatementsTemplatesParams): Promise<getStudentStatementsTemplatesOk> {
  const url = "/student/statements/templates"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly StatementTemplate[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(StatementTemplateDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly StatementTemplate[]>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates 2XX readonly StatementTemplate[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatementsTemplates"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementTemplateParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type getStudentStatementTemplateOk = StatementTemplateView

export type getStudentStatementTemplateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatementTemplate (params: getStudentStatementTemplateParams): Promise<getStudentStatementTemplateOk> {
  let url = "/student/statements/templates/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX StatementTemplateView
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(StatementTemplateViewDecoder).decode(data)
    if (result.ok) {
      return identity<StatementTemplateView>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates/ 2XX StatementTemplateView\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatementTemplate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements/templates/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementsSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentStatementsSemestersOk = readonly Semester[]

export type getStudentStatementsSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatementsSemesters (params: getStudentStatementsSemestersParams): Promise<getStudentStatementsSemestersOk> {
  const url = "/student/statements/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /student/statements/semesters 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements/semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements/semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements/semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements/semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatementsSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements/semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFeedbacksSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentFeedbacksSemestersOk = readonly Semester[]

export type getStudentFeedbacksSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFeedbacksSemesters (params: getStudentFeedbacksSemestersParams): Promise<getStudentFeedbacksSemestersOk> {
  const url = "/student/feedbacks/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/semesters 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFeedbacksSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementsFacultiesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentStatementsFacultiesOk = readonly Faculty[]

export type getStudentStatementsFacultiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatementsFaculties (params: getStudentStatementsFacultiesParams): Promise<getStudentStatementsFacultiesOk> {
  const url = "/student/statements/faculties"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Faculty[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FacultyDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Faculty[]>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties 2XX readonly Faculty[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatementsFaculties"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentStatementsFacultiesProgramsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type getStudentStatementsFacultiesProgramsOk = readonly Program[]

export type getStudentStatementsFacultiesProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentStatementsFacultiesPrograms (params: getStudentStatementsFacultiesProgramsParams): Promise<getStudentStatementsFacultiesProgramsOk> {
  let url = "/student/statements/faculties/"
  url += params.args["id"]
  url += "/programs"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Program[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ProgramDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Program[]>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties/ 2XX readonly Program[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentStatementsFacultiesPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/statements/faculties/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentStatementsParams {
  readonly "body": {
    readonly "template": StatementTemplateRequest
    readonly "files": readonly string[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentStatementsOk = null

export type postStudentStatementsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentStatements (params: postStudentStatementsParams): Promise<postStudentStatementsOk> {
  const url = "/student/statements"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "template": params.body["template"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/statements 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/statements 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/statements 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/statements 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/statements 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentStatements"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/statements XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentCoursesCatalogParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters[search]": string
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getStudentCoursesCatalogOk {
  readonly "data": readonly Course[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentCoursesCatalogErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentCoursesCatalog (params: getStudentCoursesCatalogParams): Promise<getStudentCoursesCatalogOk> {
  const url = "/student/courses/catalog"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Course[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(CourseDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Course[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/courses/catalog 2XX {\n' +
        '  readonly "data": readonly Course[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/catalog 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/catalog 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/catalog 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/catalog 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentCoursesCatalog"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/catalog XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLibraryBooksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getLibraryBooksOk {
  readonly "data": readonly LibraryBook[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getLibraryBooksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLibraryBooks (params: getLibraryBooksParams): Promise<getLibraryBooksOk> {
  const url = "/library/books"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly LibraryBook[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(LibraryBookDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly LibraryBook[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /library/books 2XX {\n' +
        '  readonly "data": readonly LibraryBook[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /library/books 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /library/books 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /library/books 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /library/books 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLibraryBooks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /library/books XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLibraryBooksTakenParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLibraryBooksTakenOk = LibraryBooksTaken

export type getLibraryBooksTakenErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLibraryBooksTaken (params: getLibraryBooksTakenParams): Promise<getLibraryBooksTakenOk> {
  const url = "/library/books-taken"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX LibraryBooksTaken
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(LibraryBooksTakenDecoder).decode(data)
    if (result.ok) {
      return identity<LibraryBooksTaken>(result.value)
    } else {
      console.error(
        'GET /library/books-taken 2XX LibraryBooksTaken\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /library/books-taken 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /library/books-taken 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /library/books-taken 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /library/books-taken 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLibraryBooksTaken"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /library/books-taken XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentBillingBalanceParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentBillingBalanceOk = BillingBalance

export type getStudentBillingBalanceErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentBillingBalance (params: getStudentBillingBalanceParams): Promise<getStudentBillingBalanceOk> {
  const url = "/student/billing/balance"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX BillingBalance
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(BillingBalanceDecoder).decode(data)
    if (result.ok) {
      return identity<BillingBalance>(result.value)
    } else {
      console.error(
        'GET /student/billing/balance 2XX BillingBalance\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/billing/balance 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/billing/balance 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/billing/balance 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/billing/balance 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentBillingBalance"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/billing/balance XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentBillingInstructionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentBillingInstructionsOk = PaymentInstruction

export type getStudentBillingInstructionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentBillingInstructions (params: getStudentBillingInstructionsParams): Promise<getStudentBillingInstructionsOk> {
  const url = "/student/billing/instructions"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX PaymentInstruction
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(PaymentInstructionDecoder).decode(data)
    if (result.ok) {
      return identity<PaymentInstruction>(result.value)
    } else {
      console.error(
        'GET /student/billing/instructions 2XX PaymentInstruction\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/billing/instructions 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/billing/instructions 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/billing/instructions 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/billing/instructions 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentBillingInstructions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/billing/instructions XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentBillingDepositsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentBillingDepositsOk = readonly BillingDeposit[]

export type getStudentBillingDepositsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentBillingDeposits (params: getStudentBillingDepositsParams): Promise<getStudentBillingDepositsOk> {
  const url = "/student/billing/deposits"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly BillingDeposit[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(BillingDepositDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly BillingDeposit[]>(result.value)
    } else {
      console.error(
        'GET /student/billing/deposits 2XX readonly BillingDeposit[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/billing/deposits 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/billing/deposits 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/billing/deposits 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/billing/deposits 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentBillingDeposits"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/billing/deposits XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentBillingScheduleParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentBillingScheduleOk = readonly BillingSchedule[]

export type getStudentBillingScheduleErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentBillingSchedule (params: getStudentBillingScheduleParams): Promise<getStudentBillingScheduleOk> {
  const url = "/student/billing/schedule"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly BillingSchedule[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(BillingScheduleDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly BillingSchedule[]>(result.value)
    } else {
      console.error(
        'GET /student/billing/schedule 2XX readonly BillingSchedule[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/billing/schedule 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/billing/schedule 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/billing/schedule 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/billing/schedule 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentBillingSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/billing/schedule XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserSettingsGeneralParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getUserSettingsGeneralOk = GeneralSettings

export type getUserSettingsGeneralErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUserSettingsGeneral (params: getUserSettingsGeneralParams): Promise<getUserSettingsGeneralOk> {
  const url = "/user/settings/general"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX GeneralSettings
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(GeneralSettingsDecoder).decode(data)
    if (result.ok) {
      return identity<GeneralSettings>(result.value)
    } else {
      console.error(
        'GET /user/settings/general 2XX GeneralSettings\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /user/settings/general 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /user/settings/general 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /user/settings/general 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /user/settings/general 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUserSettingsGeneral"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /user/settings/general XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putUserSettingsGeneralParams {
  readonly "body": {
    readonly "locale": LanguageString
    readonly "showMail": boolean
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type putUserSettingsGeneralOk = null

export type putUserSettingsGeneralErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putUserSettingsGeneral (params: putUserSettingsGeneralParams): Promise<putUserSettingsGeneralOk> {
  const url = "/user/settings/general"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "locale": params.body["locale"],
      "showMail": params.body["showMail"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /user/settings/general 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /user/settings/general 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /user/settings/general 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /user/settings/general 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /user/settings/general 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putUserSettingsGeneral"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /user/settings/general XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserSettingsNotificationsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getUserSettingsNotificationsOk = NotificationSettings

export type getUserSettingsNotificationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUserSettingsNotifications (params: getUserSettingsNotificationsParams): Promise<getUserSettingsNotificationsOk> {
  const url = "/user/settings/notifications"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX NotificationSettings
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(NotificationSettingsDecoder).decode(data)
    if (result.ok) {
      return identity<NotificationSettings>(result.value)
    } else {
      console.error(
        'GET /user/settings/notifications 2XX NotificationSettings\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /user/settings/notifications 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /user/settings/notifications 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /user/settings/notifications 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /user/settings/notifications 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUserSettingsNotifications"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /user/settings/notifications XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putUserSettingsNotificationsParams {
  readonly "body": {
    readonly "notifyOnMessage": NotificationsData
    readonly "notifyOnLectureStarts": NotificationsData
    readonly "notifyOnScoreSave": NotificationsData
    readonly "notifyOnNewsAdd": NotificationsData
    readonly "notifyOnMaterialAdd": NotificationsData
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type putUserSettingsNotificationsOk = null

export type putUserSettingsNotificationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putUserSettingsNotifications (params: putUserSettingsNotificationsParams): Promise<putUserSettingsNotificationsOk> {
  const url = "/user/settings/notifications"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "notifyOnMessage": params.body["notifyOnMessage"],
      "notifyOnLectureStarts": params.body["notifyOnLectureStarts"],
      "notifyOnScoreSave": params.body["notifyOnScoreSave"],
      "notifyOnNewsAdd": params.body["notifyOnNewsAdd"],
      "notifyOnMaterialAdd": params.body["notifyOnMaterialAdd"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /user/settings/notifications 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /user/settings/notifications 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /user/settings/notifications 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /user/settings/notifications 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /user/settings/notifications 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putUserSettingsNotifications"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /user/settings/notifications XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserAuthLogParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getUserAuthLogOk {
  readonly "data": readonly AuthLog[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getUserAuthLogErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUserAuthLog (params: getUserAuthLogParams): Promise<getUserAuthLogOk> {
  const url = "/user/auth-log"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AuthLog[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AuthLogDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AuthLog[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /user/auth-log 2XX {\n' +
        '  readonly "data": readonly AuthLog[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /user/auth-log 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /user/auth-log 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /user/auth-log 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /user/auth-log 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUserAuthLog"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /user/auth-log XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserSemestersAvailableParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getUserSemestersAvailableOk = readonly Semester[]

export type getUserSemestersAvailableErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUserSemestersAvailable (params: getUserSemestersAvailableParams): Promise<getUserSemestersAvailableOk> {
  const url = "/user/semesters/available"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /user/semesters/available 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /user/semesters/available 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /user/semesters/available 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /user/semesters/available 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /user/semesters/available 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUserSemestersAvailable"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /user/semesters/available XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getSemestersOk = readonly Semester[]

export type getSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getSemesters (params: getSemestersParams): Promise<getSemestersOk> {
  const url = "/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Semester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Semester[]>(result.value)
    } else {
      console.error(
        'GET /semesters 2XX readonly Semester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorRegimesSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorRegimesSemestersOk = readonly number[]

export type getAdministratorRegimesSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorRegimesSemesters (params: getAdministratorRegimesSemestersParams): Promise<getAdministratorRegimesSemestersOk> {
  const url = "/administrator/regimes/semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly number[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(decoders.number)).decode(data)
    if (result.ok) {
      return identity<readonly number[]>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/semesters 2XX readonly number[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorRegimesSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/regimes/semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserStateParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getUserStateOk = UserState

export type getUserStateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUserState (params: getUserStateParams): Promise<getUserStateOk> {
  const url = "/user/state"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX UserState
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(UserStateDecoder).decode(data)
    if (result.ok) {
      return identity<UserState>(result.value)
    } else {
      console.error(
        'GET /user/state 2XX UserState\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /user/state 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /user/state 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /user/state 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /user/state 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUserState"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /user/state XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchUserPasswordParams {
  readonly "body": {
    readonly "currentPassword": string
    readonly "password": string
    readonly "passwordConfirmation": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type patchUserPasswordOk = null

export type patchUserPasswordErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchUserPassword (params: patchUserPasswordParams): Promise<patchUserPasswordOk> {
  const url = "/user/password"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "currentPassword": params.body["currentPassword"],
      "password": params.body["password"],
      "passwordConfirmation": params.body["passwordConfirmation"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /user/password 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /user/password 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /user/password 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /user/password 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /user/password 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchUserPassword"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /user/password XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchUserContactParams {
  readonly "body": {
    readonly "mobileNumber": string
    readonly "mobileNumber2": string
    readonly "homeNumber": string
    readonly "actualAddress": string
    readonly "emailPersonal": null | string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type patchUserContactOk = null

export type patchUserContactErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchUserContact (params: patchUserContactParams): Promise<patchUserContactOk> {
  const url = "/user/contact"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "mobileNumber": params.body["mobileNumber"],
      "mobileNumber2": params.body["mobileNumber2"],
      "homeNumber": params.body["homeNumber"],
      "actualAddress": params.body["actualAddress"],
      "emailPersonal": params.body["emailPersonal"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /user/contact 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /user/contact 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /user/contact 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /user/contact 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /user/contact 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchUserContact"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /user/contact XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getUserParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
  }
}

export type getUserOk = User

export type getUserErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getUser (params: getUserParams): Promise<getUserOk> {
  let url = "/users/"
  url += params.args["uid"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX User
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(UserDecoder).decode(data)
    if (result.ok) {
      return identity<User>(result.value)
    } else {
      console.error(
        'GET /users/ 2XX User\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getUser"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMessagesInboxParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "filters": {
      readonly "search": null | string
    }
    readonly "semId": IDString
  }
}

export interface getMessagesInboxOk {
  readonly "data": readonly Message[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getMessagesInboxErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getMessagesInbox (params: getMessagesInboxParams): Promise<getMessagesInboxOk> {
  const url = "/messages/inbox"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Message[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(MessageDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Message[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /messages/inbox 2XX {\n' +
        '  readonly "data": readonly Message[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /messages/inbox 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /messages/inbox 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /messages/inbox 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /messages/inbox 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMessagesInbox"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /messages/inbox XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMessagesOutboxParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "filters": {
      readonly "search": null | string
    }
    readonly "semId": IDString
  }
}

export interface getMessagesOutboxOk {
  readonly "data": readonly Message[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getMessagesOutboxErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getMessagesOutbox (params: getMessagesOutboxParams): Promise<getMessagesOutboxOk> {
  const url = "/messages/outbox"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Message[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(MessageDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Message[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /messages/outbox 2XX {\n' +
        '  readonly "data": readonly Message[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /messages/outbox 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /messages/outbox 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /messages/outbox 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /messages/outbox 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMessagesOutbox"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /messages/outbox XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMessageParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "messageId": string
  }
}

export type getMessageOk = Message

export type getMessageErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getMessage (params: getMessageParams): Promise<getMessageOk> {
  let url = "/messages/"
  url += params.args["messageId"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Message
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageDecoder).decode(data)
    if (result.ok) {
      return identity<Message>(result.value)
    } else {
      console.error(
        'GET /messages/ 2XX Message\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /messages/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /messages/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /messages/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /messages/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMessage"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /messages/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentByMessageParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "messageId": string
  }
}

export type getStudentByMessageOk = LecturerUser

export type getStudentByMessageErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentByMessage (params: getStudentByMessageParams): Promise<getStudentByMessageOk> {
  let url = "/lecturer/students/"
  url += params.args["messageId"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX LecturerUser
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(LecturerUserDecoder).decode(data)
    if (result.ok) {
      return identity<LecturerUser>(result.value)
    } else {
      console.error(
        'GET /lecturer/students/ 2XX LecturerUser\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/students/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/students/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/students/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/students/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentByMessage"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/students/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRecommendationParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "senderProfileId": string
  }
}

export type getRecommendationOk = RecommendationLecturerSide

export type getRecommendationErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRecommendation (params: getRecommendationParams): Promise<getRecommendationOk> {
  let url = "/lecturer/recommendations/"
  url += params.args["senderProfileId"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX RecommendationLecturerSide
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RecommendationLecturerSideDecoder).decode(data)
    if (result.ok) {
      return identity<RecommendationLecturerSide>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 2XX RecommendationLecturerSide\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRecommendation"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRecommendationStudentInfoParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "senderProfileId": string
  }
}

export type getRecommendationStudentInfoOk = RecommendationStudentInfo

export type getRecommendationStudentInfoErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRecommendationStudentInfo (params: getRecommendationStudentInfoParams): Promise<getRecommendationStudentInfoOk> {
  let url = "/lecturer/recommendations/"
  url += params.args["senderProfileId"]
  url += "/student"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX RecommendationStudentInfo
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RecommendationStudentInfoDecoder).decode(data)
    if (result.ok) {
      return identity<RecommendationStudentInfo>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 2XX RecommendationStudentInfo\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRecommendationStudentInfo"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/recommendations/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMessagesUnreadCountParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getMessagesUnreadCountOk = MessageUnreadCount

export type getMessagesUnreadCountErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getMessagesUnreadCount (params: getMessagesUnreadCountParams): Promise<getMessagesUnreadCountOk> {
  const url = "/messages/unread-count"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageUnreadCount
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageUnreadCountDecoder).decode(data)
    if (result.ok) {
      return identity<MessageUnreadCount>(result.value)
    } else {
      console.error(
        'GET /messages/unread-count 2XX MessageUnreadCount\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /messages/unread-count 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /messages/unread-count 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /messages/unread-count 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /messages/unread-count 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMessagesUnreadCount"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /messages/unread-count XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMessagesExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type getMessagesExportOk = ExportFile

export type getMessagesExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getMessagesExport (params: getMessagesExportParams): Promise<getMessagesExportOk> {
  let url = "/messages/"
  url += params.args["id"]
  url += "/export"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /messages/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /messages/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /messages/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /messages/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /messages/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMessagesExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /messages/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postMessagesToStudentsParams {
  readonly "body": {
    readonly "students": readonly string[]
    readonly "body": string
    readonly "subject": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "courseId": IDString
  }
}

export type postMessagesToStudentsOk = null

export type postMessagesToStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postMessagesToStudents (params: postMessagesToStudentsParams): Promise<postMessagesToStudentsOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/message/students"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "students": params.body["students"],
      "body": params.body["body"],
      "subject": params.body["subject"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postMessagesToStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postMessagesToGroupsParams {
  readonly "body": {
    readonly "groups": readonly string[]
    readonly "body": string
    readonly "subject": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "courseId": IDString
  }
}

export type postMessagesToGroupsOk = null

export type postMessagesToGroupsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postMessagesToGroups (params: postMessagesToGroupsParams): Promise<postMessagesToGroupsOk> {
  let url = "/lecturer/courses/"
  url += params.args["courseId"]
  url += "/teaching-groups/message/groups"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "groups": params.body["groups"],
      "body": params.body["body"],
      "subject": params.body["subject"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postMessagesToGroups"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postMessagesParams {
  readonly "body": {
    readonly "subject": string
    readonly "body": string
    readonly "replyMsgId"?: IDString
    readonly "replyMsgSemId"?: IDString
    readonly "recipients": readonly string[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postMessagesOk = null

export type postMessagesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postMessages (params: postMessagesParams): Promise<postMessagesOk> {
  const url = "/messages"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "subject": params.body["subject"],
      "body": params.body["body"],
      "replyMsgId": params.body["replyMsgId"],
      "replyMsgSemId": params.body["replyMsgSemId"],
      "recipients": params.body["recipients"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /messages 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /messages 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /messages 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /messages 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /messages 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postMessages"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /messages XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerRecommendationsParams {
  readonly "body": {
    readonly "text": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "senderProfileId": string
  }
}

export type postLecturerRecommendationsOk = null

export type postLecturerRecommendationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerRecommendations (params: postLecturerRecommendationsParams): Promise<postLecturerRecommendationsOk> {
  let url = "/lecturer/recommendations/"
  url += params.args["senderProfileId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "text": params.body["text"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/recommendations/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/recommendations/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/recommendations/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/recommendations/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/recommendations/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerRecommendations"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/recommendations/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorUsersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
      readonly "degree": null | string
    }
    readonly "sortBy": string
    readonly "page": string
    readonly "perPage": string
  }
}

export type getAdministratorUsersOk = {
  readonly "data": readonly AdministratorUser[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
} | null

export type getAdministratorUsersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorUsers (params: getAdministratorUsersParams): Promise<getAdministratorUsersOk> {
  const url = "/administrator/users"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorUser[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorUserDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorUser[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/users 2XX {\n' +
        '  readonly "data": readonly AdministratorUser[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'GET /administrator/users 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorUsers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorAdministratorUsersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
      readonly "degree": null | string
    }
    readonly "sortBy": string
    readonly "page": string
    readonly "perPage": string
  }
}

export type getAdministratorAdministratorUsersOk = {
  readonly "data": readonly AdministratorUser[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
} | null

export type getAdministratorAdministratorUsersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorAdministratorUsers (params: getAdministratorAdministratorUsersParams): Promise<getAdministratorAdministratorUsersOk> {
  const url = "/administrator/users/administrator"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorUser[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorUserDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorUser[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator 2XX {\n' +
        '  readonly "data": readonly AdministratorUser[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorAdministratorUsers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/administrator XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorLecturerUsersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
      readonly "degree": null | string
    }
    readonly "sortBy": string
    readonly "page": string
    readonly "perPage": string
  }
}

export type getAdministratorLecturerUsersOk = {
  readonly "data": readonly AdministratorUser[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
} | null

export type getAdministratorLecturerUsersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorLecturerUsers (params: getAdministratorLecturerUsersParams): Promise<getAdministratorLecturerUsersOk> {
  const url = "/administrator/users/lecturer"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorUser[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorUserDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorUser[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer 2XX {\n' +
        '  readonly "data": readonly AdministratorUser[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorLecturerUsers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentUsersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "search": null | string
      readonly "degree": null | string
      readonly "semId": null | string
      readonly "facId": null | string
      readonly "minorFacId": null | string
      readonly "status": null | string
      readonly "userSem": null | string
    }
    readonly "sortBy": string
    readonly "page": string
    readonly "perPage": string
  }
}

export type getAdministratorStudentUsersOk = {
  readonly "data": readonly AdministratorUser[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
} | null

export type getAdministratorStudentUsersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentUsers (params: getAdministratorStudentUsersParams): Promise<getAdministratorStudentUsersOk> {
  const url = "/administrator/users/student"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorUser[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorUserDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorUser[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student 2XX {\n' +
        '  readonly "data": readonly AdministratorUser[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentUsers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/student XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "targetSemesterId"?: number
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type getAdministratorStudentChoicesOk = AdministratorStudentChoicesPage

export type getAdministratorStudentChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentChoices (params: getAdministratorStudentChoicesParams): Promise<getAdministratorStudentChoicesOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStudentChoicesPage
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStudentChoicesPageDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStudentChoicesPage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 2XX AdministratorStudentChoicesPage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentChoiceCoursesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "q"?: string
    readonly "targetSemesterId"?: number
    readonly "facultyId"?: number
    readonly "creditType"?: number
    readonly "general"?: number
    readonly "limit"?: number
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type getAdministratorStudentChoiceCoursesOk = AdministratorStudentChoiceCoursesPage

export type getAdministratorStudentChoiceCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentChoiceCourses (params: getAdministratorStudentChoiceCoursesParams): Promise<getAdministratorStudentChoiceCoursesOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/courses"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStudentChoiceCoursesPage
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStudentChoiceCoursesPageDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStudentChoiceCoursesPage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 2XX AdministratorStudentChoiceCoursesPage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentChoiceCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorStudentChoiceParams {
  readonly "body": {
    readonly "courseId": number
    readonly "targetSemesterId"?: number
    readonly "creditType"?: number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type postAdministratorStudentChoiceOk = AdministratorChoiceCreateResponse

export type postAdministratorStudentChoiceErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorStudentChoice (params: postAdministratorStudentChoiceParams): Promise<postAdministratorStudentChoiceOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "courseId": params.body["courseId"],
      "targetSemesterId": params.body["targetSemesterId"],
      "creditType": params.body["creditType"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceCreateResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceCreateResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceCreateResponse>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 2XX AdministratorChoiceCreateResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorStudentChoice"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorStudentChoiceHistoryParams {
  readonly "body": {
    readonly "courseId": number
    readonly "targetSemesterId": number
    readonly "score"?: number
    readonly "credits"?: number
    readonly "creditType"?: number
    readonly "latScore"?: string
    readonly "latScore2"?: string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type postAdministratorStudentChoiceHistoryOk = AdministratorChoiceHistoryResource

export type postAdministratorStudentChoiceHistoryErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorStudentChoiceHistory (params: postAdministratorStudentChoiceHistoryParams): Promise<postAdministratorStudentChoiceHistoryOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/history"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "courseId": params.body["courseId"],
      "targetSemesterId": params.body["targetSemesterId"],
      "score": params.body["score"],
      "credits": params.body["credits"],
      "creditType": params.body["creditType"],
      "latScore": params.body["latScore"],
      "latScore2": params.body["latScore2"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceHistoryResource
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceHistoryResourceDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceHistoryResource>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 2XX AdministratorChoiceHistoryResource\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorStudentChoiceHistory"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchAdministratorStudentChoiceParams {
  readonly "body": {
    readonly "targetSemesterId": number
    readonly "couName"?: string
    readonly "couCode"?: string
    readonly "couGeneral"?: number
    readonly "general"?: number
    readonly "couCredits"?: number
    readonly "credits"?: number
    readonly "score"?: number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
    readonly "choiceUid": string
  }
}

export type patchAdministratorStudentChoiceOk = AdministratorChoiceUpdateResource

export type patchAdministratorStudentChoiceErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchAdministratorStudentChoice (params: patchAdministratorStudentChoiceParams): Promise<patchAdministratorStudentChoiceOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/"
  url += params.args["choiceUid"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "targetSemesterId": params.body["targetSemesterId"],
      "couName": params.body["couName"],
      "couCode": params.body["couCode"],
      "couGeneral": params.body["couGeneral"],
      "general": params.body["general"],
      "couCredits": params.body["couCredits"],
      "credits": params.body["credits"],
      "score": params.body["score"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceUpdateResource
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceUpdateResourceDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceUpdateResource>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 2XX AdministratorChoiceUpdateResource\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchAdministratorStudentChoice"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAdministratorStudentChoiceParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "targetSemesterId": number
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
    readonly "choiceUid": string
  }
}

export type deleteAdministratorStudentChoiceOk = AdministratorChoiceDeleteResult

export type deleteAdministratorStudentChoiceErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAdministratorStudentChoice (params: deleteAdministratorStudentChoiceParams): Promise<deleteAdministratorStudentChoiceOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/"
  url += params.args["choiceUid"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceDeleteResult
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceDeleteResultDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceDeleteResult>(result.value)
    } else {
      console.error(
        'DELETE /administrator/users/ 2XX AdministratorChoiceDeleteResult\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAdministratorStudentChoice"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchAdministratorStudentChoiceDiscardParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "targetSemesterId": number
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
    readonly "choiceUid": string
  }
}

export type patchAdministratorStudentChoiceDiscardOk = AdministratorChoiceDiscardResult

export type patchAdministratorStudentChoiceDiscardErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchAdministratorStudentChoiceDiscard (params: patchAdministratorStudentChoiceDiscardParams): Promise<patchAdministratorStudentChoiceDiscardOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/"
  url += params.args["choiceUid"]
  url += "/discard"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceDiscardResult
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceDiscardResultDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceDiscardResult>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 2XX AdministratorChoiceDiscardResult\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchAdministratorStudentChoiceDiscard"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchAdministratorStudentChoiceUndiscardParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "targetSemesterId": number
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
    readonly "choiceUid": string
  }
}

export type patchAdministratorStudentChoiceUndiscardOk = AdministratorChoiceDiscardResult

export type patchAdministratorStudentChoiceUndiscardErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchAdministratorStudentChoiceUndiscard (params: patchAdministratorStudentChoiceUndiscardParams): Promise<patchAdministratorStudentChoiceUndiscardOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/"
  url += params.args["choiceUid"]
  url += "/undiscard"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceDiscardResult
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceDiscardResultDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceDiscardResult>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 2XX AdministratorChoiceDiscardResult\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchAdministratorStudentChoiceUndiscard"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentChoiceHistory3Params {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type getAdministratorStudentChoiceHistory3Ok = AdministratorStudentChoiceHistory3Page

export type getAdministratorStudentChoiceHistory3Err = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentChoiceHistory3 (params: getAdministratorStudentChoiceHistory3Params): Promise<getAdministratorStudentChoiceHistory3Ok> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/history3"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStudentChoiceHistory3Page
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStudentChoiceHistory3PageDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStudentChoiceHistory3Page>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 2XX AdministratorStudentChoiceHistory3Page\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentChoiceHistory3"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentChoiceHistory3ExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "mode"?: string
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type getAdministratorStudentChoiceHistory3ExportOk = ExportFile

export type getAdministratorStudentChoiceHistory3ExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentChoiceHistory3Export (params: getAdministratorStudentChoiceHistory3ExportParams): Promise<getAdministratorStudentChoiceHistory3ExportOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/history3/export"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentChoiceHistory3Export"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentChoiceHistory3PrintBySemesterParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type getAdministratorStudentChoiceHistory3PrintBySemesterOk = ExportFile

export type getAdministratorStudentChoiceHistory3PrintBySemesterErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentChoiceHistory3PrintBySemester (params: getAdministratorStudentChoiceHistory3PrintBySemesterParams): Promise<getAdministratorStudentChoiceHistory3PrintBySemesterOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/history3/print-by-semester"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentChoiceHistory3PrintBySemester"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchAdministratorStudentChoiceProgramAssignmentParams {
  readonly "body": {
    readonly "targetSemesterId": number
    readonly "programId": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
    readonly "choiceUid": string
  }
}

export type patchAdministratorStudentChoiceProgramAssignmentOk = AdministratorChoiceProgramAssignmentResult

export type patchAdministratorStudentChoiceProgramAssignmentErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchAdministratorStudentChoiceProgramAssignment (params: patchAdministratorStudentChoiceProgramAssignmentParams): Promise<patchAdministratorStudentChoiceProgramAssignmentOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/"
  url += params.args["choiceUid"]
  url += "/program-assignment"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "targetSemesterId": params.body["targetSemesterId"],
      "programId": params.body["programId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceProgramAssignmentResult
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceProgramAssignmentResultDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceProgramAssignmentResult>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 2XX AdministratorChoiceProgramAssignmentResult\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchAdministratorStudentChoiceProgramAssignment"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorStudentChoiceProgramAssignmentsResetParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type postAdministratorStudentChoiceProgramAssignmentsResetOk = AdministratorChoiceProgramAssignmentResetResult

export type postAdministratorStudentChoiceProgramAssignmentsResetErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorStudentChoiceProgramAssignmentsReset (params: postAdministratorStudentChoiceProgramAssignmentsResetParams): Promise<postAdministratorStudentChoiceProgramAssignmentsResetOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/choices/program-assignments/reset"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorChoiceProgramAssignmentResetResult
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorChoiceProgramAssignmentResetResultDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorChoiceProgramAssignmentResetResult>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 2XX AdministratorChoiceProgramAssignmentResetResult\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorStudentChoiceProgramAssignmentsReset"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStudentClinicalInternshipReferenceParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: string
  }
  readonly "args": {
    readonly "uid": string
    readonly "profileId": string
  }
}

export type getAdministratorStudentClinicalInternshipReferenceOk = ClinicalInternshipReference

export type getAdministratorStudentClinicalInternshipReferenceErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStudentClinicalInternshipReference (params: getAdministratorStudentClinicalInternshipReferenceParams): Promise<getAdministratorStudentClinicalInternshipReferenceOk> {
  let url = "/administrator/users/"
  url += params.args["uid"]
  url += "/profiles/"
  url += params.args["profileId"]
  url += "/reference/clinical-internship"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ClinicalInternshipReference
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ClinicalInternshipReferenceDecoder).decode(data)
    if (result.ok) {
      return identity<ClinicalInternshipReference>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 2XX ClinicalInternshipReference\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStudentClinicalInternshipReference"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchMessagesMarkReadParams {
  readonly "body": {
    readonly "semId": IDString
    readonly "messageIds": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type patchMessagesMarkReadOk = null

export type patchMessagesMarkReadErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchMessagesMarkRead (params: patchMessagesMarkReadParams): Promise<patchMessagesMarkReadOk> {
  const url = "/messages/mark-read"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "messageIds": params.body["messageIds"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-read 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-read 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-read 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-read 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-read 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchMessagesMarkRead"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-read XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchMessagesMarkUnreadParams {
  readonly "body": {
    readonly "semId": IDString
    readonly "messageIds": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type patchMessagesMarkUnreadOk = null

export type patchMessagesMarkUnreadErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchMessagesMarkUnread (params: patchMessagesMarkUnreadParams): Promise<patchMessagesMarkUnreadOk> {
  const url = "/messages/mark-unread"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "messageIds": params.body["messageIds"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-unread 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-unread 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-unread 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-unread 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-unread 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchMessagesMarkUnread"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /messages/mark-unread XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteMessagesParams {
  readonly "body": {
    readonly "semId": IDString
    readonly "messageIds": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type deleteMessagesOk = null

export type deleteMessagesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteMessages (params: deleteMessagesParams): Promise<deleteMessagesOk> {
  const url = "/messages"
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "messageIds": params.body["messageIds"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'DELETE /messages 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /messages 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /messages 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /messages 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /messages 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteMessages"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /messages XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentRatingParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentRatingOk = Rating

export type getStudentRatingErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentRating (params: getStudentRatingParams): Promise<getStudentRatingOk> {
  const url = "/student/rating"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Rating
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RatingDecoder).decode(data)
    if (result.ok) {
      return identity<Rating>(result.value)
    } else {
      console.error(
        'GET /student/rating 2XX Rating\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/rating 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/rating 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/rating 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/rating 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentRating"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/rating XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getNewsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getNewsOk {
  readonly "data": readonly News[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getNewsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getNews (params: getNewsParams): Promise<getNewsOk> {
  const url = "/news"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly News[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(NewsDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly News[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /news 2XX {\n' +
        '  readonly "data": readonly News[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /news 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /news 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /news 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /news 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getNews"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /news XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioSectionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export interface getStudentPortfolioSectionsOk {
  readonly "data": readonly Section[]
}

export type getStudentPortfolioSectionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioSections (params: getStudentPortfolioSectionsParams): Promise<getStudentPortfolioSectionsOk> {
  const url = "/student/portfolio/sections"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Section[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(SectionDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Section[]
      }>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections 2XX {\n' +
        '  readonly "data": readonly Section[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioSections"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerPortfolioSectionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export interface getLecturerPortfolioSectionsOk {
  readonly "data": readonly Section[]
}

export type getLecturerPortfolioSectionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerPortfolioSections (params: getLecturerPortfolioSectionsParams): Promise<getLecturerPortfolioSectionsOk> {
  const url = "/lecturer/portfolio/sections"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Section[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(SectionDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Section[]
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections 2XX {\n' +
        '  readonly "data": readonly Section[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerPortfolioSections"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioSectionParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentPortfolioSectionOk = Section

export type getStudentPortfolioSectionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioSection (params: getStudentPortfolioSectionParams): Promise<getStudentPortfolioSectionOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Section
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SectionDecoder).decode(data)
    if (result.ok) {
      return identity<Section>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX Section\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioSection"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerPortfolioSectionParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerPortfolioSectionOk = Section

export type getLecturerPortfolioSectionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerPortfolioSection (params: getLecturerPortfolioSectionParams): Promise<getLecturerPortfolioSectionOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Section
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SectionDecoder).decode(data)
    if (result.ok) {
      return identity<Section>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 2XX Section\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerPortfolioSection"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioSectionWorksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getStudentPortfolioSectionWorksOk {
  readonly "data": readonly StudentPortfolioUserWork[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentPortfolioSectionWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioSectionWorks (params: getStudentPortfolioSectionWorksParams): Promise<getStudentPortfolioSectionWorksOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/works"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly StudentPortfolioUserWork[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(StudentPortfolioUserWorkDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly StudentPortfolioUserWork[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly StudentPortfolioUserWork[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioSectionWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioSectionHistoryWorksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getStudentPortfolioSectionHistoryWorksOk {
  readonly "data": readonly StudentPortfolioUserWork[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentPortfolioSectionHistoryWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioSectionHistoryWorks (params: getStudentPortfolioSectionHistoryWorksParams): Promise<getStudentPortfolioSectionHistoryWorksOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/works-history"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly StudentPortfolioUserWork[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(StudentPortfolioUserWorkDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly StudentPortfolioUserWork[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly StudentPortfolioUserWork[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioSectionHistoryWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioSectionChartsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getStudentPortfolioSectionChartsOk {
  readonly "data": readonly PortfolioCompetency[]
}

export type getStudentPortfolioSectionChartsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioSectionCharts (params: getStudentPortfolioSectionChartsParams): Promise<getStudentPortfolioSectionChartsOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/charts"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly PortfolioCompetency[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(PortfolioCompetencyDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly PortfolioCompetency[]
      }>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly PortfolioCompetency[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioSectionCharts"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerPortfolioSectionWorksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "filters[status]": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getLecturerPortfolioSectionWorksOk {
  readonly "data": readonly LecturerPortfolioUserWork[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getLecturerPortfolioSectionWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerPortfolioSectionWorks (params: getLecturerPortfolioSectionWorksParams): Promise<getLecturerPortfolioSectionWorksOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["id"]
  url += "/works"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly LecturerPortfolioUserWork[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(LecturerPortfolioUserWorkDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly LecturerPortfolioUserWork[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly LecturerPortfolioUserWork[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerPortfolioSectionWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioSectionWorkParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "sectionId": string
    readonly "id": string
  }
}

export type getStudentPortfolioSectionWorkOk = StudentPortfolioUserWork

export type getStudentPortfolioSectionWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioSectionWork (params: getStudentPortfolioSectionWorkParams): Promise<getStudentPortfolioSectionWorkOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["sectionId"]
  url += "/works/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX StudentPortfolioUserWork
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(StudentPortfolioUserWorkDecoder).decode(data)
    if (result.ok) {
      return identity<StudentPortfolioUserWork>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX StudentPortfolioUserWork\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioSectionWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerPortfolioSectionWorkParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "SectionId": string
    readonly "id": string
  }
}

export type getLecturerPortfolioSectionWorkOk = LecturerPortfolioUserWork

export type getLecturerPortfolioSectionWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerPortfolioSectionWork (params: getLecturerPortfolioSectionWorkParams): Promise<getLecturerPortfolioSectionWorkOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["SectionId"]
  url += "/works/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX LecturerPortfolioUserWork
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(LecturerPortfolioUserWorkDecoder).decode(data)
    if (result.ok) {
      return identity<LecturerPortfolioUserWork>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 2XX LecturerPortfolioUserWork\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerPortfolioSectionWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioMentrosParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentPortfolioMentrosOk = readonly User[]

export type getStudentPortfolioMentrosErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioMentros (params: getStudentPortfolioMentrosParams): Promise<getStudentPortfolioMentrosOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/lecturers"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly User[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UserDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly User[]>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX readonly User[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioMentros"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentPortfolioCompetenciesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getStudentPortfolioCompetenciesOk {
  readonly "data": readonly PortfolioCompetency[]
}

export type getStudentPortfolioCompetenciesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPortfolioCompetencies (params: getStudentPortfolioCompetenciesParams): Promise<getStudentPortfolioCompetenciesOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/competencies"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly PortfolioCompetency[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(PortfolioCompetencyDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly PortfolioCompetency[]
      }>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly PortfolioCompetency[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPortfolioCompetencies"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerPortfolioCompetenciesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getLecturerPortfolioCompetenciesOk {
  readonly "data": readonly PortfolioCompetency[]
}

export type getLecturerPortfolioCompetenciesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerPortfolioCompetencies (params: getLecturerPortfolioCompetenciesParams): Promise<getLecturerPortfolioCompetenciesOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["id"]
  url += "/competencies"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly PortfolioCompetency[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(PortfolioCompetencyDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly PortfolioCompetency[]
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly PortfolioCompetency[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerPortfolioCompetencies"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerPortfolioSectionCompetenciesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export interface getLecturerPortfolioSectionCompetenciesOk {
  readonly "data": readonly PortfolioCompetency[]
}

export type getLecturerPortfolioSectionCompetenciesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerPortfolioSectionCompetencies (params: getLecturerPortfolioSectionCompetenciesParams): Promise<getLecturerPortfolioSectionCompetenciesOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["id"]
  url += "/competencies"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly PortfolioCompetency[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(PortfolioCompetencyDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly PortfolioCompetency[]
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 2XX {\n' +
        '  readonly "data": readonly PortfolioCompetency[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerPortfolioSectionCompetencies"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putStudentPortfolioWorkParams {
  readonly "body": {
    readonly "mentorId"?: IDString
    readonly "text"?: IDString
    readonly "competencies": ReadonlyArray<{
      readonly "competencyId": number
    }>
    readonly "files": readonly IDString[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": IDString
    readonly "workId": IDString
  }
}

export type putStudentPortfolioWorkOk = null

export type putStudentPortfolioWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putStudentPortfolioWork (params: putStudentPortfolioWorkParams): Promise<putStudentPortfolioWorkOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/works/"
  url += params.args["workId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "mentorId": params.body["mentorId"],
      "text": params.body["text"],
      "competencies": params.body["competencies"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putStudentPortfolioWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putStudentPortfolioDraftWorkParams {
  readonly "body": {
    readonly "mentorId"?: IDString
    readonly "text"?: IDString
    readonly "competencies": ReadonlyArray<{
      readonly "competencyId": number
    }>
    readonly "files": readonly IDString[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type putStudentPortfolioDraftWorkOk = null

export type putStudentPortfolioDraftWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putStudentPortfolioDraftWork (params: putStudentPortfolioDraftWorkParams): Promise<putStudentPortfolioDraftWorkOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/works"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "mentorId": params.body["mentorId"],
      "text": params.body["text"],
      "competencies": params.body["competencies"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putStudentPortfolioDraftWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchStudentPortfolioWorkParams {
  readonly "body": {
    readonly "mentorId"?: IDString
    readonly "text"?: IDString
    readonly "competencies": ReadonlyArray<{
      readonly "competencyId": number
    }>
    readonly "files": readonly IDString[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "workId": IDString
  }
}

export type patchStudentPortfolioWorkOk = null

export type patchStudentPortfolioWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchStudentPortfolioWork (params: patchStudentPortfolioWorkParams): Promise<patchStudentPortfolioWorkOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/works/"
  url += params.args["workId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "mentorId": params.body["mentorId"],
      "text": params.body["text"],
      "competencies": params.body["competencies"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /student/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchStudentPortfolioWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentPortfolioWorkParams {
  readonly "body": {
    readonly "mentorId"?: IDString
    readonly "text"?: IDString
    readonly "competencies": ReadonlyArray<{
      readonly "competencyId": number
    }>
    readonly "files": readonly IDString[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "workId": IDString
  }
}

export type postStudentPortfolioWorkOk = null

export type postStudentPortfolioWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentPortfolioWork (params: postStudentPortfolioWorkParams): Promise<postStudentPortfolioWorkOk> {
  let url = "/student/portfolio/sections/"
  url += params.args["id"]
  url += "/works/"
  url += params.args["workId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "mentorId": params.body["mentorId"],
      "text": params.body["text"],
      "competencies": params.body["competencies"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentPortfolioWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchLecturerPortfolioSectionsWorksParams {
  readonly "body": {
    readonly "comment": string
    readonly "scores": ScoreEvaluation
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "sectionId": string
    readonly "workId": string
  }
}

export type patchLecturerPortfolioSectionsWorksOk = null

export type patchLecturerPortfolioSectionsWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchLecturerPortfolioSectionsWorks (params: patchLecturerPortfolioSectionsWorksParams): Promise<patchLecturerPortfolioSectionsWorksOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["sectionId"]
  url += "/works/"
  url += params.args["workId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "comment": params.body["comment"],
      "scores": params.body["scores"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchLecturerPortfolioSectionsWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchLecturerPortfolioSectionsWorksRejectParams {
  readonly "body": {
    readonly "comment": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "workId": string
  }
}

export type patchLecturerPortfolioSectionsWorksRejectOk = null

export type patchLecturerPortfolioSectionsWorksRejectErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchLecturerPortfolioSectionsWorksReject (params: patchLecturerPortfolioSectionsWorksRejectParams): Promise<patchLecturerPortfolioSectionsWorksRejectOk> {
  let url = "/lecturer/portfolio/sections/"
  url += params.args["id"]
  url += "/works/"
  url += params.args["workId"]
  url += "/reject"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "comment": params.body["comment"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchLecturerPortfolioSectionsWorksReject"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentProgramsStateParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentProgramsStateOk = StudentProgramState

export type getStudentProgramsStateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentProgramsState (params: getStudentProgramsStateParams): Promise<getStudentProgramsStateOk> {
  const url = "/student/programs/state"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX StudentProgramState
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(StudentProgramStateDecoder).decode(data)
    if (result.ok) {
      return identity<StudentProgramState>(result.value)
    } else {
      console.error(
        'GET /student/programs/state 2XX StudentProgramState\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/programs/state 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/programs/state 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/programs/state 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/programs/state 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentProgramsState"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/programs/state XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getSingleNewsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "newsId": string
  }
}

export type getSingleNewsOk = News

export type getSingleNewsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getSingleNews (params: getSingleNewsParams): Promise<getSingleNewsOk> {
  let url = "/news/"
  url += params.args["newsId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX News
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(NewsDecoder).decode(data)
    if (result.ok) {
      return identity<News>(result.value)
    } else {
      console.error(
        'GET /news/ 2XX News\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /news/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /news/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /news/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /news/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getSingleNews"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /news/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getNewsUnreadCountParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getNewsUnreadCountOk = NewsUnreadCount

export type getNewsUnreadCountErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getNewsUnreadCount (params: getNewsUnreadCountParams): Promise<getNewsUnreadCountOk> {
  const url = "/news/unread-count"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX NewsUnreadCount
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(NewsUnreadCountDecoder).decode(data)
    if (result.ok) {
      return identity<NewsUnreadCount>(result.value)
    } else {
      console.error(
        'GET /news/unread-count 2XX NewsUnreadCount\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /news/unread-count 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /news/unread-count 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /news/unread-count 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /news/unread-count 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getNewsUnreadCount"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /news/unread-count XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMediaFilesDownloadParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getMediaFilesDownloadOk = DownloadMediaFile

export type getMediaFilesDownloadErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getMediaFilesDownload (params: getMediaFilesDownloadParams): Promise<getMediaFilesDownloadOk> {
  let url = "/media-files/"
  url += params.args["id"]
  url += "/download"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX DownloadMediaFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(DownloadMediaFileDecoder).decode(data)
    if (result.ok) {
      return identity<DownloadMediaFile>(result.value)
    } else {
      console.error(
        'GET /media-files/ 2XX DownloadMediaFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /media-files/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /media-files/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /media-files/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /media-files/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMediaFilesDownload"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /media-files/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationFilesDownloadParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getRegistrationFilesDownloadOk = DownloadMediaFile

export type getRegistrationFilesDownloadErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationFilesDownload (params: getRegistrationFilesDownloadParams): Promise<getRegistrationFilesDownloadOk> {
  let url = "/registration/download/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX DownloadMediaFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(DownloadMediaFileDecoder).decode(data)
    if (result.ok) {
      return identity<DownloadMediaFile>(result.value)
    } else {
      console.error(
        'GET /registration/download/ 2XX DownloadMediaFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/download/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/download/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/download/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/download/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationFilesDownload"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/download/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFacultiesMinorsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentFacultiesMinorsOk = readonly Faculty[]

export type getStudentFacultiesMinorsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFacultiesMinors (params: getStudentFacultiesMinorsParams): Promise<getStudentFacultiesMinorsOk> {
  const url = "/student/faculties/minors"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Faculty[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FacultyDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Faculty[]>(result.value)
    } else {
      console.error(
        'GET /student/faculties/minors 2XX readonly Faculty[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/faculties/minors 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/faculties/minors 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/faculties/minors 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/faculties/minors 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFacultiesMinors"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/faculties/minors XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentProgramsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters[type]": string
  }
}

export type getStudentProgramsOk = readonly Program[]

export type getStudentProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentPrograms (params: getStudentProgramsParams): Promise<getStudentProgramsOk> {
  const url = "/student/programs"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Program[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ProgramDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Program[]>(result.value)
    } else {
      console.error(
        'GET /student/programs 2XX readonly Program[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/programs 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/programs 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/programs 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/programs 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/programs XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentProgramParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentProgramOk = Program

export type getStudentProgramErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentProgram (params: getStudentProgramParams): Promise<getStudentProgramOk> {
  let url = "/student/programs/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Program
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ProgramDecoder).decode(data)
    if (result.ok) {
      return identity<Program>(result.value)
    } else {
      console.error(
        'GET /student/programs/ 2XX Program\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/programs/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/programs/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/programs/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/programs/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentProgram"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/programs/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFacultiesMinorProgramsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentFacultiesMinorProgramsOk = readonly Program[]

export type getStudentFacultiesMinorProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFacultiesMinorPrograms (params: getStudentFacultiesMinorProgramsParams): Promise<getStudentFacultiesMinorProgramsOk> {
  let url = "/student/faculties/"
  url += params.args["id"]
  url += "/minor-programs"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Program[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ProgramDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Program[]>(result.value)
    } else {
      console.error(
        'GET /student/faculties/ 2XX readonly Program[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/faculties/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/faculties/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/faculties/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/faculties/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFacultiesMinorPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/faculties/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchStudentProgramsStateParams {
  readonly "body": {
    readonly "customProgramId": IDString
    readonly "minorFacultyId": IDString
    readonly "minorProgramId": IDString
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type patchStudentProgramsStateOk = null

export type patchStudentProgramsStateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchStudentProgramsState (params: patchStudentProgramsStateParams): Promise<patchStudentProgramsStateOk> {
  const url = "/student/programs/state"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "customProgramId": params.body["customProgramId"],
      "minorFacultyId": params.body["minorFacultyId"],
      "minorProgramId": params.body["minorProgramId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /student/programs/state 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /student/programs/state 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /student/programs/state 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /student/programs/state 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /student/programs/state 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchStudentProgramsState"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /student/programs/state XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentRecommendationsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getStudentRecommendationsOk {
  readonly "data": readonly Recommendation[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentRecommendationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentRecommendations (params: getStudentRecommendationsParams): Promise<getStudentRecommendationsOk> {
  const url = "/student/recommendations"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Recommendation[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(RecommendationDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Recommendation[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/recommendations 2XX {\n' +
        '  readonly "data": readonly Recommendation[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/recommendations 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/recommendations 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/recommendations 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/recommendations 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentRecommendations"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/recommendations XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getNotificationsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getNotificationsOk {
  readonly "data": readonly Notification[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getNotificationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getNotifications (params: getNotificationsParams): Promise<getNotificationsOk> {
  const url = "/notifications"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Notification[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(NotificationDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Notification[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /notifications 2XX {\n' +
        '  readonly "data": readonly Notification[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /notifications 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /notifications 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /notifications 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /notifications 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getNotifications"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /notifications XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchNotificationsMarkAllAsReadParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type patchNotificationsMarkAllAsReadOk = null

export type patchNotificationsMarkAllAsReadErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchNotificationsMarkAllAsRead (params: patchNotificationsMarkAllAsReadParams): Promise<patchNotificationsMarkAllAsReadOk> {
  const url = "/notifications/mark-all-as-read"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /notifications/mark-all-as-read 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /notifications/mark-all-as-read 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /notifications/mark-all-as-read 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /notifications/mark-all-as-read 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /notifications/mark-all-as-read 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchNotificationsMarkAllAsRead"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /notifications/mark-all-as-read XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchNotificationsMarkAsReadParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "uuid": string
  }
}

export type patchNotificationsMarkAsReadOk = null

export type patchNotificationsMarkAsReadErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchNotificationsMarkAsRead (params: patchNotificationsMarkAsReadParams): Promise<patchNotificationsMarkAsReadOk> {
  let url = "/notifications/"
  url += params.args["uuid"]
  url += "/mark-as-read"
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /notifications/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /notifications/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /notifications/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /notifications/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /notifications/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchNotificationsMarkAsRead"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /notifications/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentRecommendationParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentRecommendationOk = Recommendation

export type getStudentRecommendationErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentRecommendation (params: getStudentRecommendationParams): Promise<getStudentRecommendationOk> {
  let url = "/student/recommendations/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Recommendation
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RecommendationDecoder).decode(data)
    if (result.ok) {
      return identity<Recommendation>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 2XX Recommendation\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentRecommendation"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentRecommendationsRequestParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "user_id": IDString
  }
}

export type postStudentRecommendationsRequestOk = null

export type postStudentRecommendationsRequestErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentRecommendationsRequest (params: postStudentRecommendationsRequestParams): Promise<postStudentRecommendationsRequestOk> {
  let url = "/student/recommendations/"
  url += params.args["user_id"]
  url += "/request"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/recommendations/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/recommendations/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/recommendations/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/recommendations/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/recommendations/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentRecommendationsRequest"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/recommendations/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentRecommendationsExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type getStudentRecommendationsExportOk = ExportFile

export type getStudentRecommendationsExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentRecommendationsExport (params: getStudentRecommendationsExportParams): Promise<getStudentRecommendationsExportOk> {
  let url = "/student/recommendations/"
  url += params.args["id"]
  url += "/export"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentRecommendationsExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/recommendations/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeOk = Resume

export type getStudentResumeErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResume (params: getStudentResumeParams): Promise<getStudentResumeOk> {
  const url = "/student/resume"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Resume
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ResumeDecoder).decode(data)
    if (result.ok) {
      return identity<Resume>(result.value)
    } else {
      console.error(
        'GET /student/resume 2XX Resume\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResume"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumePersonalParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumePersonalOk = ResumePersonal

export type getStudentResumePersonalErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumePersonal (params: getStudentResumePersonalParams): Promise<getStudentResumePersonalOk> {
  const url = "/student/resume/personal"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ResumePersonal
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ResumePersonalDecoder).decode(data)
    if (result.ok) {
      return identity<ResumePersonal>(result.value)
    } else {
      console.error(
        'GET /student/resume/personal 2XX ResumePersonal\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/personal 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/personal 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/personal 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/personal 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumePersonal"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/personal XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeWorksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeWorksOk = readonly ResumeWork[]

export type getStudentResumeWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeWorks (params: getStudentResumeWorksParams): Promise<getStudentResumeWorksOk> {
  const url = "/student/resume/works"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumeWork[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumeWorkDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumeWork[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/works 2XX readonly ResumeWork[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/works 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/works 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/works 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/works 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/works XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeTrainingsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeTrainingsOk = readonly ResumeTraining[]

export type getStudentResumeTrainingsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeTrainings (params: getStudentResumeTrainingsParams): Promise<getStudentResumeTrainingsOk> {
  const url = "/student/resume/trainings"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumeTraining[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumeTrainingDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumeTraining[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/trainings 2XX readonly ResumeTraining[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/trainings 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/trainings 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/trainings 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/trainings 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeTrainings"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/trainings XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeSkillsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeSkillsOk = ResumeSkill

export type getStudentResumeSkillsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeSkills (params: getStudentResumeSkillsParams): Promise<getStudentResumeSkillsOk> {
  const url = "/student/resume/skills"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ResumeSkill
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ResumeSkillDecoder).decode(data)
    if (result.ok) {
      return identity<ResumeSkill>(result.value)
    } else {
      console.error(
        'GET /student/resume/skills 2XX ResumeSkill\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/skills 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/skills 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/skills 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/skills 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeSkills"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/skills XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeEducationsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeEducationsOk = readonly ResumeEducation[]

export type getStudentResumeEducationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeEducations (params: getStudentResumeEducationsParams): Promise<getStudentResumeEducationsOk> {
  const url = "/student/resume/educations"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumeEducation[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumeEducationDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumeEducation[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/educations 2XX readonly ResumeEducation[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/educations 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/educations 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/educations 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/educations 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeEducations"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/educations XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeAdditionalParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeAdditionalOk = ResumeAdditional

export type getStudentResumeAdditionalErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeAdditional (params: getStudentResumeAdditionalParams): Promise<getStudentResumeAdditionalOk> {
  const url = "/student/resume/additional"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ResumeAdditional
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ResumeAdditionalDecoder).decode(data)
    if (result.ok) {
      return identity<ResumeAdditional>(result.value)
    } else {
      console.error(
        'GET /student/resume/additional 2XX ResumeAdditional\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/additional 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/additional 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/additional 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/additional 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeAdditional"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/additional XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeUniversitiesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeUniversitiesOk = readonly University[]

export type getStudentResumeUniversitiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeUniversities (params: getStudentResumeUniversitiesParams): Promise<getStudentResumeUniversitiesOk> {
  const url = "/student/resume/universities"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly University[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UniversityDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly University[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/universities 2XX readonly University[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/universities 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/universities 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/universities 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/universities 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeUniversities"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/universities XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeLanguagesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeLanguagesOk = readonly ResumeLanguage[]

export type getStudentResumeLanguagesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeLanguages (params: getStudentResumeLanguagesParams): Promise<getStudentResumeLanguagesOk> {
  const url = "/student/resume/languages"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumeLanguage[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumeLanguageDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumeLanguage[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/languages 2XX readonly ResumeLanguage[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/languages 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/languages 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/languages 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/languages 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeLanguages"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/languages XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumePublicationTypesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumePublicationTypesOk = readonly ResumePublicationType[]

export type getStudentResumePublicationTypesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumePublicationTypes (params: getStudentResumePublicationTypesParams): Promise<getStudentResumePublicationTypesOk> {
  const url = "/student/resume/publication-types"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumePublicationType[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumePublicationTypeDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumePublicationType[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/publication-types 2XX readonly ResumePublicationType[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/publication-types 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/publication-types 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/publication-types 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/publication-types 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumePublicationTypes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/publication-types XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeGrantTypesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeGrantTypesOk = readonly ResumeGrantType[]

export type getStudentResumeGrantTypesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeGrantTypes (params: getStudentResumeGrantTypesParams): Promise<getStudentResumeGrantTypesOk> {
  const url = "/student/resume/grant-types"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumeGrantType[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumeGrantTypeDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumeGrantType[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/grant-types 2XX readonly ResumeGrantType[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/grant-types 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/grant-types 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/grant-types 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/grant-types 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeGrantTypes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/grant-types XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeCitiesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "filters": {
      readonly "countryId": IDString
    }
  }
}

export type getStudentResumeCitiesOk = readonly ResumeCity[]

export type getStudentResumeCitiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeCities (params: getStudentResumeCitiesParams): Promise<getStudentResumeCitiesOk> {
  const url = "/student/resume/cities"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ResumeCity[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ResumeCityDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ResumeCity[]>(result.value)
    } else {
      console.error(
        'GET /student/resume/cities 2XX readonly ResumeCity[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/cities 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/cities 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/cities 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/cities 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeCities"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/cities XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentResumeExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentResumeExportOk = ExportFile

export type getStudentResumeExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentResumeExport (params: getStudentResumeExportParams): Promise<getStudentResumeExportOk> {
  const url = "/student/resume/export"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ExportFile
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ExportFileDecoder).decode(data)
    if (result.ok) {
      return identity<ExportFile>(result.value)
    } else {
      console.error(
        'GET /student/resume/export 2XX ExportFile\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/resume/export 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/resume/export 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/resume/export 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/resume/export 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentResumeExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/resume/export XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentResumePersonalParams {
  readonly "body": {
    readonly "photoTitle": string
    readonly "address": string
    readonly "homePhone": string
    readonly "mobilePhone": string
    readonly "photoUid": null | string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentResumePersonalOk = null

export type postStudentResumePersonalErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentResumePersonal (params: postStudentResumePersonalParams): Promise<postStudentResumePersonalOk> {
  const url = "/student/resume/personal"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "photoTitle": params.body["photoTitle"],
      "address": params.body["address"],
      "homePhone": params.body["homePhone"],
      "mobilePhone": params.body["mobilePhone"],
      "photoUid": params.body["photoUid"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/resume/personal 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/resume/personal 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/resume/personal 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/resume/personal 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/resume/personal 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentResumePersonal"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/resume/personal XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentResumeWorksParams {
  readonly "body": {
    readonly "data": readonly UpdateResumeWorkRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentResumeWorksOk = null

export type postStudentResumeWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentResumeWorks (params: postStudentResumeWorksParams): Promise<postStudentResumeWorksOk> {
  const url = "/student/resume/works"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "data": params.body["data"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/resume/works 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/resume/works 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/resume/works 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/resume/works 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/resume/works 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentResumeWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/resume/works XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentResumeTrainingsParams {
  readonly "body": {
    readonly "data": readonly UpdateResumeTrainingRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentResumeTrainingsOk = null

export type postStudentResumeTrainingsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentResumeTrainings (params: postStudentResumeTrainingsParams): Promise<postStudentResumeTrainingsOk> {
  const url = "/student/resume/trainings"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "data": params.body["data"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/resume/trainings 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/resume/trainings 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/resume/trainings 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/resume/trainings 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/resume/trainings 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentResumeTrainings"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/resume/trainings XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentResumeSkillsParams {
  readonly "body": {
    readonly "hasDriverLicence": boolean
    readonly "languages": readonly UpdateResumeSkillLanguageRequest[]
    readonly "communications": readonly UpdateResumeSkillCommunicationRequest[]
    readonly "computers": readonly UpdateResumeSkillComputerRequest[]
    readonly "organisationals": readonly UpdateResumeSkillOrganisationalRequest[]
    readonly "others": readonly UpdateResumeSkillOtherRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentResumeSkillsOk = null

export type postStudentResumeSkillsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentResumeSkills (params: postStudentResumeSkillsParams): Promise<postStudentResumeSkillsOk> {
  const url = "/student/resume/skills"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "hasDriverLicence": params.body["hasDriverLicence"],
      "languages": params.body["languages"],
      "communications": params.body["communications"],
      "computers": params.body["computers"],
      "organisationals": params.body["organisationals"],
      "others": params.body["others"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/resume/skills 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/resume/skills 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/resume/skills 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/resume/skills 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/resume/skills 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentResumeSkills"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/resume/skills XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentResumeEducationsParams {
  readonly "body": {
    readonly "data": readonly UpdateResumeEducationRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentResumeEducationsOk = null

export type postStudentResumeEducationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentResumeEducations (params: postStudentResumeEducationsParams): Promise<postStudentResumeEducationsOk> {
  const url = "/student/resume/educations"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "data": params.body["data"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/resume/educations 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/resume/educations 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/resume/educations 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/resume/educations 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/resume/educations 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentResumeEducations"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/resume/educations XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentResumeAdditionalParams {
  readonly "body": {
    readonly "info": null | string
    readonly "publications": readonly UpdateResumeAdditionalPublicationRequest[]
    readonly "fellowships": readonly UpdateResumeAdditionalFellowshipRequest[]
    readonly "subjects": readonly UpdateResumeAdditionalSubjectRequest[]
    readonly "videoLectures": readonly UpdateResumeAdditionalVideoLectureRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentResumeAdditionalOk = null

export type postStudentResumeAdditionalErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentResumeAdditional (params: postStudentResumeAdditionalParams): Promise<postStudentResumeAdditionalOk> {
  const url = "/student/resume/additional"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "info": params.body["info"],
      "publications": params.body["publications"],
      "fellowships": params.body["fellowships"],
      "subjects": params.body["subjects"],
      "videoLectures": params.body["videoLectures"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/resume/additional 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/resume/additional 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/resume/additional 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/resume/additional 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/resume/additional 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentResumeAdditional"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/resume/additional XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchStudentResumeTabsParams {
  readonly "body": {
    readonly "visibility": boolean
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "ResumeTab": ResumeTab
  }
}

export type patchStudentResumeTabsOk = null

export type patchStudentResumeTabsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchStudentResumeTabs (params: patchStudentResumeTabsParams): Promise<patchStudentResumeTabsOk> {
  let url = "/student/resume/tabs/"
  url += params.args["ResumeTab"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "visibility": params.body["visibility"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /student/resume/tabs/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /student/resume/tabs/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /student/resume/tabs/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /student/resume/tabs/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /student/resume/tabs/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchStudentResumeTabs"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /student/resume/tabs/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableTabsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentAvailableTabsOk = readonly AvailableCourseTab[]

export type getStudentAvailableTabsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableTabs (params: getStudentAvailableTabsParams): Promise<getStudentAvailableTabsOk> {
  const url = "/student/available/tabs"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AvailableCourseTab[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AvailableCourseTabDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AvailableCourseTab[]>(result.value)
    } else {
      console.error(
        'GET /student/available/tabs 2XX readonly AvailableCourseTab[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/tabs 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/tabs 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/tabs 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/tabs 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableTabs"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/tabs XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentAvailableChoicesOk = AvailableChoiceSummary

export type getStudentAvailableChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableChoices (params: getStudentAvailableChoicesParams): Promise<getStudentAvailableChoicesOk> {
  const url = "/student/available/choices"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AvailableChoiceSummary
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AvailableChoiceSummaryDecoder).decode(data)
    if (result.ok) {
      return identity<AvailableChoiceSummary>(result.value)
    } else {
      console.error(
        'GET /student/available/choices 2XX AvailableChoiceSummary\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableFreeChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentAvailableFreeChoicesOk = AvailableChoiceSummary

export type getStudentAvailableFreeChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableFreeChoices (params: getStudentAvailableFreeChoicesParams): Promise<getStudentAvailableFreeChoicesOk> {
  const url = "/student/available/free/choices"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AvailableChoiceSummary
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AvailableChoiceSummaryDecoder).decode(data)
    if (result.ok) {
      return identity<AvailableChoiceSummary>(result.value)
    } else {
      console.error(
        'GET /student/available/free/choices 2XX AvailableChoiceSummary\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/free/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/free/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/free/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/free/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableFreeChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/free/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableGeneralCoursesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentAvailableGeneralCoursesOk = AvailableCourseSummary

export type getStudentAvailableGeneralCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableGeneralCourses (params: getStudentAvailableGeneralCoursesParams): Promise<getStudentAvailableGeneralCoursesOk> {
  const url = "/student/available/general/courses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AvailableCourseSummary
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AvailableCourseSummaryDecoder).decode(data)
    if (result.ok) {
      return identity<AvailableCourseSummary>(result.value)
    } else {
      console.error(
        'GET /student/available/general/courses 2XX AvailableCourseSummary\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/general/courses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/general/courses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/general/courses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/general/courses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableGeneralCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/general/courses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableGeneralChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentAvailableGeneralChoicesOk = AvailableChoiceSummary

export type getStudentAvailableGeneralChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableGeneralChoices (params: getStudentAvailableGeneralChoicesParams): Promise<getStudentAvailableGeneralChoicesOk> {
  const url = "/student/available/general/choices"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AvailableChoiceSummary
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AvailableChoiceSummaryDecoder).decode(data)
    if (result.ok) {
      return identity<AvailableChoiceSummary>(result.value)
    } else {
      console.error(
        'GET /student/available/general/choices 2XX AvailableChoiceSummary\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/general/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/general/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/general/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/general/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableGeneralChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/general/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableProgramsCoursesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentAvailableProgramsCoursesOk = AvailableCourseSummary

export type getStudentAvailableProgramsCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableProgramsCourses (params: getStudentAvailableProgramsCoursesParams): Promise<getStudentAvailableProgramsCoursesOk> {
  let url = "/student/available/programs/"
  url += params.args["id"]
  url += "/courses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AvailableCourseSummary
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AvailableCourseSummaryDecoder).decode(data)
    if (result.ok) {
      return identity<AvailableCourseSummary>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 2XX AvailableCourseSummary\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableProgramsCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentAvailableProgramsChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentAvailableProgramsChoicesOk = AvailableChoiceSummary

export type getStudentAvailableProgramsChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentAvailableProgramsChoices (params: getStudentAvailableProgramsChoicesParams): Promise<getStudentAvailableProgramsChoicesOk> {
  let url = "/student/available/programs/"
  url += params.args["id"]
  url += "/choices"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AvailableChoiceSummary
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AvailableChoiceSummaryDecoder).decode(data)
    if (result.ok) {
      return identity<AvailableChoiceSummary>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 2XX AvailableChoiceSummary\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentAvailableProgramsChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/available/programs/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFacultiesProgramsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentFacultiesProgramsOk = readonly Faculty[]

export type getStudentFacultiesProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFacultiesPrograms (params: getStudentFacultiesProgramsParams): Promise<getStudentFacultiesProgramsOk> {
  const url = "/student/faculties/programs"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Faculty[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(decoders.lazy(() => FacultyDecoder))).decode(data)
    if (result.ok) {
      return identity<readonly Faculty[]>(result.value)
    } else {
      console.error(
        'GET /student/faculties/programs 2XX readonly Faculty[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/faculties/programs 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/faculties/programs 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/faculties/programs 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/faculties/programs 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFacultiesPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/faculties/programs XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentLecturersCurrentParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentLecturersCurrentOk = readonly User[]

export type getStudentLecturersCurrentErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentLecturersCurrent (params: getStudentLecturersCurrentParams): Promise<getStudentLecturersCurrentOk> {
  const url = "/student/lecturers/current"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly User[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UserDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly User[]>(result.value)
    } else {
      console.error(
        'GET /student/lecturers/current 2XX readonly User[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/lecturers/current 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/lecturers/current 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/lecturers/current 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/lecturers/current 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentLecturersCurrent"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/lecturers/current XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFeedbacksSubjectsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentFeedbacksSubjectsOk = readonly FeedbackSubject[]

export type getStudentFeedbacksSubjectsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFeedbacksSubjects (params: getStudentFeedbacksSubjectsParams): Promise<getStudentFeedbacksSubjectsOk> {
  const url = "/student/feedbacks/subjects"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly FeedbackSubject[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FeedbackSubjectDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly FeedbackSubject[]>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/subjects 2XX readonly FeedbackSubject[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/subjects 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/subjects 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/subjects 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/subjects 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFeedbacksSubjects"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/subjects XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentFeedbacksParams {
  readonly "body": {
    readonly "subjectId": IDString
    readonly "text": IDString
    readonly "files": readonly string[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postStudentFeedbacksOk = null

export type postStudentFeedbacksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentFeedbacks (params: postStudentFeedbacksParams): Promise<postStudentFeedbacksOk> {
  const url = "/student/feedbacks"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "subjectId": params.body["subjectId"],
      "text": params.body["text"],
      "files": params.body["files"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/feedbacks 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/feedbacks 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/feedbacks 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/feedbacks 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/feedbacks 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentFeedbacks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/feedbacks XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFeedbackParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": IDString
  }
}

export type getStudentFeedbackOk = Feedback

export type getStudentFeedbackErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFeedback (params: getStudentFeedbackParams): Promise<getStudentFeedbackOk> {
  let url = "/student/feedbacks/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Feedback
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(FeedbackDecoder).decode(data)
    if (result.ok) {
      return identity<Feedback>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/ 2XX Feedback\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFeedback"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentFeedbacksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "semId": string
  }
}

export interface getStudentFeedbacksOk {
  readonly "data": readonly Feedback[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getStudentFeedbacksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentFeedbacks (params: getStudentFeedbacksParams): Promise<getStudentFeedbacksOk> {
  const url = "/student/feedbacks"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly Feedback[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(FeedbackDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly Feedback[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks 2XX {\n' +
        '  readonly "data": readonly Feedback[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentFeedbacks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/feedbacks XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentChosenGroupParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentChosenGroupOk = Group

export type getStudentChosenGroupErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentChosenGroup (params: getStudentChosenGroupParams): Promise<getStudentChosenGroupOk> {
  let url = "/student/courses/"
  url += params.args["id"]
  url += "/chosen-group"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Group
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(GroupDecoder).decode(data)
    if (result.ok) {
      return identity<Group>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 2XX Group\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentChosenGroup"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getCountriesParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type getCountriesOk = readonly Country[]

export type getCountriesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getCountries (params: getCountriesParams): Promise<getCountriesOk> {
  const url = "/countries"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Country[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(decoders.lazy(() => CountryDecoder))).decode(data)
    if (result.ok) {
      return identity<readonly Country[]>(result.value)
    } else {
      console.error(
        'GET /countries 2XX readonly Country[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /countries 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /countries 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /countries 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /countries 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getCountries"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /countries XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationAddressesParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "query": string
  }
}

export type getRegistrationAddressesOk = readonly Address[]

export type getRegistrationAddressesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationAddresses (params: getRegistrationAddressesParams): Promise<getRegistrationAddressesOk> {
  const url = "/registration/addresses"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Address[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AddressDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Address[]>(result.value)
    } else {
      console.error(
        'GET /registration/addresses 2XX readonly Address[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/addresses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/addresses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/addresses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/addresses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationAddresses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/addresses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationCoursesParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type getRegistrationCoursesOk = readonly ExamCourse[]

export type getRegistrationCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationCourses (params: getRegistrationCoursesParams): Promise<getRegistrationCoursesOk> {
  const url = "/registration/courses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly ExamCourse[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ExamCourseDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly ExamCourse[]>(result.value)
    } else {
      console.error(
        'GET /registration/courses 2XX readonly ExamCourse[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/courses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/courses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/courses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/courses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/courses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationCheckStatusParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "degree": string
  }
}

export type getRegistrationCheckStatusOk = RegistrationStatus

export type getRegistrationCheckStatusErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationCheckStatus (params: getRegistrationCheckStatusParams): Promise<getRegistrationCheckStatusOk> {
  let url = "/registration/check-status/"
  url += params.args["degree"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX RegistrationStatus
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RegistrationStatusDecoder).decode(data)
    if (result.ok) {
      return identity<RegistrationStatus>(result.value)
    } else {
      console.error(
        'GET /registration/check-status/ 2XX RegistrationStatus\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/check-status/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/check-status/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/check-status/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/check-status/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationCheckStatus"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/check-status/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationUniversitiesParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type getRegistrationUniversitiesOk = readonly University[]

export type getRegistrationUniversitiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationUniversities (params: getRegistrationUniversitiesParams): Promise<getRegistrationUniversitiesOk> {
  const url = "/registration/universities"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly University[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UniversityDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly University[]>(result.value)
    } else {
      console.error(
        'GET /registration/universities 2XX readonly University[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/universities 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/universities 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/universities 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/universities 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationUniversities"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/universities XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationTestTypesParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type getRegistrationTestTypesOk = readonly University[]

export type getRegistrationTestTypesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationTestTypes (params: getRegistrationTestTypesParams): Promise<getRegistrationTestTypesOk> {
  const url = "/registration/test-types"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly University[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(UniversityDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly University[]>(result.value)
    } else {
      console.error(
        'GET /registration/test-types 2XX readonly University[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/test-types 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/test-types 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/test-types 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/test-types 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationTestTypes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/test-types XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationFacultiesParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type getRegistrationFacultiesOk = readonly Faculty[]

export type getRegistrationFacultiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationFaculties (params: getRegistrationFacultiesParams): Promise<getRegistrationFacultiesOk> {
  const url = "/registration/faculties"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Faculty[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FacultyDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Faculty[]>(result.value)
    } else {
      console.error(
        'GET /registration/faculties 2XX readonly Faculty[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/faculties 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/faculties 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/faculties 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/faculties 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationFaculties"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/faculties XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegistrationProgramsParams {
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "faculty_id": string
    readonly "testype_id": string
  }
}

export type getRegistrationProgramsOk = readonly Program[]

export type getRegistrationProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegistrationPrograms (params: getRegistrationProgramsParams): Promise<getRegistrationProgramsOk> {
  let url = "/registration/programs/"
  url += params.args["faculty_id"]
  url += "/"
  url += params.args["testype_id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Program[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(ProgramDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Program[]>(result.value)
    } else {
      console.error(
        'GET /registration/programs/ 2XX readonly Program[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /registration/programs/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /registration/programs/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /registration/programs/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /registration/programs/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegistrationPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /registration/programs/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postCheckPersonalNumberParams {
  readonly "body": {
    readonly "persNum": string
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type postCheckPersonalNumberOk = never

export type postCheckPersonalNumberErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postCheckPersonalNumber (params: postCheckPersonalNumberParams): Promise<postCheckPersonalNumberOk> {
  const url = "/registration/check-pers-num"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "persNum": params.body["persNum"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /registration/check-pers-num 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /registration/check-pers-num 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /registration/check-pers-num 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /registration/check-pers-num 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postCheckPersonalNumber"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /registration/check-pers-num XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postMasterRegistrationParams {
  readonly "body": {
    readonly "step1": MasterRegistrationStep1
    readonly "step2": MasterRegistrationStep2
    readonly "step3": RegistrationStep3
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type postMasterRegistrationOk = Registration

export type postMasterRegistrationErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postMasterRegistration (params: postMasterRegistrationParams): Promise<postMasterRegistrationOk> {
  const url = "/registration/masters"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "step1": params.body["step1"],
      "step2": params.body["step2"],
      "step3": params.body["step3"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Registration
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RegistrationDecoder).decode(data)
    if (result.ok) {
      return identity<Registration>(result.value)
    } else {
      console.error(
        'POST /registration/masters 2XX Registration\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /registration/masters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /registration/masters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /registration/masters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /registration/masters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postMasterRegistration"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /registration/masters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerRegistrationParams {
  readonly "body": {
    readonly "step1": LecturerRegistrationStep1
    readonly "step2": LecturerRegistrationStep2
    readonly "step3": RegistrationStep3
  }
  readonly "headers": {
    readonly "Accept-Language": LanguageString
  }
}

export type postLecturerRegistrationOk = Registration

export type postLecturerRegistrationErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerRegistration (params: postLecturerRegistrationParams): Promise<postLecturerRegistrationOk> {
  const url = "/registration/lecturers"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "step1": params.body["step1"],
      "step2": params.body["step2"],
      "step3": params.body["step3"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Registration
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RegistrationDecoder).decode(data)
    if (result.ok) {
      return identity<Registration>(result.value)
    } else {
      console.error(
        'POST /registration/lecturers 2XX Registration\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /registration/lecturers 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /registration/lecturers 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /registration/lecturers 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /registration/lecturers 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerRegistration"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /registration/lecturers XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getMetaDataParams {
  readonly "query": {
    readonly "_": string
  }
}

export type getMetaDataOk = MetaData

export type getMetaDataErr = never

export async function getMetaData (params: getMetaDataParams): Promise<getMetaDataOk> {
  const url = "/metadata.json"
  const query = queryToString(params.query)
  const response = await fetch(location.origin + url + query, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MetaData
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MetaDataDecoder).decode(data)
    if (result.ok) {
      return identity<MetaData>(result.value)
    } else {
      console.error(
        'GET /metadata.json 2XX MetaData\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getMetaData"))
  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentSurveyActiveParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getStudentSurveyActiveOk = Survey

export type getStudentSurveyActiveErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentSurveyActive (params: getStudentSurveyActiveParams): Promise<getStudentSurveyActiveOk> {
  const url = "/student/survey/active"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Survey
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SurveyDecoder).decode(data)
    if (result.ok) {
      return identity<Survey>(result.value)
    } else {
      console.error(
        'GET /student/survey/active 2XX Survey\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/survey/active 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/survey/active 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/survey/active 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/survey/active 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentSurveyActive"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/survey/active XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getStudentSurveyQuestionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getStudentSurveyQuestionsOk = readonly SurveyQuestion[]

export type getStudentSurveyQuestionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getStudentSurveyQuestions (params: getStudentSurveyQuestionsParams): Promise<getStudentSurveyQuestionsOk> {
  let url = "/student/survey/"
  url += params.args["id"]
  url += "/questions"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly SurveyQuestion[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SurveyQuestionDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly SurveyQuestion[]>(result.value)
    } else {
      console.error(
        'GET /student/survey/ 2XX readonly SurveyQuestion[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /student/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /student/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /student/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /student/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getStudentSurveyQuestions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /student/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentSurveyQuestionsAnswersParams {
  readonly "body": {
    readonly "data": readonly QuestionAnswerRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postStudentSurveyQuestionsAnswersOk = SurveyProgress

export type postStudentSurveyQuestionsAnswersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentSurveyQuestionsAnswers (params: postStudentSurveyQuestionsAnswersParams): Promise<postStudentSurveyQuestionsAnswersOk> {
  let url = "/student/survey/"
  url += params.args["id"]
  url += "/questions/answers"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "data": params.body["data"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX SurveyProgress
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SurveyProgressDecoder).decode(data)
    if (result.ok) {
      return identity<SurveyProgress>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 2XX SurveyProgress\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentSurveyQuestionsAnswers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentSurveyCloseParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postStudentSurveyCloseOk = null

export type postStudentSurveyCloseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentSurveyClose (params: postStudentSurveyCloseParams): Promise<postStudentSurveyCloseOk> {
  let url = "/student/survey/"
  url += params.args["id"]
  url += "/close"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentSurveyClose"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postStudentSurveyFinishParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postStudentSurveyFinishOk = never

export type postStudentSurveyFinishErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postStudentSurveyFinish (params: postStudentSurveyFinishParams): Promise<postStudentSurveyFinishOk> {
  let url = "/student/survey/"
  url += params.args["id"]
  url += "/finish"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /student/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postStudentSurveyFinish"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /student/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerSurveyActiveParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getLecturerSurveyActiveOk = Survey

export type getLecturerSurveyActiveErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerSurveyActive (params: getLecturerSurveyActiveParams): Promise<getLecturerSurveyActiveOk> {
  const url = "/lecturer/survey/active"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX Survey
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SurveyDecoder).decode(data)
    if (result.ok) {
      return identity<Survey>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/active 2XX Survey\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/active 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/active 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/active 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/active 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerSurveyActive"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/active XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerSurveyQuestionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerSurveyQuestionsOk = readonly SurveyQuestion[]

export type getLecturerSurveyQuestionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerSurveyQuestions (params: getLecturerSurveyQuestionsParams): Promise<getLecturerSurveyQuestionsOk> {
  let url = "/lecturer/survey/"
  url += params.args["id"]
  url += "/questions"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly SurveyQuestion[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SurveyQuestionDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly SurveyQuestion[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/ 2XX readonly SurveyQuestion[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerSurveyQuestions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerSurveyQuestionsAnswersParams {
  readonly "body": {
    readonly "data": readonly QuestionAnswerRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postLecturerSurveyQuestionsAnswersOk = SurveyProgress

export type postLecturerSurveyQuestionsAnswersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerSurveyQuestionsAnswers (params: postLecturerSurveyQuestionsAnswersParams): Promise<postLecturerSurveyQuestionsAnswersOk> {
  let url = "/lecturer/survey/"
  url += params.args["id"]
  url += "/questions/answers"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "data": params.body["data"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX SurveyProgress
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SurveyProgressDecoder).decode(data)
    if (result.ok) {
      return identity<SurveyProgress>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 2XX SurveyProgress\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerSurveyQuestionsAnswers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerSurveyCloseParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postLecturerSurveyCloseOk = null

export type postLecturerSurveyCloseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerSurveyClose (params: postLecturerSurveyCloseParams): Promise<postLecturerSurveyCloseOk> {
  let url = "/lecturer/survey/"
  url += params.args["id"]
  url += "/close"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerSurveyClose"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerSurveyFinishParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postLecturerSurveyFinishOk = never

export type postLecturerSurveyFinishErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerSurveyFinish (params: postLecturerSurveyFinishParams): Promise<postLecturerSurveyFinishOk> {
  let url = "/lecturer/survey/"
  url += params.args["id"]
  url += "/finish"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerSurveyFinish"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/survey/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesDiscussionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getLecturerCoursesDiscussionsOk = readonly CoursePost[]

export type getLecturerCoursesDiscussionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesDiscussions (params: getLecturerCoursesDiscussionsParams): Promise<getLecturerCoursesDiscussionsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly CoursePost[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(CoursePostDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly CoursePost[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly CoursePost[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesDiscussions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerCoursesDiscussionsParams {
  readonly "body": {
    readonly "semId": number
    readonly "visibility": number
    readonly "groups"?: readonly string[]
    readonly "commenting": number
    readonly "body": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postLecturerCoursesDiscussionsOk = null

export type postLecturerCoursesDiscussionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerCoursesDiscussions (params: postLecturerCoursesDiscussionsParams): Promise<postLecturerCoursesDiscussionsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "visibility": params.body["visibility"],
      "groups": params.body["groups"],
      "commenting": params.body["commenting"],
      "body": params.body["body"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerCoursesDiscussions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteLecturerCoursesDiscussionsParams {
  readonly "body": {
    readonly "semId": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export type deleteLecturerCoursesDiscussionsOk = MessageObject

export type deleteLecturerCoursesDiscussionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteLecturerCoursesDiscussions (params: deleteLecturerCoursesDiscussionsParams): Promise<deleteLecturerCoursesDiscussionsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions/"
  url += params.args["postId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteLecturerCoursesDiscussions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface patchLecturerCoursesDiscussionsParams {
  readonly "body": {
    readonly "semId": string
    readonly "visibility": number
    readonly "groups"?: readonly string[]
    readonly "commenting": number
    readonly "body": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export type patchLecturerCoursesDiscussionsOk = null

export type patchLecturerCoursesDiscussionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function patchLecturerCoursesDiscussions (params: patchLecturerCoursesDiscussionsParams): Promise<patchLecturerCoursesDiscussionsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions/"
  url += params.args["postId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PATCH",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
      "visibility": params.body["visibility"],
      "groups": params.body["groups"],
      "commenting": params.body["commenting"],
      "body": params.body["body"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("patchLecturerCoursesDiscussions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PATCH /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesDiscussionParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export type getLecturerCoursesDiscussionOk = CoursePost

export type getLecturerCoursesDiscussionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesDiscussion (params: getLecturerCoursesDiscussionParams): Promise<getLecturerCoursesDiscussionOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions/"
  url += params.args["postId"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CoursePost
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CoursePostDecoder).decode(data)
    if (result.ok) {
      return identity<CoursePost>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX CoursePost\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesDiscussion"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesDiscussionsCommentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export interface getLecturerCoursesDiscussionsCommentsOk {
  readonly "data": readonly CoursePostComment[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getLecturerCoursesDiscussionsCommentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesDiscussionsComments (params: getLecturerCoursesDiscussionsCommentsParams): Promise<getLecturerCoursesDiscussionsCommentsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions/"
  url += params.args["postId"]
  url += "/comments"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly CoursePostComment[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(CoursePostCommentDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly CoursePostComment[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX {\n' +
        '  readonly "data": readonly CoursePostComment[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesDiscussionsComments"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postLecturerCoursesDiscussionsCommentsParams {
  readonly "body": {
    readonly "replyCommentId"?: number
    readonly "body": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
  }
}

export type postLecturerCoursesDiscussionsCommentsOk = CoursePostComment

export type postLecturerCoursesDiscussionsCommentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postLecturerCoursesDiscussionsComments (params: postLecturerCoursesDiscussionsCommentsParams): Promise<postLecturerCoursesDiscussionsCommentsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions/"
  url += params.args["postId"]
  url += "/comments"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "replyCommentId": params.body["replyCommentId"],
      "body": params.body["body"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX CoursePostComment
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(CoursePostCommentDecoder).decode(data)
    if (result.ok) {
      return identity<CoursePostComment>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 2XX CoursePostComment\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postLecturerCoursesDiscussionsComments"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteLecturerCoursesDiscussionsCommentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
  readonly "args": {
    readonly "id": string
    readonly "postId": string
    readonly "commentId": string
  }
}

export type deleteLecturerCoursesDiscussionsCommentsOk = MessageObject

export type deleteLecturerCoursesDiscussionsCommentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteLecturerCoursesDiscussionsComments (params: deleteLecturerCoursesDiscussionsCommentsParams): Promise<deleteLecturerCoursesDiscussionsCommentsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/discussions/"
  url += params.args["postId"]
  url += "/comments/"
  url += params.args["commentId"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX MessageObject
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(MessageObjectDecoder).decode(data)
    if (result.ok) {
      return identity<MessageObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 2XX MessageObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteLecturerCoursesDiscussionsComments"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesSurveyResultsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "semId": string
  }
}

export type getLecturerCoursesSurveyResultsOk = readonly LecturerSurveyList[]

export type getLecturerCoursesSurveyResultsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesSurveyResults (params: getLecturerCoursesSurveyResultsParams): Promise<getLecturerCoursesSurveyResultsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/surveys/"
  url += params.args["semId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly LecturerSurveyList[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(LecturerSurveyListDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly LecturerSurveyList[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly LecturerSurveyList[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesSurveyResults"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesSurveyChartDataParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "surveyId": string
  }
}

export type getLecturerCoursesSurveyChartDataOk = readonly SurveyChart[]

export type getLecturerCoursesSurveyChartDataErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesSurveyChartData (params: getLecturerCoursesSurveyChartDataParams): Promise<getLecturerCoursesSurveyChartDataOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/survey/"
  url += params.args["surveyId"]
  url += "/chart-data"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly SurveyChart[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(SurveyChartDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly SurveyChart[]>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX readonly SurveyChart[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesSurveyChartData"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getLecturerCoursesScoresStatisticsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "semId": string
  }
}

export type getLecturerCoursesScoresStatisticsOk = ScoreDistribution

export type getLecturerCoursesScoresStatisticsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getLecturerCoursesScoresStatistics (params: getLecturerCoursesScoresStatisticsParams): Promise<getLecturerCoursesScoresStatisticsOk> {
  let url = "/lecturer/courses/"
  url += params.args["id"]
  url += "/scores/"
  url += params.args["semId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ScoreDistribution
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ScoreDistributionDecoder).decode(data)
    if (result.ok) {
      return identity<ScoreDistribution>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 2XX ScoreDistribution\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getLecturerCoursesScoresStatistics"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /lecturer/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegimeDegreesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getRegimeDegreesOk = readonly Degree[]

export type getRegimeDegreesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegimeDegrees (params: getRegimeDegreesParams): Promise<getRegimeDegreesOk> {
  const url = "/degrees"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Degree[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(DegreeDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Degree[]>(result.value)
    } else {
      console.error(
        'GET /degrees 2XX readonly Degree[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /degrees 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /degrees 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /degrees 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /degrees 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegimeDegrees"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /degrees XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegimeFacultiesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getRegimeFacultiesOk = readonly Faculty[]

export type getRegimeFacultiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegimeFaculties (params: getRegimeFacultiesParams): Promise<getRegimeFacultiesOk> {
  const url = "/faculties"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly Faculty[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FacultyDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly Faculty[]>(result.value)
    } else {
      console.error(
        'GET /faculties 2XX readonly Faculty[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /faculties 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /faculties 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /faculties 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /faculties 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegimeFaculties"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /faculties XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getRegimeDefinitionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getRegimeDefinitionsOk = RegimeDefinitions

export type getRegimeDefinitionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getRegimeDefinitions (params: getRegimeDefinitionsParams): Promise<getRegimeDefinitionsOk> {
  const url = "/definitions/regime"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX RegimeDefinitions
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(RegimeDefinitionsDecoder).decode(data)
    if (result.ok) {
      return identity<RegimeDefinitions>(result.value)
    } else {
      console.error(
        'GET /definitions/regime 2XX RegimeDefinitions\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /definitions/regime 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /definitions/regime 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /definitions/regime 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /definitions/regime 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getRegimeDefinitions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /definitions/regime XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getFilesDefinitionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getFilesDefinitionsOk = FileDefinitions

export type getFilesDefinitionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getFilesDefinitions (params: getFilesDefinitionsParams): Promise<getFilesDefinitionsOk> {
  const url = "/definitions/files"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX FileDefinitions
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(FileDefinitionsDecoder).decode(data)
    if (result.ok) {
      return identity<FileDefinitions>(result.value)
    } else {
      console.error(
        'GET /definitions/files 2XX FileDefinitions\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /definitions/files 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /definitions/files 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /definitions/files 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /definitions/files 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getFilesDefinitions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /definitions/files XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorFilesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "filters": {
      readonly "status": null | string
      readonly "search": null | string
      readonly "storage": null | string
    }
  }
}

export interface getAdministratorFilesOk {
  readonly "data": readonly MediaFile[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorFilesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorFiles (params: getAdministratorFilesParams): Promise<getAdministratorFilesOk> {
  const url = "/administrator/files"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly MediaFile[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(MediaFileDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly MediaFile[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/files 2XX {\n' +
        '  readonly "data": readonly MediaFile[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/files 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/files 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/files 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/files 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorFiles"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/files XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatisticsChoicesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
}

export type getAdministratorStatisticsChoicesOk = AdministratorStatistics

export type getAdministratorStatisticsChoicesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatisticsChoices (params: getAdministratorStatisticsChoicesParams): Promise<getAdministratorStatisticsChoicesOk> {
  const url = "/administrator/statistics/choices"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStatistics
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStatisticsDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStatistics>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/choices 2XX AdministratorStatistics\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/choices 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/choices 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/choices 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/choices 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatisticsChoices"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/choices XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatisticsActiveStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
}

export type getAdministratorStatisticsActiveStudentsOk = AdministratorStatistics

export type getAdministratorStatisticsActiveStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatisticsActiveStudents (params: getAdministratorStatisticsActiveStudentsParams): Promise<getAdministratorStatisticsActiveStudentsOk> {
  const url = "/administrator/statistics/active-students"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStatistics
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStatisticsDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStatistics>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/active-students 2XX AdministratorStatistics\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/active-students 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/active-students 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/active-students 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/active-students 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatisticsActiveStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/active-students XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorStatisticsGraduatesSearchParams {
  readonly "body": {
    readonly "type": AdministratorGraduatesStatisticsType
    readonly "semId"?: number
    readonly "q"?: string
    readonly "degree"?: number
    readonly "facultyId"?: number
    readonly "minorFacultyId"?: number
    readonly "eduStatuses"?: readonly number[]
    readonly "schoolId"?: number
    readonly "programId"?: number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorStatisticsGraduatesSearchOk = AdministratorGraduatesSearch

export type postAdministratorStatisticsGraduatesSearchErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorStatisticsGraduatesSearch (params: postAdministratorStatisticsGraduatesSearchParams): Promise<postAdministratorStatisticsGraduatesSearchOk> {
  const url = "/administrator/statistics/graduates/search"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "type": params.body["type"],
      "semId": params.body["semId"],
      "q": params.body["q"],
      "degree": params.body["degree"],
      "facultyId": params.body["facultyId"],
      "minorFacultyId": params.body["minorFacultyId"],
      "eduStatuses": params.body["eduStatuses"],
      "schoolId": params.body["schoolId"],
      "programId": params.body["programId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorGraduatesSearch
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorGraduatesSearchDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorGraduatesSearch>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/search 2XX AdministratorGraduatesSearch\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/search 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/search 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/search 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/search 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorStatisticsGraduatesSearch"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/search XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatisticsGraduatesSearchParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "searchId": string
  }
}

export type getAdministratorStatisticsGraduatesSearchOk = AdministratorGraduatesSearch

export type getAdministratorStatisticsGraduatesSearchErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatisticsGraduatesSearch (params: getAdministratorStatisticsGraduatesSearchParams): Promise<getAdministratorStatisticsGraduatesSearchOk> {
  let url = "/administrator/statistics/graduates/search/"
  url += params.args["searchId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorGraduatesSearch
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorGraduatesSearchDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorGraduatesSearch>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 2XX AdministratorGraduatesSearch\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatisticsGraduatesSearch"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatisticsGraduatesSearchRowsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "page"?: number
    readonly "perPage"?: number
  }
  readonly "args": {
    readonly "searchId": string
  }
}

export interface getAdministratorStatisticsGraduatesSearchRowsOk {
  readonly "data": readonly JSONRecord[]
  readonly "meta": AdministratorGraduatesStatisticsMeta
}

export type getAdministratorStatisticsGraduatesSearchRowsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatisticsGraduatesSearchRows (params: getAdministratorStatisticsGraduatesSearchRowsParams): Promise<getAdministratorStatisticsGraduatesSearchRowsOk> {
  let url = "/administrator/statistics/graduates/search/"
  url += params.args["searchId"]
  url += "/rows"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly JSONRecord[]
  //   readonly "meta": AdministratorGraduatesStatisticsMeta
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(JSONRecordDecoder),
      "meta": AdministratorGraduatesStatisticsMetaDecoder,
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly JSONRecord[]
        readonly "meta": AdministratorGraduatesStatisticsMeta
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 2XX {\n' +
        '  readonly "data": readonly JSONRecord[]\n' +
        '  readonly "meta": AdministratorGraduatesStatisticsMeta\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatisticsGraduatesSearchRows"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/search/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorStatisticsGraduatesExportParams {
  readonly "body": {
    readonly "type": AdministratorGraduatesStatisticsType
    readonly "semId"?: number
    readonly "q"?: string
    readonly "degree"?: number
    readonly "facultyId"?: number
    readonly "minorFacultyId"?: number
    readonly "eduStatuses"?: readonly number[]
    readonly "schoolId"?: number
    readonly "programId"?: number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorStatisticsGraduatesExportOk = AdministratorGraduatesExport

export type postAdministratorStatisticsGraduatesExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorStatisticsGraduatesExport (params: postAdministratorStatisticsGraduatesExportParams): Promise<postAdministratorStatisticsGraduatesExportOk> {
  const url = "/administrator/statistics/graduates/export"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "type": params.body["type"],
      "semId": params.body["semId"],
      "q": params.body["q"],
      "degree": params.body["degree"],
      "facultyId": params.body["facultyId"],
      "minorFacultyId": params.body["minorFacultyId"],
      "eduStatuses": params.body["eduStatuses"],
      "schoolId": params.body["schoolId"],
      "programId": params.body["programId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorGraduatesExport
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorGraduatesExportDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorGraduatesExport>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/export 2XX AdministratorGraduatesExport\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/export 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/export 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/export 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/export 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorStatisticsGraduatesExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/statistics/graduates/export XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatisticsGraduatesExportParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "exportId": string
  }
}

export type getAdministratorStatisticsGraduatesExportOk = AdministratorGraduatesExport

export type getAdministratorStatisticsGraduatesExportErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatisticsGraduatesExport (params: getAdministratorStatisticsGraduatesExportParams): Promise<getAdministratorStatisticsGraduatesExportOk> {
  let url = "/administrator/statistics/graduates/export/"
  url += params.args["exportId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorGraduatesExport
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorGraduatesExportDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorGraduatesExport>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/export/ 2XX AdministratorGraduatesExport\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/export/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/export/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/export/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/export/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatisticsGraduatesExport"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statistics/graduates/export/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCacheContentParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "key": string
  }
}

export interface getAdministratorCacheContentOk {
  readonly "data": null | string
}

export type getAdministratorCacheContentErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCacheContent (params: getAdministratorCacheContentParams): Promise<getAdministratorCacheContentOk> {
  const url = "/administrator/system/cache/content"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": null | string
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": decoders.nullable(decoders.string),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": null | string
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/content 2XX {\n' +
        '  readonly "data": null | string\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/content 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/content 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/content 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/content 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCacheContent"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/content XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCachesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "filters": {
      readonly "search": null | string
      readonly "server": null | string
    }
  }
}

export interface getAdministratorCachesOk {
  readonly "data": readonly CacheKey[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorCachesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCaches (params: getAdministratorCachesParams): Promise<getAdministratorCachesOk> {
  const url = "/administrator/system/cache/list"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly CacheKey[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(CacheKeyDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly CacheKey[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/list 2XX {\n' +
        '  readonly "data": readonly CacheKey[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/list 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/list 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/list 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/list 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCaches"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/list XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCacheServersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export interface getAdministratorCacheServersOk {
  readonly "data": {
    readonly "attributes": readonly string[]
  }
}

export type getAdministratorCacheServersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCacheServers (params: getAdministratorCacheServersParams): Promise<getAdministratorCacheServersOk> {
  const url = "/administrator/system/cache/servers"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": {
  //     readonly "attributes": readonly string[]
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": decoders.object({
        "attributes": ArrayObjectDecoder(decoders.string),
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": {
          readonly "attributes": readonly string[]
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/servers 2XX {\n' +
        '  readonly "data": {\n' +
        '    readonly "attributes": readonly string[]\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/servers 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/servers 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/servers 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/servers 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCacheServers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/system/cache/servers XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface deleteAdministratorCacheParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "key": string
  }
}

export type deleteAdministratorCacheOk = null

export type deleteAdministratorCacheErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function deleteAdministratorCache (params: deleteAdministratorCacheParams): Promise<deleteAdministratorCacheOk> {
  const url = "/administrator/system/cache/delete"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "DELETE",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'DELETE /administrator/system/cache/delete 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/system/cache/delete 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'DELETE /administrator/system/cache/delete 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'DELETE /administrator/system/cache/delete 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'DELETE /administrator/system/cache/delete 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("deleteAdministratorCache"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'DELETE /administrator/system/cache/delete XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface flushEntireCachesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type flushEntireCachesOk = null

export type flushEntireCachesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function flushEntireCaches (params: flushEntireCachesParams): Promise<flushEntireCachesOk> {
  const url = "/administrator/system/cache/flush"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/system/cache/flush 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/system/cache/flush 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/system/cache/flush 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/system/cache/flush 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/system/cache/flush 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("flushEntireCaches"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/system/cache/flush XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioSectionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
}

export interface getAdministratorPortfolioSectionsOk {
  readonly "data": readonly AdministratorPortfolioSection[]
}

export type getAdministratorPortfolioSectionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioSections (params: getAdministratorPortfolioSectionsParams): Promise<getAdministratorPortfolioSectionsOk> {
  const url = "/administrator/portfolio/sections"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorPortfolioSection[]
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorPortfolioSectionDecoder),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorPortfolioSection[]
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections 2XX {\n' +
        '  readonly "data": readonly AdministratorPortfolioSection[]\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioSections"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioCompetenciesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getAdministratorPortfolioCompetenciesOk {
  readonly "data": readonly AdministratorPortfolioCompetency[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorPortfolioCompetenciesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioCompetencies (params: getAdministratorPortfolioCompetenciesParams): Promise<getAdministratorPortfolioCompetenciesOk> {
  const url = "/administrator/portfolio/competencies"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorPortfolioCompetency[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorPortfolioCompetencyDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorPortfolioCompetency[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies 2XX {\n' +
        '  readonly "data": readonly AdministratorPortfolioCompetency[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioCompetencies"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioCriteriasParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
  }
}

export interface getAdministratorPortfolioCriteriasOk {
  readonly "data": readonly AdministratorPortfolioCriteria[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorPortfolioCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioCriterias (params: getAdministratorPortfolioCriteriasParams): Promise<getAdministratorPortfolioCriteriasOk> {
  const url = "/administrator/portfolio/criteria"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorPortfolioCriteria[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorPortfolioCriteriaDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorPortfolioCriteria[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria 2XX {\n' +
        '  readonly "data": readonly AdministratorPortfolioCriteria[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioSectionParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorPortfolioSectionOk = AdministratorPortfolioSectionDetails

export type getAdministratorPortfolioSectionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioSection (params: getAdministratorPortfolioSectionParams): Promise<getAdministratorPortfolioSectionOk> {
  let url = "/administrator/portfolio/sections/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorPortfolioSectionDetails
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorPortfolioSectionDetailsDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorPortfolioSectionDetails>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections/ 2XX AdministratorPortfolioSectionDetails\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioSection"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioCompetencyParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorPortfolioCompetencyOk = AdministratorPortfolioCompetency

export type getAdministratorPortfolioCompetencyErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioCompetency (params: getAdministratorPortfolioCompetencyParams): Promise<getAdministratorPortfolioCompetencyOk> {
  let url = "/administrator/portfolio/competencies/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorPortfolioCompetency
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorPortfolioCompetencyDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorPortfolioCompetency>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies/ 2XX AdministratorPortfolioCompetency\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioCompetency"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/competencies/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioCriteriaParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorPortfolioCriteriaOk = AdministratorPortfolioCriteria

export type getAdministratorPortfolioCriteriaErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioCriteria (params: getAdministratorPortfolioCriteriaParams): Promise<getAdministratorPortfolioCriteriaOk> {
  let url = "/administrator/portfolio/criteria/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorPortfolioCriteria
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorPortfolioCriteriaDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorPortfolioCriteria>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria/ 2XX AdministratorPortfolioCriteria\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioCriteria"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/criteria/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getPortfolioDefinitionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getPortfolioDefinitionsOk = PortfolioDefinitions

export type getPortfolioDefinitionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getPortfolioDefinitions (params: getPortfolioDefinitionsParams): Promise<getPortfolioDefinitionsOk> {
  const url = "/definitions/portfolio "
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX PortfolioDefinitions
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(PortfolioDefinitionsDecoder).decode(data)
    if (result.ok) {
      return identity<PortfolioDefinitions>(result.value)
    } else {
      console.error(
        'GET /definitions/portfolio  2XX PortfolioDefinitions\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /definitions/portfolio  401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /definitions/portfolio  403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /definitions/portfolio  422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /definitions/portfolio  503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getPortfolioDefinitions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /definitions/portfolio  XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorPortfolioSectionParams {
  readonly "body": {
    readonly "section": AdministratorPortfolioSectionRequest
    readonly "competencies": AdministratorPortfolioCompetencyRequest
    readonly "mentors": ReadonlyArray<readonly AdministratorPortfolioMentorRequest[]>
    readonly "semesters": readonly AdministratorPortfolioSemesterRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorPortfolioSectionOk = null

export type postAdministratorPortfolioSectionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorPortfolioSection (params: postAdministratorPortfolioSectionParams): Promise<postAdministratorPortfolioSectionOk> {
  const url = "/administrator/portfolio/sections"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "section": params.body["section"],
      "competencies": params.body["competencies"],
      "mentors": params.body["mentors"],
      "semesters": params.body["semesters"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/sections 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/sections 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/sections 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/sections 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/sections 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorPortfolioSection"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/sections XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorPortfolioSectionParams {
  readonly "body": {
    readonly "section"?: AdministratorPortfolioSectionRequest
    readonly "competencies"?: AdministratorPortfolioCompetencyRequest
    readonly "mentors"?: ReadonlyArray<readonly AdministratorPortfolioMentorRequest[]>
    readonly "semesters"?: readonly AdministratorPortfolioSemesterRequest[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorPortfolioSectionOk = null

export type putAdministratorPortfolioSectionErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorPortfolioSection (params: putAdministratorPortfolioSectionParams): Promise<putAdministratorPortfolioSectionOk> {
  let url = "/administrator/portfolio/sections/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "section": params.body["section"],
      "competencies": params.body["competencies"],
      "mentors": params.body["mentors"],
      "semesters": params.body["semesters"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/sections/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/sections/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/sections/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/sections/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/sections/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorPortfolioSection"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/sections/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorPortfolioCompetencyParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "description": string
    readonly "descriptionEn": string
    readonly "status": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorPortfolioCompetencyOk = null

export type postAdministratorPortfolioCompetencyErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorPortfolioCompetency (params: postAdministratorPortfolioCompetencyParams): Promise<postAdministratorPortfolioCompetencyOk> {
  const url = "/administrator/portfolio/competencies"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "description": params.body["description"],
      "descriptionEn": params.body["descriptionEn"],
      "status": params.body["status"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/competencies 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/competencies 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/competencies 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/competencies 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/competencies 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorPortfolioCompetency"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/competencies XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorPortfolioCompetencyParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "description": string
    readonly "descriptionEn": string
    readonly "status": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorPortfolioCompetencyOk = null

export type putAdministratorPortfolioCompetencyErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorPortfolioCompetency (params: putAdministratorPortfolioCompetencyParams): Promise<putAdministratorPortfolioCompetencyOk> {
  let url = "/administrator/portfolio/competencies/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "description": params.body["description"],
      "descriptionEn": params.body["descriptionEn"],
      "status": params.body["status"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/competencies/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/competencies/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/competencies/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/competencies/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/competencies/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorPortfolioCompetency"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/competencies/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorPortfolioCriteriaParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "description": string
    readonly "descriptionEn": string
    readonly "status": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorPortfolioCriteriaOk = null

export type postAdministratorPortfolioCriteriaErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorPortfolioCriteria (params: postAdministratorPortfolioCriteriaParams): Promise<postAdministratorPortfolioCriteriaOk> {
  const url = "/administrator/portfolio/criteria"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "description": params.body["description"],
      "descriptionEn": params.body["descriptionEn"],
      "status": params.body["status"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/criteria 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/criteria 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/criteria 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/criteria 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/criteria 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorPortfolioCriteria"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/criteria XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorPortfolioCriteriaParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "description": string
    readonly "descriptionEn": string
    readonly "status": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorPortfolioCriteriaOk = null

export type putAdministratorPortfolioCriteriaErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorPortfolioCriteria (params: putAdministratorPortfolioCriteriaParams): Promise<putAdministratorPortfolioCriteriaOk> {
  let url = "/administrator/portfolio/criteria/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "description": params.body["description"],
      "descriptionEn": params.body["descriptionEn"],
      "status": params.body["status"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/criteria/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/criteria/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/criteria/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/criteria/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/criteria/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorPortfolioCriteria"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/criteria/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsCompetenciesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorPortfolioListsCompetenciesOk = readonly PortfolioListsCompetency[]

export type getAdministratorPortfolioListsCompetenciesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsCompetencies (params: getAdministratorPortfolioListsCompetenciesParams): Promise<getAdministratorPortfolioListsCompetenciesOk> {
  const url = "/administrator/portfolio/lists/competencies"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsCompetency[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsCompetencyDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsCompetency[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/competencies 2XX readonly PortfolioListsCompetency[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/competencies 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/competencies 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/competencies 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/competencies 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsCompetencies"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/competencies XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsCriteriasParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorPortfolioListsCriteriasOk = readonly PortfolioListsCriteria[]

export type getAdministratorPortfolioListsCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsCriterias (params: getAdministratorPortfolioListsCriteriasParams): Promise<getAdministratorPortfolioListsCriteriasOk> {
  const url = "/administrator/portfolio/lists/criterias"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsCriteria[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsCriteriaDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsCriteria[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/criterias 2XX readonly PortfolioListsCriteria[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/criterias 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/criterias 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/criterias 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/criterias 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/criterias XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsMentorsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorPortfolioListsMentorsOk = readonly PortfolioListsMentor[]

export type getAdministratorPortfolioListsMentorsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsMentors (params: getAdministratorPortfolioListsMentorsParams): Promise<getAdministratorPortfolioListsMentorsOk> {
  const url = "/administrator/portfolio/lists/mentors"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsMentor[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsMentorDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsMentor[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/mentors 2XX readonly PortfolioListsMentor[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/mentors 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/mentors 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/mentors 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/mentors 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsMentors"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/mentors XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsStudentSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "sectionId"?: string
  }
}

export type getAdministratorPortfolioListsStudentSemestersOk = readonly PortfolioListsSemester[]

export type getAdministratorPortfolioListsStudentSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsStudentSemesters (params: getAdministratorPortfolioListsStudentSemestersParams): Promise<getAdministratorPortfolioListsStudentSemestersOk> {
  const url = "/administrator/portfolio/lists/student-semesters"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsSemester[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsSemesterDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsSemester[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/student-semesters 2XX readonly PortfolioListsSemester[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/student-semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/student-semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/student-semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/student-semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsStudentSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/student-semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsPortfolioMentorsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorPortfolioListsPortfolioMentorsOk = readonly PortfolioListsMentor[]

export type getAdministratorPortfolioListsPortfolioMentorsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsPortfolioMentors (params: getAdministratorPortfolioListsPortfolioMentorsParams): Promise<getAdministratorPortfolioListsPortfolioMentorsOk> {
  const url = "/administrator/portfolio/lists/portfolio-mentors"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsMentor[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsMentorDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsMentor[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-mentors 2XX readonly PortfolioListsMentor[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-mentors 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-mentors 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-mentors 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-mentors 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsPortfolioMentors"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-mentors XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsPortfolioSemestersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorPortfolioListsPortfolioSemestersOk = PortfolioSemester

export type getAdministratorPortfolioListsPortfolioSemestersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsPortfolioSemesters (params: getAdministratorPortfolioListsPortfolioSemestersParams): Promise<getAdministratorPortfolioListsPortfolioSemestersOk> {
  const url = "/administrator/portfolio/lists/portfolio-semesters"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX PortfolioSemester
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(PortfolioSemesterDecoder).decode(data)
    if (result.ok) {
      return identity<PortfolioSemester>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-semesters 2XX PortfolioSemester\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-semesters 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-semesters 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-semesters 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-semesters 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsPortfolioSemesters"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/portfolio-semesters XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": string
  }
}

export type getAdministratorPortfolioStudentsOk = readonly AdministratorPortfolioStudent[]

export type getAdministratorPortfolioStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioStudents (params: getAdministratorPortfolioStudentsParams): Promise<getAdministratorPortfolioStudentsOk> {
  const url = "/administrator/portfolio/students"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorPortfolioStudent[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorPortfolioStudentDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorPortfolioStudent[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/students 2XX readonly AdministratorPortfolioStudent[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/students 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/students 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/students 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/students 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/students XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semester"?: string
    readonly "sectionId"?: string
  }
}

export type getAdministratorPortfolioListsStudentsOk = readonly PortfolioListsStudent[]

export type getAdministratorPortfolioListsStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsStudents (params: getAdministratorPortfolioListsStudentsParams): Promise<getAdministratorPortfolioListsStudentsOk> {
  const url = "/administrator/portfolio/lists/students"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsStudent[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsStudentDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsStudent[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/students 2XX readonly PortfolioListsStudent[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/students 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/students 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/students 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/students 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/students XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioListsSectionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorPortfolioListsSectionsOk = readonly PortfolioListsSection[]

export type getAdministratorPortfolioListsSectionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioListsSections (params: getAdministratorPortfolioListsSectionsParams): Promise<getAdministratorPortfolioListsSectionsOk> {
  const url = "/administrator/portfolio/lists/sections"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly PortfolioListsSection[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(PortfolioListsSectionDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly PortfolioListsSection[]>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/sections 2XX readonly PortfolioListsSection[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/sections 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/sections 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/sections 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/sections 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioListsSections"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/lists/sections XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorPortfolioStudentsAssignParams {
  readonly "body": {
    readonly "mentorId": number
    readonly "studentId": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorPortfolioStudentsAssignOk = SuccessResponse

export type postAdministratorPortfolioStudentsAssignErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorPortfolioStudentsAssign (params: postAdministratorPortfolioStudentsAssignParams): Promise<postAdministratorPortfolioStudentsAssignOk> {
  const url = "/administrator/portfolio/students/assign"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "mentorId": params.body["mentorId"],
      "studentId": params.body["studentId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX SuccessResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(SuccessResponseDecoder).decode(data)
    if (result.ok) {
      return identity<SuccessResponse>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/students/assign 2XX SuccessResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/students/assign 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/students/assign 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/students/assign 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/students/assign 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorPortfolioStudentsAssign"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/students/assign XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioWorksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "semId": string
    readonly "sectionId": string
    readonly "semester": string
    readonly "status": string
    readonly "searchStudent": string
    readonly "searchMentor": string
  }
}

export interface getAdministratorPortfolioWorksOk {
  readonly "data": readonly AdministratorPortfolioWork[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorPortfolioWorksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioWorks (params: getAdministratorPortfolioWorksParams): Promise<getAdministratorPortfolioWorksOk> {
  const url = "/administrator/portfolio/works"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorPortfolioWork[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorPortfolioWorkDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorPortfolioWork[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works 2XX {\n' +
        '  readonly "data": readonly AdministratorPortfolioWork[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioWorks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioWorkParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorPortfolioWorkOk = AdministratorPortfolioWork

export type getAdministratorPortfolioWorkErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioWork (params: getAdministratorPortfolioWorkParams): Promise<getAdministratorPortfolioWorkOk> {
  let url = "/administrator/portfolio/works/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorPortfolioWork
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorPortfolioWorkDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorPortfolioWork>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works/ 2XX AdministratorPortfolioWork\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioWork"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/works/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorPortfolioLimitsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "semId": string
  }
}

export interface getAdministratorPortfolioLimitsOk {
  readonly "data": readonly AdministratorPortfolioLimit[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorPortfolioLimitsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPortfolioLimits (params: getAdministratorPortfolioLimitsParams): Promise<getAdministratorPortfolioLimitsOk> {
  const url = "/administrator/portfolio/limits"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorPortfolioLimit[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorPortfolioLimitDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorPortfolioLimit[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/limits 2XX {\n' +
        '  readonly "data": readonly AdministratorPortfolioLimit[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/limits 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/limits 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/limits 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/limits 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPortfolioLimits"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/portfolio/limits XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorPortfolioLimitsParams {
  readonly "body": {
    readonly "sectionId": number
    readonly "semester": number
    readonly "profileId": number
    readonly "userId": number
    readonly "allowed": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorPortfolioLimitsOk = null

export type postAdministratorPortfolioLimitsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorPortfolioLimits (params: postAdministratorPortfolioLimitsParams): Promise<postAdministratorPortfolioLimitsOk> {
  const url = "/administrator/portfolio/limits"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "sectionId": params.body["sectionId"],
      "semester": params.body["semester"],
      "profileId": params.body["profileId"],
      "userId": params.body["userId"],
      "allowed": params.body["allowed"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/limits 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/limits 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/limits 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/limits 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/limits 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorPortfolioLimits"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/portfolio/limits XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorPortfolioWorkEvaluateParams {
  readonly "body": {
    readonly "scores": ReadonlyArray<{
      readonly "competencyId": number
      readonly "criteriaId": number
      readonly "score": number
      readonly "feedback": string
    }>
    readonly "comment"?: string
    readonly "text"?: string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorPortfolioWorkEvaluateOk = null

export type putAdministratorPortfolioWorkEvaluateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorPortfolioWorkEvaluate (params: putAdministratorPortfolioWorkEvaluateParams): Promise<putAdministratorPortfolioWorkEvaluateOk> {
  let url = "/administrator/portfolio/works/"
  url += params.args["id"]
  url += "/evaluate"
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "scores": params.body["scores"],
      "comment": params.body["comment"],
      "text": params.body["text"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/works/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/works/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/works/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/works/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/works/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorPortfolioWorkEvaluate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/portfolio/works/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorFacultiesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "filters[name]": string
    readonly "filters[status]": string
    readonly "sortBy": string
  }
}

export interface getAdministratorFacultiesOk {
  readonly "data": readonly AdministratorFaculty[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorFacultiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorFaculties (params: getAdministratorFacultiesParams): Promise<getAdministratorFacultiesOk> {
  const url = "/administrator/faculties"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorFaculty[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorFacultyDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorFaculty[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties 2XX {\n' +
        '  readonly "data": readonly AdministratorFaculty[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorFaculties"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorProgramsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "page"?: number
    readonly "perPage"?: number
    readonly "sortBy"?: string
    readonly "search"?: string
    readonly "name"?: string
    readonly "code"?: string
    readonly "status"?: number
    readonly "facultyId"?: number
    readonly "facultyIds"?: readonly number[]
    readonly "degree"?: number
    readonly "allowInRegistration"?: boolean
  }
}

export interface getAdministratorProgramsOk {
  readonly "data": readonly AdministratorProgram[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorPrograms (params: getAdministratorProgramsParams): Promise<getAdministratorProgramsOk> {
  const url = "/administrator/programs"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorProgram[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorProgramDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorProgram[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/programs 2XX {\n' +
        '  readonly "data": readonly AdministratorProgram[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/programs 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/programs 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/programs 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/programs 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/programs XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorFacultyParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorFacultyOk = AdministratorFaculty

export type getAdministratorFacultyErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorFaculty (params: getAdministratorFacultyParams): Promise<getAdministratorFacultyOk> {
  let url = "/administrator/faculties/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorFaculty
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorFacultyDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorFaculty>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/ 2XX AdministratorFaculty\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorFaculty"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorFacultyDegreesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorFacultyDegreesOk = AdministratorFacultyDegree

export type getAdministratorFacultyDegreesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorFacultyDegrees (params: getAdministratorFacultyDegreesParams): Promise<getAdministratorFacultyDegreesOk> {
  const url = "/administrator/faculties/degrees"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorFacultyDegree
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorFacultyDegreeDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorFacultyDegree>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/degrees 2XX AdministratorFacultyDegree\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/degrees 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/degrees 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/degrees 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/degrees 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorFacultyDegrees"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/faculties/degrees XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorDeanUsersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorDeanUsersOk = ReadonlyArray<{
  readonly "id": IDString
  readonly "fullName": string
}>

export type getAdministratorDeanUsersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorDeanUsers (params: getAdministratorDeanUsersParams): Promise<getAdministratorDeanUsersOk> {
  const url = "/administrator/users/lecturer/list?perPage=5000"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ReadonlyArray<{
  //   readonly "id": IDString
  //   readonly "fullName": string
  // }>
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder((
      decoders.object({
        attributes: decoders.object({
          "id": IDStringDecoder,
          "fullName": decoders.string,
        }),
      })
      .transform(obj => {
        return {
          "id": obj.attributes["id"],
          "fullName": obj.attributes["fullName"],
        }
      })
    ))).decode(data)
    if (result.ok) {
      return identity<ReadonlyArray<{
        readonly "id": IDString
        readonly "fullName": string
      }>>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer/list?perPage=5000 2XX ReadonlyArray<{\n' +
        '  readonly "id": IDString\n' +
        '  readonly "fullName": string\n' +
        '}>\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer/list?perPage=5000 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer/list?perPage=5000 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer/list?perPage=5000 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer/list?perPage=5000 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorDeanUsers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/users/lecturer/list?perPage=5000 XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorDefinitionsUsersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorDefinitionsUsersOk = AdministratorDefinitionUser

export type getAdministratorDefinitionsUsersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorDefinitionsUsers (params: getAdministratorDefinitionsUsersParams): Promise<getAdministratorDefinitionsUsersOk> {
  const url = "/definitions/users"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorDefinitionUser
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorDefinitionUserDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorDefinitionUser>(result.value)
    } else {
      console.error(
        'GET /definitions/users 2XX AdministratorDefinitionUser\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /definitions/users 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /definitions/users 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /definitions/users 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /definitions/users 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorDefinitionsUsers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /definitions/users XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorDefinitionsStudentsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorDefinitionsStudentsOk = AdministratorDefinitionStudent

export type getAdministratorDefinitionsStudentsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorDefinitionsStudents (params: getAdministratorDefinitionsStudentsParams): Promise<getAdministratorDefinitionsStudentsOk> {
  const url = "/definitions/students"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorDefinitionStudent
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorDefinitionStudentDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorDefinitionStudent>(result.value)
    } else {
      console.error(
        'GET /definitions/students 2XX AdministratorDefinitionStudent\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /definitions/students 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /definitions/students 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /definitions/students 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /definitions/students 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorDefinitionsStudents"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /definitions/students XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorFacultyParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "code": string
    readonly "status": number
    readonly "dean": string
    readonly "mail": string
    readonly "feedbackMail": string
    readonly "consultationMail": string
    readonly "allowInRegistration": boolean
    readonly "allowInMinorRegistration": boolean
    readonly "hasMajorMinor": number
    readonly "bachelorMajor": readonly number[]
    readonly "bachelorMinor": readonly number[]
    readonly "bachelorMasterMinor": readonly number[]
    readonly "bachelorMasterMajor": readonly number[]
    readonly "masterMajor": readonly number[]
    readonly "masterMinor": readonly number[]
    readonly "doctoralMajor": readonly number[]
    readonly "doctoralMinor": readonly number[]
    readonly "professionalMajor": readonly number[]
    readonly "professionalMinor": readonly number[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorFacultyOk = null

export type putAdministratorFacultyErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorFaculty (params: putAdministratorFacultyParams): Promise<putAdministratorFacultyOk> {
  let url = "/administrator/faculties/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "code": params.body["code"],
      "status": params.body["status"],
      "dean": params.body["dean"],
      "mail": params.body["mail"],
      "feedbackMail": params.body["feedbackMail"],
      "consultationMail": params.body["consultationMail"],
      "allowInRegistration": params.body["allowInRegistration"],
      "allowInMinorRegistration": params.body["allowInMinorRegistration"],
      "hasMajorMinor": params.body["hasMajorMinor"],
      "bachelorMajor": params.body["bachelorMajor"],
      "bachelorMinor": params.body["bachelorMinor"],
      "bachelorMasterMinor": params.body["bachelorMasterMinor"],
      "bachelorMasterMajor": params.body["bachelorMasterMajor"],
      "masterMajor": params.body["masterMajor"],
      "masterMinor": params.body["masterMinor"],
      "doctoralMajor": params.body["doctoralMajor"],
      "doctoralMinor": params.body["doctoralMinor"],
      "professionalMajor": params.body["professionalMajor"],
      "professionalMinor": params.body["professionalMinor"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'PUT /administrator/faculties/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/faculties/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/faculties/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/faculties/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/faculties/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorFaculty"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/faculties/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorFacultyParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "code": string
    readonly "status": number
    readonly "dean": string
    readonly "mail": string
    readonly "feedbackMail": string
    readonly "consultationMail": string
    readonly "allowInRegistration": boolean
    readonly "allowInMinorRegistration": boolean
    readonly "hasMajorMinor": number
    readonly "bachelorMajor": readonly number[]
    readonly "bachelorMinor": readonly number[]
    readonly "masterMajor": readonly number[]
    readonly "masterMinor": readonly number[]
    readonly "doctoralMajor": readonly number[]
    readonly "doctoralMinor": readonly number[]
    readonly "professionalMajor": readonly number[]
    readonly "professionalMinor": readonly number[]
    readonly "bachelorMasterMinor": readonly number[]
    readonly "bachelorMasterMajor": readonly number[]
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorFacultyOk = null

export type postAdministratorFacultyErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorFaculty (params: postAdministratorFacultyParams): Promise<postAdministratorFacultyOk> {
  const url = "/administrator/faculties"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "code": params.body["code"],
      "status": params.body["status"],
      "dean": params.body["dean"],
      "mail": params.body["mail"],
      "feedbackMail": params.body["feedbackMail"],
      "consultationMail": params.body["consultationMail"],
      "allowInRegistration": params.body["allowInRegistration"],
      "allowInMinorRegistration": params.body["allowInMinorRegistration"],
      "hasMajorMinor": params.body["hasMajorMinor"],
      "bachelorMajor": params.body["bachelorMajor"],
      "bachelorMinor": params.body["bachelorMinor"],
      "masterMajor": params.body["masterMajor"],
      "masterMinor": params.body["masterMinor"],
      "doctoralMajor": params.body["doctoralMajor"],
      "doctoralMinor": params.body["doctoralMinor"],
      "professionalMajor": params.body["professionalMajor"],
      "professionalMinor": params.body["professionalMinor"],
      "bachelorMasterMinor": params.body["bachelorMasterMinor"],
      "bachelorMasterMajor": params.body["bachelorMasterMajor"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/faculties 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/faculties 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/faculties 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/faculties 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/faculties 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorFaculty"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/faculties XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorProgramParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorProgramOk = AdministratorProgram

export type getAdministratorProgramErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorProgram (params: getAdministratorProgramParams): Promise<getAdministratorProgramOk> {
  let url = "/administrator/programs/show/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorProgram
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorProgramDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorProgram>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/show/ 2XX AdministratorProgram\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/show/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/show/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/show/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/show/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorProgram"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/show/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorProgramFacultySchoolsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorProgramFacultySchoolsOk = readonly FacultySchool[]

export type getAdministratorProgramFacultySchoolsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorProgramFacultySchools (params: getAdministratorProgramFacultySchoolsParams): Promise<getAdministratorProgramFacultySchoolsOk> {
  let url = "/administrator/programs/faculty-schools/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly FacultySchool[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(FacultySchoolDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly FacultySchool[]>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/faculty-schools/ 2XX readonly FacultySchool[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/faculty-schools/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/faculty-schools/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/faculty-schools/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/faculty-schools/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorProgramFacultySchools"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/programs/faculty-schools/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorProgramsUpdateParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "fullname": string
    readonly "fullnameEn": string
    readonly "minorFullname": string
    readonly "minorFullnameEn": string
    readonly "direction": string
    readonly "directionEn": string
    readonly "specialty": string
    readonly "specialtyEn": string
    readonly "degree": number
    readonly "facultyId": number
    readonly "status": number
    readonly "code": string
    readonly "prefix": string
    readonly "testtypeId"?: null | number
    readonly "allowInRegistration": boolean
    readonly "allowInMobility": boolean
    readonly "hasMajorMinor": number
    readonly "facultySchoolId"?: null | number
    readonly "failsForExpel": number
    readonly "registrationRequirements": string
    readonly "hasFreeCredits": boolean
    readonly "languageRestrictionEnabled": boolean
    readonly "showFreeCreditCourses": boolean
    readonly "genCredits": number
    readonly "baseCredits": number
    readonly "otherCredits": number
    readonly "price": number
    readonly "creditYears": string
    readonly "learningLang": string
    readonly "qualificationCredits": number
    readonly "minorGenCredits": number
    readonly "minorBaseCredits": number
    readonly "minorOtherCredits": number
    readonly "description": string
    readonly "descriptionEn": string
    readonly "requirementsMajor": string
    readonly "requirementsMajorEn": string
    readonly "requirementsMinor": string
    readonly "requirementsMinorEn": string
    readonly "qualificationMajor": string
    readonly "qualificationMajorEn": string
    readonly "qualificationFields": string
    readonly "qualificationFieldsEn": string
    readonly "minorDescription": string
    readonly "minorDescriptionEn": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type postAdministratorProgramsUpdateOk = null

export type postAdministratorProgramsUpdateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorProgramsUpdate (params: postAdministratorProgramsUpdateParams): Promise<postAdministratorProgramsUpdateOk> {
  let url = "/administrator/programs/save/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "fullname": params.body["fullname"],
      "fullnameEn": params.body["fullnameEn"],
      "minorFullname": params.body["minorFullname"],
      "minorFullnameEn": params.body["minorFullnameEn"],
      "direction": params.body["direction"],
      "directionEn": params.body["directionEn"],
      "specialty": params.body["specialty"],
      "specialtyEn": params.body["specialtyEn"],
      "degree": params.body["degree"],
      "facultyId": params.body["facultyId"],
      "status": params.body["status"],
      "code": params.body["code"],
      "prefix": params.body["prefix"],
      "testtypeId": params.body["testtypeId"],
      "allowInRegistration": params.body["allowInRegistration"],
      "allowInMobility": params.body["allowInMobility"],
      "hasMajorMinor": params.body["hasMajorMinor"],
      "facultySchoolId": params.body["facultySchoolId"],
      "failsForExpel": params.body["failsForExpel"],
      "registrationRequirements": params.body["registrationRequirements"],
      "hasFreeCredits": params.body["hasFreeCredits"],
      "languageRestrictionEnabled": params.body["languageRestrictionEnabled"],
      "showFreeCreditCourses": params.body["showFreeCreditCourses"],
      "genCredits": params.body["genCredits"],
      "baseCredits": params.body["baseCredits"],
      "otherCredits": params.body["otherCredits"],
      "price": params.body["price"],
      "creditYears": params.body["creditYears"],
      "learningLang": params.body["learningLang"],
      "qualificationCredits": params.body["qualificationCredits"],
      "minorGenCredits": params.body["minorGenCredits"],
      "minorBaseCredits": params.body["minorBaseCredits"],
      "minorOtherCredits": params.body["minorOtherCredits"],
      "description": params.body["description"],
      "descriptionEn": params.body["descriptionEn"],
      "requirementsMajor": params.body["requirementsMajor"],
      "requirementsMajorEn": params.body["requirementsMajorEn"],
      "requirementsMinor": params.body["requirementsMinor"],
      "requirementsMinorEn": params.body["requirementsMinorEn"],
      "qualificationMajor": params.body["qualificationMajor"],
      "qualificationMajorEn": params.body["qualificationMajorEn"],
      "qualificationFields": params.body["qualificationFields"],
      "qualificationFieldsEn": params.body["qualificationFieldsEn"],
      "minorDescription": params.body["minorDescription"],
      "minorDescriptionEn": params.body["minorDescriptionEn"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save/ 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorProgramsUpdate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorProgramsCreateParams {
  readonly "body": {
    readonly "name": string
    readonly "nameEn": string
    readonly "fullname": string
    readonly "fullnameEn": string
    readonly "minorFullname": string
    readonly "minorFullnameEn": string
    readonly "direction": string
    readonly "directionEn": string
    readonly "specialty": string
    readonly "specialtyEn": string
    readonly "degree": number
    readonly "facultyId": number
    readonly "status": number
    readonly "code": string
    readonly "prefix": string
    readonly "testtypeId"?: null | number
    readonly "allowInRegistration": boolean
    readonly "allowInMobility": boolean
    readonly "hasMajorMinor": number
    readonly "facultySchoolId"?: null | number
    readonly "failsForExpel": number
    readonly "registrationRequirements": string
    readonly "hasFreeCredits": boolean
    readonly "languageRestrictionEnabled": boolean
    readonly "showFreeCreditCourses": boolean
    readonly "genCredits": number
    readonly "baseCredits": number
    readonly "otherCredits": number
    readonly "price": number
    readonly "creditYears": string
    readonly "learningLang": string
    readonly "qualificationCredits": number
    readonly "minorGenCredits": number
    readonly "minorBaseCredits": number
    readonly "minorOtherCredits": number
    readonly "description": string
    readonly "descriptionEn": string
    readonly "requirementsMajor": string
    readonly "requirementsMajorEn": string
    readonly "requirementsMinor": string
    readonly "requirementsMinorEn": string
    readonly "qualificationMajor": string
    readonly "qualificationMajorEn": string
    readonly "qualificationFields": string
    readonly "qualificationFieldsEn": string
    readonly "minorDescription": string
    readonly "minorDescriptionEn": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorProgramsCreateOk = null

export type postAdministratorProgramsCreateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorProgramsCreate (params: postAdministratorProgramsCreateParams): Promise<postAdministratorProgramsCreateOk> {
  const url = "/administrator/programs/save"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "fullname": params.body["fullname"],
      "fullnameEn": params.body["fullnameEn"],
      "minorFullname": params.body["minorFullname"],
      "minorFullnameEn": params.body["minorFullnameEn"],
      "direction": params.body["direction"],
      "directionEn": params.body["directionEn"],
      "specialty": params.body["specialty"],
      "specialtyEn": params.body["specialtyEn"],
      "degree": params.body["degree"],
      "facultyId": params.body["facultyId"],
      "status": params.body["status"],
      "code": params.body["code"],
      "prefix": params.body["prefix"],
      "testtypeId": params.body["testtypeId"],
      "allowInRegistration": params.body["allowInRegistration"],
      "allowInMobility": params.body["allowInMobility"],
      "hasMajorMinor": params.body["hasMajorMinor"],
      "facultySchoolId": params.body["facultySchoolId"],
      "failsForExpel": params.body["failsForExpel"],
      "registrationRequirements": params.body["registrationRequirements"],
      "hasFreeCredits": params.body["hasFreeCredits"],
      "languageRestrictionEnabled": params.body["languageRestrictionEnabled"],
      "showFreeCreditCourses": params.body["showFreeCreditCourses"],
      "genCredits": params.body["genCredits"],
      "baseCredits": params.body["baseCredits"],
      "otherCredits": params.body["otherCredits"],
      "price": params.body["price"],
      "creditYears": params.body["creditYears"],
      "learningLang": params.body["learningLang"],
      "qualificationCredits": params.body["qualificationCredits"],
      "minorGenCredits": params.body["minorGenCredits"],
      "minorBaseCredits": params.body["minorBaseCredits"],
      "minorOtherCredits": params.body["minorOtherCredits"],
      "description": params.body["description"],
      "descriptionEn": params.body["descriptionEn"],
      "requirementsMajor": params.body["requirementsMajor"],
      "requirementsMajorEn": params.body["requirementsMajorEn"],
      "requirementsMinor": params.body["requirementsMinor"],
      "requirementsMinorEn": params.body["requirementsMinorEn"],
      "qualificationMajor": params.body["qualificationMajor"],
      "qualificationMajorEn": params.body["qualificationMajorEn"],
      "qualificationFields": params.body["qualificationFields"],
      "qualificationFieldsEn": params.body["qualificationFieldsEn"],
      "minorDescription": params.body["minorDescription"],
      "minorDescriptionEn": params.body["minorDescriptionEn"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorProgramsCreate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/programs/save XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsCoursesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "q"?: string
    readonly "semId"?: number
  }
}

export type getAdministratorListsCoursesOk = AdministratorListsCoursesResponse

export type getAdministratorListsCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsCourses (params: getAdministratorListsCoursesParams): Promise<getAdministratorListsCoursesOk> {
  const url = "/administrator/lists/courses"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsCoursesResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsCoursesResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsCoursesResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/courses 2XX AdministratorListsCoursesResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/courses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/courses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/courses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/courses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/courses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsCourseTypesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsCourseTypesOk = ReadonlyArray<{
  readonly "id": IDString
  readonly "name": string
}>

export type getAdministratorListsCourseTypesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsCourseTypes (params: getAdministratorListsCourseTypesParams): Promise<getAdministratorListsCourseTypesOk> {
  const url = "/administrator/lists/course-types"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX ReadonlyArray<{
  //   readonly "id": IDString
  //   readonly "name": string
  // }>
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(decoders.object({
      "id": IDStringDecoder,
      "name": decoders.string,
    }))).decode(data)
    if (result.ok) {
      return identity<ReadonlyArray<{
        readonly "id": IDString
        readonly "name": string
      }>>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-types 2XX ReadonlyArray<{\n' +
        '  readonly "id": IDString\n' +
        '  readonly "name": string\n' +
        '}>\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-types 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-types 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-types 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-types 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsCourseTypes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-types XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseDefinitionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorCourseDefinitionsOk = AdministratorCourseDefinition

export type getAdministratorCourseDefinitionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourseDefinitions (params: getAdministratorCourseDefinitionsParams): Promise<getAdministratorCourseDefinitionsOk> {
  const url = "/definitions/courses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseDefinition
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseDefinitionDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseDefinition>(result.value)
    } else {
      console.error(
        'GET /definitions/courses 2XX AdministratorCourseDefinition\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /definitions/courses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /definitions/courses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /definitions/courses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /definitions/courses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourseDefinitions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /definitions/courses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCoursesDisableChooseRegimeParams {
  readonly "body": {
    readonly "semId": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorCoursesDisableChooseRegimeOk = null

export type postAdministratorCoursesDisableChooseRegimeErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCoursesDisableChooseRegime (params: postAdministratorCoursesDisableChooseRegimeParams): Promise<postAdministratorCoursesDisableChooseRegimeOk> {
  const url = "/administrator/courses/disable-choose-regime"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "semId": params.body["semId"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX null
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.hardcoded(null)).decode(data)
    if (result.ok) {
      return identity<null>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/disable-choose-regime 2XX null\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/disable-choose-regime 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/disable-choose-regime 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/disable-choose-regime 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/disable-choose-regime 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCoursesDisableChooseRegime"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses/disable-choose-regime XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCoursesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "page": number
    readonly "perPage": number
    readonly "sortBy"?: string
    readonly "filters[semId]"?: number
    readonly "filters[status]"?: number
    readonly "filters[degree]"?: number
    readonly "filters[facId]"?: number
    readonly "filters[query]"?: string
    readonly "filters[general]"?: string
    readonly "filters[type]"?: number
  }
}

export interface getAdministratorCoursesOk {
  readonly "data": readonly AdministratorCourse[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourses (params: getAdministratorCoursesParams): Promise<getAdministratorCoursesOk> {
  const url = "/administrator/courses"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorCourse[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorCourseDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorCourse[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/courses 2XX {\n' +
        '  readonly "data": readonly AdministratorCourse[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorCourseParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorCourseOk = AdministratorCourse

export type getAdministratorCourseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorCourse (params: getAdministratorCourseParams): Promise<getAdministratorCourseOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourse>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 2XX AdministratorCourse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorCourse"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface postAdministratorCoursesParams {
  readonly "body": {
    readonly "name": string
    readonly "facId": number
    readonly "semId": number
    readonly "degree": number
    readonly "status": number
    readonly "typeId": number
    readonly "credits": number
    readonly "chooseRegime": boolean
    readonly "nameEn"?: string
    readonly "code"?: string
    readonly "userSem"?: readonly number[]
    readonly "examCreditLimit"?: number
    readonly "scoreThresholdMin"?: number
    readonly "scoreThresholdMax"?: number
    readonly "failsForExpel"?: number
    readonly "general"?: boolean
    readonly "studySem"?: number
    readonly "groupName"?: string
    readonly "facs"?: readonly number[]
    readonly "genCodes"?: ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
    readonly "baseCodes"?: ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
    readonly "otherCodes"?: ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
    readonly "locale"?: string
    readonly "showInFreeCredits"?: null | boolean
    readonly "facsProgramIds"?: readonly number[]
    readonly "primaryLecturerId"?: number
    readonly "type"?: number
    readonly "syllabus"?: {
      readonly "duration"?: string
      readonly "hours"?: string
      readonly "lecturers"?: string
      readonly "prerequisites"?: string
      readonly "methods"?: string
      readonly "mission"?: string
      readonly "topics"?: string
      readonly "outcomes"?: string
      readonly "evaluation"?: string
      readonly "resources"?: string
      readonly "otherResources"?: string
      readonly "schedule"?: string
      readonly "knowledge"?: boolean
      readonly "applying"?: boolean
      readonly "judgments"?: boolean
      readonly "communications"?: boolean
      readonly "learning"?: boolean
      readonly "values"?: boolean
      readonly "syllabusFileUid"?: string
    }
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type postAdministratorCoursesOk = AdministratorCourse

export type postAdministratorCoursesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function postAdministratorCourses (params: postAdministratorCoursesParams): Promise<postAdministratorCoursesOk> {
  const url = "/administrator/courses"
  const response = await fetch(baseURL + url, {
    method: "POST",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "facId": params.body["facId"],
      "semId": params.body["semId"],
      "degree": params.body["degree"],
      "status": params.body["status"],
      "typeId": params.body["typeId"],
      "credits": params.body["credits"],
      "chooseRegime": params.body["chooseRegime"],
      "nameEn": params.body["nameEn"],
      "code": params.body["code"],
      "userSem": params.body["userSem"],
      "examCreditLimit": params.body["examCreditLimit"],
      "scoreThresholdMin": params.body["scoreThresholdMin"],
      "scoreThresholdMax": params.body["scoreThresholdMax"],
      "failsForExpel": params.body["failsForExpel"],
      "general": params.body["general"],
      "studySem": params.body["studySem"],
      "groupName": params.body["groupName"],
      "facs": params.body["facs"],
      "genCodes": params.body["genCodes"],
      "baseCodes": params.body["baseCodes"],
      "otherCodes": params.body["otherCodes"],
      "locale": params.body["locale"],
      "showInFreeCredits": params.body["showInFreeCredits"],
      "facsProgramIds": params.body["facsProgramIds"],
      "primaryLecturerId": params.body["primaryLecturerId"],
      "type": params.body["type"],
      "syllabus": params.body["syllabus"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourse>(result.value)
    } else {
      console.error(
        'POST /administrator/courses 2XX AdministratorCourse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'POST /administrator/courses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'POST /administrator/courses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'POST /administrator/courses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("postAdministratorCourses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'POST /administrator/courses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorCourseParams {
  readonly "body": {
    readonly "name"?: string
    readonly "nameEn"?: string
    readonly "code"?: string
    readonly "status"?: number
    readonly "degree"?: number
    readonly "typeId"?: number
    readonly "credits"?: number
    readonly "chooseRegime"?: boolean
    readonly "userSem"?: readonly number[]
    readonly "general"?: boolean
    readonly "studySem"?: null | number
    readonly "groupName"?: string
    readonly "examCreditLimit"?: number
    readonly "scoreThresholdMin"?: number
    readonly "scoreThresholdMax"?: number
    readonly "failsForExpel"?: null | number
    readonly "facId"?: number
    readonly "primaryLecturerId"?: number
    readonly "facs"?: readonly number[]
    readonly "genCodes"?: ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
    readonly "baseCodes"?: ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
    readonly "otherCodes"?: ReadonlyArray<{
      readonly "code": string
      readonly "semesters"?: readonly number[]
    }>
    readonly "locale"?: string
    readonly "showInFreeCredits"?: null | boolean
    readonly "facsProgramIds"?: readonly number[]
    readonly "semId"?: number
    readonly "type"?: number
    readonly "syllabus"?: {
      readonly "duration"?: string
      readonly "hours"?: string
      readonly "lecturers"?: string
      readonly "prerequisites"?: string
      readonly "methods"?: string
      readonly "mission"?: string
      readonly "topics"?: string
      readonly "outcomes"?: string
      readonly "evaluation"?: string
      readonly "resources"?: string
      readonly "otherResources"?: string
      readonly "schedule"?: string
      readonly "knowledge"?: boolean
      readonly "applying"?: boolean
      readonly "judgments"?: boolean
      readonly "communications"?: boolean
      readonly "learning"?: boolean
      readonly "values"?: boolean
      readonly "syllabusFileUid"?: string
    }
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorCourseOk = AdministratorCourse

export type putAdministratorCourseErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorCourse (params: putAdministratorCourseParams): Promise<putAdministratorCourseOk> {
  let url = "/administrator/courses/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "name": params.body["name"],
      "nameEn": params.body["nameEn"],
      "code": params.body["code"],
      "status": params.body["status"],
      "degree": params.body["degree"],
      "typeId": params.body["typeId"],
      "credits": params.body["credits"],
      "chooseRegime": params.body["chooseRegime"],
      "userSem": params.body["userSem"],
      "general": params.body["general"],
      "studySem": params.body["studySem"],
      "groupName": params.body["groupName"],
      "examCreditLimit": params.body["examCreditLimit"],
      "scoreThresholdMin": params.body["scoreThresholdMin"],
      "scoreThresholdMax": params.body["scoreThresholdMax"],
      "failsForExpel": params.body["failsForExpel"],
      "facId": params.body["facId"],
      "primaryLecturerId": params.body["primaryLecturerId"],
      "facs": params.body["facs"],
      "genCodes": params.body["genCodes"],
      "baseCodes": params.body["baseCodes"],
      "otherCodes": params.body["otherCodes"],
      "locale": params.body["locale"],
      "showInFreeCredits": params.body["showInFreeCredits"],
      "facsProgramIds": params.body["facsProgramIds"],
      "semId": params.body["semId"],
      "type": params.body["type"],
      "syllabus": params.body["syllabus"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourse>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 2XX AdministratorCourse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorCourse"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/courses/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsProgramsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "q"?: string
    readonly "degree"?: number
    readonly "status"?: number
  }
}

export type getAdministratorListsProgramsOk = AdministratorProgramsListResponse

export type getAdministratorListsProgramsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsPrograms (params: getAdministratorListsProgramsParams): Promise<getAdministratorListsProgramsOk> {
  const url = "/administrator/lists/programs"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorProgramsListResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorProgramsListResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorProgramsListResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/programs 2XX AdministratorProgramsListResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/programs 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/programs 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/programs 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/programs 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsPrograms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/programs XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsLecturersParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "q"?: string
  }
}

export type getAdministratorListsLecturersOk = AdministratorListsLecturer

export type getAdministratorListsLecturersErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsLecturers (params: getAdministratorListsLecturersParams): Promise<getAdministratorListsLecturersOk> {
  const url = "/administrator/lists/lecturers"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsLecturer
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsLecturerDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsLecturer>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers 2XX AdministratorListsLecturer\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsLecturers"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsLecturersPersnumsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "q"?: string
  }
}

export type getAdministratorListsLecturersPersnumsOk = AdministratorListsLecturer

export type getAdministratorListsLecturersPersnumsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsLecturersPersnums (params: getAdministratorListsLecturersPersnumsParams): Promise<getAdministratorListsLecturersPersnumsOk> {
  const url = "/administrator/lists/lecturers-persnums"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsLecturer
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsLecturerDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsLecturer>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers-persnums 2XX AdministratorListsLecturer\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers-persnums 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers-persnums 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers-persnums 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers-persnums 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsLecturersPersnums"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecturers-persnums XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsCourseDefaultsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsCourseDefaultsOk = AdministratorCourseDefaultsResponse

export type getAdministratorListsCourseDefaultsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsCourseDefaults (params: getAdministratorListsCourseDefaultsParams): Promise<getAdministratorListsCourseDefaultsOk> {
  const url = "/administrator/lists/course-defaults"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCourseDefaultsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCourseDefaultsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCourseDefaultsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-defaults 2XX AdministratorCourseDefaultsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-defaults 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-defaults 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-defaults 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-defaults 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsCourseDefaults"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/course-defaults XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsDegreesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsDegreesOk = readonly AdministratorListsType[]

export type getAdministratorListsDegreesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsDegrees (params: getAdministratorListsDegreesParams): Promise<getAdministratorListsDegreesOk> {
  const url = "/administrator/lists/degrees"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorListsType[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorListsTypeDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorListsType[]>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/degrees 2XX readonly AdministratorListsType[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/degrees 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/degrees 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/degrees 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/degrees 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsDegrees"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/degrees XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsGroupDurationsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
    readonly "degree": number
  }
}

export type getAdministratorListsGroupDurationsOk = AdministratorListsGroupDurations

export type getAdministratorListsGroupDurationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsGroupDurations (params: getAdministratorListsGroupDurationsParams): Promise<getAdministratorListsGroupDurationsOk> {
  const url = "/administrator/lists/group-durations"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsGroupDurations
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsGroupDurationsDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsGroupDurations>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-durations 2XX AdministratorListsGroupDurations\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-durations 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-durations 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-durations 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-durations 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsGroupDurations"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-durations XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsCreditTypesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsCreditTypesOk = AdministratorCreditTypesListResponse

export type getAdministratorListsCreditTypesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsCreditTypes (params: getAdministratorListsCreditTypesParams): Promise<getAdministratorListsCreditTypesOk> {
  const url = "/administrator/lists/credit-types"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorCreditTypesListResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorCreditTypesListResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorCreditTypesListResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/credit-types 2XX AdministratorCreditTypesListResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/credit-types 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/credit-types 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/credit-types 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/credit-types 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsCreditTypes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/credit-types XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsScoreOptionsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsScoreOptionsOk = AdministratorListsScoreOptionsResponse

export type getAdministratorListsScoreOptionsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsScoreOptions (params: getAdministratorListsScoreOptionsParams): Promise<getAdministratorListsScoreOptionsOk> {
  const url = "/administrator/lists/score-options"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsScoreOptionsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsScoreOptionsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsScoreOptionsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-options 2XX AdministratorListsScoreOptionsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-options 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-options 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-options 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-options 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsScoreOptions"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-options XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsHoursParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsHoursOk = AdministratorListsHoursResponse

export type getAdministratorListsHoursErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsHours (params: getAdministratorListsHoursParams): Promise<getAdministratorListsHoursOk> {
  const url = "/administrator/lists/hours"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsHoursResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsHoursResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsHoursResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/hours 2XX AdministratorListsHoursResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/hours 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/hours 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/hours 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/hours 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsHours"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/hours XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsWeeksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsWeeksOk = AdministratorListsHoursResponse

export type getAdministratorListsWeeksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsWeeks (params: getAdministratorListsWeeksParams): Promise<getAdministratorListsWeeksOk> {
  const url = "/administrator/lists/weeks"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsHoursResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsHoursResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsHoursResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/weeks 2XX AdministratorListsHoursResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/weeks 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/weeks 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/weeks 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/weeks 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsWeeks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/weeks XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsLectureTypesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsLectureTypesOk = AdministratorListsLectureTypesResponse

export type getAdministratorListsLectureTypesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsLectureTypes (params: getAdministratorListsLectureTypesParams): Promise<getAdministratorListsLectureTypesOk> {
  const url = "/administrator/lists/lecture-types"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsLectureTypesResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsLectureTypesResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsLectureTypesResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-types 2XX AdministratorListsLectureTypesResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-types 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-types 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-types 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-types 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsLectureTypes"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-types XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsFacultiesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsFacultiesOk = AdministratorListsFacultiesResponse

export type getAdministratorListsFacultiesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsFaculties (params: getAdministratorListsFacultiesParams): Promise<getAdministratorListsFacultiesOk> {
  const url = "/administrator/lists/faculties"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsFacultiesResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsFacultiesResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsFacultiesResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/faculties 2XX AdministratorListsFacultiesResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/faculties 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/faculties 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/faculties 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/faculties 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsFaculties"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/faculties XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsSchoolsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "facultyId"?: number
  }
}

export type getAdministratorListsSchoolsOk = readonly AdministratorListsOption[]

export type getAdministratorListsSchoolsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsSchools (params: getAdministratorListsSchoolsParams): Promise<getAdministratorListsSchoolsOk> {
  const url = "/administrator/lists/schools"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorListsOption[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorListsOptionDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorListsOption[]>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schools 2XX readonly AdministratorListsOption[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schools 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schools 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schools 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schools 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsSchools"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schools XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsStudentStatusesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsStudentStatusesOk = readonly AdministratorListsOption[]

export type getAdministratorListsStudentStatusesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsStudentStatuses (params: getAdministratorListsStudentStatusesParams): Promise<getAdministratorListsStudentStatusesOk> {
  const url = "/administrator/lists/student-statuses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorListsOption[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorListsOptionDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorListsOption[]>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/student-statuses 2XX readonly AdministratorListsOption[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/student-statuses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/student-statuses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/student-statuses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/student-statuses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsStudentStatuses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/student-statuses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsGroupNamesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "q"?: string
  }
}

export type getAdministratorListsGroupNamesOk = AdministratorListsGroupNamesResponse

export type getAdministratorListsGroupNamesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsGroupNames (params: getAdministratorListsGroupNamesParams): Promise<getAdministratorListsGroupNamesOk> {
  const url = "/administrator/lists/group-names"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsGroupNamesResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsGroupNamesResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsGroupNamesResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-names 2XX AdministratorListsGroupNamesResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-names 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-names 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-names 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-names 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsGroupNames"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/group-names XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsBuildingsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsBuildingsOk = AdministratorListsBuildingsResponse

export type getAdministratorListsBuildingsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsBuildings (params: getAdministratorListsBuildingsParams): Promise<getAdministratorListsBuildingsOk> {
  const url = "/administrator/lists/buildings"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsBuildingsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsBuildingsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsBuildingsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/buildings 2XX AdministratorListsBuildingsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/buildings 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/buildings 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/buildings 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/buildings 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsBuildings"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/buildings XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsRoomsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "buildingId"?: number
  }
}

export type getAdministratorListsRoomsOk = AdministratorListsRoomsResponse

export type getAdministratorListsRoomsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsRooms (params: getAdministratorListsRoomsParams): Promise<getAdministratorListsRoomsOk> {
  const url = "/administrator/lists/rooms"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsRoomsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsRoomsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsRoomsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/rooms 2XX AdministratorListsRoomsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/rooms 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/rooms 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/rooms 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/rooms 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsRooms"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/rooms XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsLectureFormatsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsLectureFormatsOk = AdministratorListsLectureFormatsResponse

export type getAdministratorListsLectureFormatsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsLectureFormats (params: getAdministratorListsLectureFormatsParams): Promise<getAdministratorListsLectureFormatsOk> {
  const url = "/administrator/lists/lecture-formats"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsLectureFormatsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsLectureFormatsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsLectureFormatsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-formats 2XX AdministratorListsLectureFormatsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-formats 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-formats 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-formats 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-formats 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsLectureFormats"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/lecture-formats XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsScheduleLocationsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsScheduleLocationsOk = AdministratorListsScheduleLocationsResponse

export type getAdministratorListsScheduleLocationsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsScheduleLocations (params: getAdministratorListsScheduleLocationsParams): Promise<getAdministratorListsScheduleLocationsOk> {
  const url = "/administrator/lists/schedule-locations"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsScheduleLocationsResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsScheduleLocationsResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsScheduleLocationsResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schedule-locations 2XX AdministratorListsScheduleLocationsResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schedule-locations 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schedule-locations 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schedule-locations 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schedule-locations 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsScheduleLocations"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/schedule-locations XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsLearningWeeksParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
    readonly "couId": number
    readonly "groupId": number
    readonly "hourId"?: null | number
    readonly "excludeId"?: number
  }
}

export type getAdministratorListsLearningWeeksOk = readonly AdministratorListsLearningWeek[]

export type getAdministratorListsLearningWeeksErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsLearningWeeks (params: getAdministratorListsLearningWeeksParams): Promise<getAdministratorListsLearningWeeksOk> {
  const url = "/administrator/lists/learning-weeks"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorListsLearningWeek[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorListsLearningWeekDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorListsLearningWeek[]>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks 2XX readonly AdministratorListsLearningWeek[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsLearningWeeks"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsScoreCriteriasParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsScoreCriteriasOk = AdministratorListsScoreCriteriasResponse

export type getAdministratorListsScoreCriteriasErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsScoreCriterias (params: getAdministratorListsScoreCriteriasParams): Promise<getAdministratorListsScoreCriteriasOk> {
  const url = "/administrator/lists/score-criterias"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsScoreCriteriasResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsScoreCriteriasResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsScoreCriteriasResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-criterias 2XX AdministratorListsScoreCriteriasResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-criterias 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-criterias 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-criterias 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-criterias 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsScoreCriterias"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/score-criterias XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsStatementTemplatesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsStatementTemplatesOk = readonly AdministratorListsStatementTemplate[]

export type getAdministratorListsStatementTemplatesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsStatementTemplates (params: getAdministratorListsStatementTemplatesParams): Promise<getAdministratorListsStatementTemplatesOk> {
  const url = "/administrator/lists/statement-templates"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorListsStatementTemplate[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorListsStatementTemplateDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorListsStatementTemplate[]>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-templates 2XX readonly AdministratorListsStatementTemplate[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-templates 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-templates 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-templates 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-templates 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsStatementTemplates"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-templates XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsStatementStatusesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorListsStatementStatusesOk = readonly AdministratorListsType[]

export type getAdministratorListsStatementStatusesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsStatementStatuses (params: getAdministratorListsStatementStatusesParams): Promise<getAdministratorListsStatementStatusesOk> {
  const url = "/administrator/lists/statement-statuses"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorListsType[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorListsTypeDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorListsType[]>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-statuses 2XX readonly AdministratorListsType[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-statuses 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-statuses 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-statuses 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-statuses 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsStatementStatuses"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/statement-statuses XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatementsParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query"?: {
    readonly "semId"?: number
    readonly "search"?: string
    readonly "searchInBody"?: number
    readonly "templateId"?: number
    readonly "status"?: number
    readonly "facId"?: number
    readonly "degree"?: number
    readonly "page"?: number
    readonly "perPage"?: number
  }
}

export interface getAdministratorStatementsOk {
  readonly "data": readonly AdministratorStatement[]
  readonly "meta": {
    readonly "pagination": Pagination
  }
}

export type getAdministratorStatementsErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatements (params: getAdministratorStatementsParams): Promise<getAdministratorStatementsOk> {
  const url = "/administrator/statements"
  const query = params.query ? queryToString(params.query) : ""
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": readonly AdministratorStatement[]
  //   readonly "meta": {
  //     readonly "pagination": Pagination
  //   }
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": ArrayObjectDecoder(AdministratorStatementDecoder),
      "meta": decoders.object({
        "pagination": PaginationDecoder,
      }),
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": readonly AdministratorStatement[]
        readonly "meta": {
          readonly "pagination": Pagination
        }
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/statements 2XX {\n' +
        '  readonly "data": readonly AdministratorStatement[]\n' +
        '  readonly "meta": {\n' +
        '    readonly "pagination": Pagination\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statements 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statements 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statements 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statements 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatements"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statements XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatementParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "semId": string
  }
}

export type getAdministratorStatementOk = AdministratorStatement

export type getAdministratorStatementErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatement (params: getAdministratorStatementParams): Promise<getAdministratorStatementOk> {
  let url = "/administrator/statements/"
  url += params.args["id"]
  url += "/"
  url += params.args["semId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStatement
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStatementDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStatement>(result.value)
    } else {
      console.error(
        'GET /administrator/statements/ 2XX AdministratorStatement\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statements/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statements/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statements/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statements/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatement"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statements/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorStatementParams {
  readonly "body": {
    readonly "status": number
    readonly "comment": string
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
    readonly "semId": string
  }
}

export type putAdministratorStatementOk = AdministratorStatement

export type putAdministratorStatementErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorStatement (params: putAdministratorStatementParams): Promise<putAdministratorStatementOk> {
  let url = "/administrator/statements/"
  url += params.args["id"]
  url += "/"
  url += params.args["semId"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "status": params.body["status"],
      "comment": params.body["comment"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStatement
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStatementDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStatement>(result.value)
    } else {
      console.error(
        'PUT /administrator/statements/ 2XX AdministratorStatement\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/statements/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/statements/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/statements/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/statements/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorStatement"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/statements/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatementTemplatesParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
}

export type getAdministratorStatementTemplatesOk = readonly AdministratorStatementTemplate[]

export type getAdministratorStatementTemplatesErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatementTemplates (params: getAdministratorStatementTemplatesParams): Promise<getAdministratorStatementTemplatesOk> {
  const url = "/administrator/statement-templates"
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX readonly AdministratorStatementTemplate[]
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(ArrayObjectDecoder(AdministratorStatementTemplateDecoder)).decode(data)
    if (result.ok) {
      return identity<readonly AdministratorStatementTemplate[]>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates 2XX readonly AdministratorStatementTemplate[]\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatementTemplates"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorStatementTemplateParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type getAdministratorStatementTemplateOk = AdministratorStatementTemplate

export type getAdministratorStatementTemplateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorStatementTemplate (params: getAdministratorStatementTemplateParams): Promise<getAdministratorStatementTemplateOk> {
  let url = "/administrator/statement-templates/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStatementTemplate
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStatementTemplateDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStatementTemplate>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates/ 2XX AdministratorStatementTemplate\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorStatementTemplate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/statement-templates/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface putAdministratorStatementTemplateParams {
  readonly "body": {
    readonly "title": string
    readonly "titleEn": string
    readonly "status": number
  }
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "args": {
    readonly "id": string
  }
}

export type putAdministratorStatementTemplateOk = AdministratorStatementTemplate

export type putAdministratorStatementTemplateErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function putAdministratorStatementTemplate (params: putAdministratorStatementTemplateParams): Promise<putAdministratorStatementTemplateOk> {
  let url = "/administrator/statement-templates/"
  url += params.args["id"]
  url += ""
  const response = await fetch(baseURL + url, {
    method: "PUT",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      "title": params.body["title"],
      "titleEn": params.body["titleEn"],
      "status": params.body["status"],
    }),
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorStatementTemplate
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorStatementTemplateDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorStatementTemplate>(result.value)
    } else {
      console.error(
        'PUT /administrator/statement-templates/ 2XX AdministratorStatementTemplate\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'PUT /administrator/statement-templates/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'PUT /administrator/statement-templates/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'PUT /administrator/statement-templates/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'PUT /administrator/statement-templates/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("putAdministratorStatementTemplate"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'PUT /administrator/statement-templates/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorSchedulesGridParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "buildingId": number
    readonly "degree": number
    readonly "startWeek": number
    readonly "endWeek": number
    readonly "semId"?: number
    readonly "hourId"?: number
  }
}

export type getAdministratorSchedulesGridOk = AdministratorSchedulesGridResponse

export type getAdministratorSchedulesGridErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorSchedulesGrid (params: getAdministratorSchedulesGridParams): Promise<getAdministratorSchedulesGridOk> {
  const url = "/administrator/schedules/grid"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorSchedulesGridResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorSchedulesGridResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorSchedulesGridResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/grid 2XX AdministratorSchedulesGridResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/grid 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/grid 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/grid 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/grid 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorSchedulesGrid"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/grid XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorSchedulesShowParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "semId": number
  }
  readonly "args": {
    readonly "id": number
  }
}

export interface getAdministratorSchedulesShowOk {
  readonly "data": string
}

export type getAdministratorSchedulesShowErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorSchedulesShow (params: getAdministratorSchedulesShowParams): Promise<getAdministratorSchedulesShowOk> {
  let url = "/administrator/schedules/"
  url += params.args["id"]
  url += ""
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX {
  //   readonly "data": string
  // }
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(decoders.object({
      "data": decoders.string,
    })).decode(data)
    if (result.ok) {
      return identity<{
        readonly "data": string
      }>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/ 2XX {\n' +
        '  readonly "data": string\n' +
        '}\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/ 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/ 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/ 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/ 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorSchedulesShow"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/schedules/ XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}

export interface getAdministratorListsLearningWeeksScheduleParams {
  readonly "headers": {
    readonly "Authorization": string
    readonly "Profile-ID": string
    readonly "Accept-Language": LanguageString
  }
  readonly "query": {
    readonly "degree": number
    readonly "semId"?: number
  }
}

export type getAdministratorListsLearningWeeksScheduleOk = AdministratorListsLearningWeeksScheduleResponse

export type getAdministratorListsLearningWeeksScheduleErr = base.AuthError | base.ForbiddenError | base.ErrorsObject | base.MaintenanceMode | base.ErrorMessage

export async function getAdministratorListsLearningWeeksSchedule (params: getAdministratorListsLearningWeeksScheduleParams): Promise<getAdministratorListsLearningWeeksScheduleOk> {
  const url = "/administrator/lists/learning-weeks-schedule"
  const query = queryToString(params.query)
  const response = await fetch(baseURL + url + query, {
    method: "GET",
    headers: {
      "Authorization": params.headers["Authorization"],
      "Profile-ID": params.headers["Profile-ID"],
      "Accept-Language": params.headers["Accept-Language"],
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  let data: unknown = null
  try {
    data = await response.json()
  } catch (err) {}

  // 2XX AdministratorListsLearningWeeksScheduleResponse
  if (response.status >= 200 && response.status <= 299) {
    const result = DataDecoder(AdministratorListsLearningWeeksScheduleResponseDecoder).decode(data)
    if (result.ok) {
      return identity<AdministratorListsLearningWeeksScheduleResponse>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks-schedule 2XX AdministratorListsLearningWeeksScheduleResponse\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 401 base.AuthError
  if (response.status === 401) {
    const result = DataDecoder(base.AuthErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.AuthError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks-schedule 401 base.AuthError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 403 base.ForbiddenError
  if (response.status === 403) {
    const result = DataDecoder(base.ForbiddenErrorDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ForbiddenError>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks-schedule 403 base.ForbiddenError\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 422 base.ErrorsObject
  if (response.status === 422) {
    const result = DataDecoder(base.ErrorsObjectDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorsObject>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks-schedule 422 base.ErrorsObject\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // 503 base.MaintenanceMode
  if (response.status === 503) {
    const result = DataDecoder(base.MaintenanceModeDecoder).decode(data)
    if (result.ok) {
      throw identity<base.MaintenanceMode>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks-schedule 503 base.MaintenanceMode\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // XXX base.ErrorMessage
  Sentry.setExtra("data", JSON.stringify(data))
  Sentry.captureException(new Error("getAdministratorListsLearningWeeksSchedule"))
  {
    const result = DataDecoder(base.ErrorMessageDecoder).decode(data)
    if (result.ok) {
      throw identity<base.ErrorMessage>(result.value)
    } else {
      console.error(
        'GET /administrator/lists/learning-weeks-schedule XXX base.ErrorMessage\n' +
        '\n' +
        (result.error?.text ?? '')
      )
    }
  }

  // fallback ErrorMessage
  throw identity<ErrorMessage>({
    type: "ErrorMessage",
    message: "Could not process response!"
  })
}
